<template>
  <div ref="root" id="root" class="root-container"
       :style="{ 'background-color': bss.background_color, 'overflow-x': 'hidden'}">

    <link v-if="payment_settings.payment_gateway_id === 5" id="yappyStyle" rel="stylesheet" href="https://pagosbg.bgeneral.com/assets/css/styles.css" />
    <link v-if="!loading && bss.font_family" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + bss.font_family">
    <link v-if="!loading && bss.font_family_card" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + bss.font_family_card">
    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>
    <not-found-page v-show="notFound"></not-found-page>
    <div v-show="!notFound" class="row justify-content-end text-right mt-2 mr-2">
      <div class="col-auto">
        <language-switcher v-if="bss && Number(bss.show_language_switcher) === 1" :color="bss.text_color"/>
      </div>
    </div>
    <!--    <div class="row justify-content-end text-right mt-3">-->
    <!--      <div class="col-12">-->
    <!--        <base-button :style="{'font-family': bss.font_family, 'color': bss.text_color}" v-if="!is_authenticated" link type="success" v-on:click="login()"><i class="tim-icons icon-single-02"></i> Login</base-button>-->
    <!--        <base-button :style="{'font-family': bss.font_family, 'color': bss.text_color}" v-if="!is_authenticated" link type="success" v-on:click="register()"><i class="tim-icons icon-laptop"></i> Register</base-button>-->
    <!--        <base-button :style="{'font-family': bss.font_family, 'color': bss.text_color}" v-if="is_authenticated" link type="success" v-on:click="toProfile()" class="mr-3"><i class="tim-icons icon-single-02"></i> Account</base-button>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">

        <simple-wizard :text-color="bss.text_color" :backgroud-color="bss.button_color" ref="wiz"
                       @tab-change="onWizardTabChange"
                       :display-progress-bar="bss.display_progress_bar">
          <template slot="header">
            <div class="mt-5">
              <img v-if="bss.show_logo" :height="bss.logo_height" :width="bss.logo_width" :style="{'object-fit': bss.logo_fit}" :src="bss.logo" alt="logo">
              <h3 :style="{'font-family': bss.font_family, 'color': bss.text_color}" class="card-title mt-3">{{ bss.title }}</h3>
              <p :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{bss.subtext}}</p>
            </div>
          </template>

          <!-- Minimum booking notice countdown (OTC-1767) -->
          <template slot="under-progress">
            <transition name="fade">
              <div v-if="showBookingNoticeCountdown" class="booking-notice-banner" :style="bookingNoticeBannerStyle">
                <i class="tim-icons icon-time-alarm"></i>
                <span v-if="!bookingNoticeExpired">{{ $t('book.bookingNoticeWarning', { time: bookingNoticeCountdownText }) }}</span>
                <span v-else>{{ $t('book.bookingNoticeExpired') }}</span>
              </div>
            </transition>
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label" >
              <i class="tim-icons icon-components"></i>
              <p class="d-sm-block d-none" v-show="bss.display_section_titles" :style="{'font-family': bss.font_family, 'color': bss.text_color}">
                {{ $t('book.headers.selectExperience') }}
              </p>
            </template>
            <div class="row justify-content-center" v-show="!loading" v-if="show_calendar && (bss.layout_type_id === 1 || bss.layout_type_id === 2)">
              <div class="col-lg-8 col-10">
                <h2 :style="{'font-family': bss.font_family, 'color': bss.text_color}">
                  <base-button
                    :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'font-size': 'large', 'font-weight': 'bold'}"
                    v-on:click="show_calendar = false" link >
                    <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                  </base-button>
                  {{selectedGame.game_name}}
                </h2>
              </div>
            </div>
            <div class="row justify-content-center mb-4" v-show="!loading" v-if="!gift_card_link && games.length > 0 && !bss.hide_date_selection">
              <a :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }"
                 v-if="showPrevious(currentDay) && show_calendar && !isMobile" v-on:click="decrementWeek(currentDay)" class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i> {{ $t('book.buttons.previousWeek') }}
              </a>
              <a :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }"
                 v-if="showPrevious(currentDay) && show_calendar && !isMobile" v-on:click="decrementWeek(currentDay)" class="btn btn-link btn-primary d-block d-sm-none">
                <i class="tim-icons icon-minimal-left"></i>
              </a>
              <a :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }" v-if="showPrevious(currentDay) && (!show_calendar)" v-on:click="decrementDay(currentDay)" class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i>  {{ $t('book.buttons.previousDay') }}
              </a>
              <a :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }" v-if="showPrevious(currentDay) && (!show_calendar || (show_calendar && isMobile))" v-on:click="decrementDay(currentDay)" class="btn btn-link btn-primary d-block d-sm-none">
                <i class="tim-icons icon-minimal-left"></i>
              </a>
              <p :style="{'color': bss.text_color, 'opacity': 0.4, 'font-size': 'medium', 'margin-top': '25px' }" v-if="!showPrevious(currentDay) && (!show_calendar || (show_calendar && isMobile))" class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i> {{ $t('book.buttons.previousDay') }}
              </p>
              <p :style="{'color': bss.text_color, 'opacity': 0.4, 'font-size': 'medium', 'margin-top': '25px' }" v-if="!showPrevious(currentDay) && ((show_calendar && !isMobile))" class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i> {{ $t('book.buttons.previousWeek') }}
              </p>
              <p :style="{'color': bss.text_color, 'opacity': 0.4, 'font-size': 'medium', 'margin-top': '25px' }" v-if="!showPrevious(currentDay)" class="btn btn-link btn-primary d-block d-sm-none ">
                <i class="tim-icons icon-minimal-left"></i>
              </p>
              <div class="col-7 col-lg-2">
                <div class="row justify-content-center mb-2">
                  <div class="col text-center ">
                    <p :style="{'color': bss.text_color }" class="text-uppercase">{{ $t('book.buttons.chooseDate') }}</p>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col">
                    <el-date-picker :key="$i18n.locale" :editable="false"
                                    :clearable="false"
                                    class="custom-cursor date-field-themed"
                                    :style="{'--date-field-color': bss.text_color}"
                                    size="small"
                                    prefix-icon="' '"
                                    ref="datePickerRef"
                                    type="date"
                                    :placeholder="$t('book.placeholders.selectDate')"
                                    value-format="yyyy-MM-dd"
                                    :format="day_of_week + ' ' + locale.date_format "
                                    v-model="currentDay"
                                    @change="onDatePickerChange()"
                                    :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <a v-if="show_calendar && !isMobile"
                 :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }" v-on:click="incrementWeek(currentDay)" class="btn btn-link btn-primary d-none d-sm-block">
                {{ $t('book.buttons.nextWeek') }} <i class="tim-icons icon-minimal-right"></i>
              </a>
              <a v-if="show_calendar && !isMobile"
                 :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }" v-on:click="incrementWeek(currentDay)" class="btn btn-link btn-primary d-block d-sm-none">
                <i class="tim-icons icon-minimal-right"></i>
              </a>
              <a v-if="!show_calendar || isMobile" :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }" v-on:click="incrementDay(currentDay)" class="btn btn-link btn-primary d-none d-sm-block">
                {{ $t('book.buttons.nextDay') }} <i class="tim-icons icon-minimal-right"></i>
              </a>
              <a v-if="!show_calendar || isMobile"  :style="{'color': bss.text_color, 'font-size': 'medium', 'margin-top': '25px' }" v-on:click="incrementDay(currentDay)" class="btn btn-link btn-primary d-block d-sm-none">
                <i class="tim-icons icon-minimal-right"></i>
              </a>
            </div>
            <div v-if="!show_calendar && bss.layout_type_id === 1" v-show="!loading" class="row justify-content-center">
              <div v-if="!gift_card_link" style="display: inline-flex;" class="col-lg-4 col-md-6 col-sm-10 col-10" v-for="game in games" :key="game.id">
                <card class="event-card-elevated" :style="{ 'background-color': bss.card_color}">
                  <div slot="image" style="padding-bottom: 0; height: 250px; position: relative" class="game-info-flip" :class="{ 'is-flipped': isGameInfoOpen(game) }">
                    <div class="game-info-flip__inner">
                      <div class="game-info-flip__front">
                        <el-carousel :key="'GC-' + game.id + '-' + gameImagesFor(game.game_images).length + (isMobileViewport ? '-m' : '-d')"
                                     :arrow="getArrowSetting(gameImagesFor(game.game_images))" :autoplay="!!(bss.allow_autoscroll)" indicator-position="none" :interval="5000">
                          <el-carousel-item style="border-radius: 5px; width: 100%; height: 250px;"
                                            :style="{'background-color': item.background_color}" v-for="(item, index) in gameImagesFor(game.game_images)"
                                            :key="'CS' + index">
                            <div  style="border-radius: 5px; width: 100%; height: 250px; position: relative">
                              <img id="img"
                                   :style="{'transform': 'translate(0%, 0%) scale(' + item.scale*0.01 + ')', 'left': item.x + 'px', 'top': item.y + 'px', 'object-fit':  imageFitInBox(item), 'height': '100%'}"
                                   class="card-img"
                                   style="position: absolute; transform-origin: center center; will-change: transform"
                                   slot="image" v-twin-src="item.url"  alt="Card image cap"/>
                            </div>
                          </el-carousel-item>
                        </el-carousel>
                        <button v-if="showInfoTrigger(game)"
                                type="button"
                                class="game-info-trigger"
                                :class="{ 'game-info-trigger--text': (bss.game_info_trigger_type || 'icon') === 'text' }"
                                :style="(bss.game_info_trigger_type || 'icon') === 'icon'
                                  ? { color: bss.button_color, ...gameInfoTriggerPositionStyle }
                                  : { 'background-color': bss.button_color, color: bss.card_color, 'font-family': bss.font_family_card, ...gameInfoTriggerPositionStyle }"
                                :aria-label="$t('book.aboutEvent')"
                                @click="toggleGameInfo(game)">
                          <b-icon v-if="(bss.game_info_trigger_type || 'icon') === 'icon'" :icon="bss.game_info_trigger_icon || 'info-circle'" font-scale="1.3" />
                          <span v-else>{{ bss.game_info_trigger_text || 'Learn more' }}</span>
                        </button>
                      </div>
                      <div v-if="showInfoTrigger(game)"
                           class="game-info-flip__back game-info-panel"
                           :style="{ 'background-color': bss.card_color, color: bss.text_color_card, 'font-family': bss.font_family_card }">
                        <button type="button"
                                class="game-info-panel__close"
                                :style="{ color: bss.text_color_card }"
                                :aria-label="$t('book.close')"
                                @click="toggleGameInfo(game)">&times;</button>
                        <div class="game-info-panel__content" v-html="resolvedGameDescription(game)"></div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="bss.show_game_title">
                    <!-- Over the image the title is drawn inside the details block below, so it moves up with it. -->
                    <div class="col" v-if="bss.show_game_details_over_image" style="height: 10px"></div>
                    <div class="col" v-if="!bss.show_game_details_over_image">
                      <h2 :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{game.game_name}}</h2>
                    </div>
                  </div>
                  <div class="row mb-1" v-else>
                    <div class="col" v-if="bss.show_game_details_over_image" style="z-index: 100; pointer-events: none" :style="{'position': 'relative', 'height': '10px'}">
                      <h2 :style="{'position': 'absolute',
                      'bottom': '0', 'font-family': bss.font_family_card, 'color': bss.text_color_card}"> </h2>
                    </div>
                  </div>
                  <div v-if="bss.show_game_details_over_image" style="z-index: 100; pointer-events: none"  :style="{'position': 'relative', 'height': '10px', 'font-family': bss.font_family_card, 'color': bss.text_color_card,
                          'margin-top': '-120px', 'margin-bottom': '70px'}">
                    <div class="details-over-image">
                    <h2 v-if="bss.show_game_title" class="details-over-image__title"
                        :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{game.game_name}}</h2>
                    <div v-if="bss.show_number_of_players">
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card}"
                            class="mr-1">{{ $t('book.groupSize') }}: </span>
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">
                      {{game.min_players_count}}
                      <span v-show="game.max_players_count != null"> - </span> {{game.max_players_count}}</span>
                    </div>
                    <div v-if="bss.show_game_duration && game.duration_minutes">
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card}"
                            class="mr-1">{{ $t('book.duration') }}: </span>
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">
                      {{game.duration_minutes}}
                      <span>{{ $t('book.minutes') }}</span>
                      </span>
                    </div>
                    <event-ratings v-if="bss.show_game_difficulty" :ratings="game.ratings" />
                    </div>
                  </div>

                  <div class="mb-2" v-if="!bss.show_game_details_over_image" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'margin-top': '-20px' }">
                    <div v-if="bss.show_number_of_players">
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card}"
                            class="mr-1">{{ $t('book.groupSize') }}: </span>
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">
                      {{game.min_players_count}}
                      <span v-show="game.max_players_count != null"> - </span> {{game.max_players_count}}</span>
                    </div>
                    <div v-if="bss.show_game_duration && game.duration_minutes">
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card}"
                            class="mr-1">{{ $t('book.duration') }}: </span>
                      <span :style="{ 'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">
                      {{game.duration_minutes}}
                      <span>{{ $t('book.minutes') }}</span>
                      </span>
                    </div>
                    <event-ratings v-if="bss.show_game_difficulty" :ratings="game.ratings" />
                  </div>
                  <!--   No data panel -->
                  <div v-if="!game || !game.slots || getOrderedTimeSlots(game, game.slots).length === 0">
                    <div class="empty-bookings" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color }">
                        <span style="font-size: 2.1em">
                          <i class="tim-icons icon-calendar-60"></i>
                        </span>
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="mt-3">{{ $t('book.noBookings') }}</p>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div style="display: inline-flex; position: relative; margin-top: 12px;" class="col-6 col-sm-6 col-lg-4 col-md-6" v-for="(s, i) in getOrderedTimeSlots(game, game.slots)" :key="'S' + i" :ref="'el'+i">
                      <span v-if="shouldShowSlotBadge(s, game)" class="slot-custom-badge" :style="{ background: bss.button_color, color: bss.background_color || '#fff' }">{{ s.custom_message }}</span>
                      <base-button  style="z-index: 100; overflow-wrap: anywhere;" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color, 'width': '100%', 'padding-x': '5px', 'padding-left': '3px',  'padding-right': '3px' }"
                                    v-on:click="tabOne(1, game, s)"
                                    v-if="s.online_display_mode !== 'non_bookable' && (!s.block && !s.remove) && (s.status === 'available' || (s.online_display_mode === 'bookable' && s.status !== 'booked')) && !isPublicBooking(game, s) && !s.is_resource_saturated"
                                    simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <base-button  style="z-index: 100; overflow-wrap: anywhere;" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color, 'width': '100%', 'padding-x': '5px', 'padding-left': '3px',  'padding-right': '3px' }"
                                    v-on:click="tabOne(1, game, s)"
                                    v-if="s.online_display_mode !== 'non_bookable' && (!s.block && !s.remove) && (s.status === 'available' || (s.online_display_mode === 'bookable' && s.status !== 'booked')) && isPublicBooking(game, s) && !s.is_resource_saturated"
                                    simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span v-if="bss.show_available_ticket_count" style="font-size: 60%">{{getRemainingTickets(game, s)}}/{{game.max_players_count}} {{ $t('book.availableTickets') }} </span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <base-button style="z-index: 100; overflow-wrap: anywhere;" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color, 'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="tabOne(1, game, s)"
                                   v-if="s.online_display_mode === 'non_bookable' || s.is_resource_saturated ||
                                    ((s.status === 'booked' || s.status === 'requested') &&
                                     (s.is_reservation_upgraded || !isPublicBooking(game, s) || (isPublicBooking(game, s) && !hasRemainingSlots(game, s))))"
                                   disabled
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{bss.booked_text}}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <!-- Call to book button for booked public slots within time restriction -->
                      <base-button style="z-index: 100; overflow-wrap: anywhere" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color, 'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="s.has_external_link ? goToCallToBook(s) : null"
                                   v-if="(s.status === 'booked') && s.online_display_mode !== 'non_bookable' &&
                                    (!s.is_reservation_upgraded && !s.is_resource_saturated && isPublicBooking(game, s) && hasRemainingSlots(game, s) && shouldSlotBeCallToBook(s)) "
                                   disabled
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{ s.slot_text || bss.call_to_book_text }}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <!-- Available button for booked public slots outside time restriction -->
                      <base-button style="z-index: 100; overflow-wrap: anywhere;"
                                   :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color, 'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="tabOne(1, game, s)"
                                   v-if="(s.status === 'booked') && s.online_display_mode !== 'non_bookable' &&
                                    (!s.is_reservation_upgraded && !s.is_resource_saturated && isPublicBooking(game, s) && hasRemainingSlots(game, s) && !shouldSlotBeCallToBook(s)) "
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span v-if="bss.show_available_ticket_count" style="font-size: 60%">{{getRemainingTickets(game, s)}}/{{game.max_players_count}} {{ $t('book.availableTickets') }} </span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <base-button style="z-index: 100; overflow-wrap: anywhere" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color, 'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="tabOne(1, game, s)"
                                   v-if="(s.status === 'blocked' || (s.status === 'requestable' && (!allowRequestToBook || isPublicBooking(game, s)))) && s.online_display_mode !== 'non_bookable'"
                                   disabled
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{ bss.blocked_text }}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <!-- Request to book: enabled, standard bookable styling (rtb colors are calendar-view-only) -->
                      <base-button  style="z-index: 100; overflow-wrap: anywhere;" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color, 'width': '100%', 'padding-x': '5px', 'padding-left': '3px',  'padding-right': '3px' }"
                                    v-on:click="tabOne(1, game, s)"
                                    v-if="isRequestToBookSlot(game, s)"
                                    simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{ bss.request_to_book_text || $t('book.requestToBook') }}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <base-button style="z-index: 100; overflow-wrap: anywhere"
                                   :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color, 'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="tabOne(1, game, s)"
                                   v-if="((s.status === 'call_to_book' && !s.remove) || (s.block && !s.remove))
                                   && s.online_display_mode !== 'non_bookable'
                                   && !s.has_external_link && s.slot_text && !(s.status === 'booked' || s.status === 'blocked')
                                   && !s.is_resource_saturated
                                   && !rtbOverridesCtb(game, s)"
                                   disabled
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{ s.slot_text }}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <base-button style="z-index: 100; overflow-wrap: anywhere"
                                   :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color, 'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="tabOne(1, game, s)"
                                   v-if="(s.status === 'call_to_book' || s.block)
                                   && s.online_display_mode !== 'non_bookable'
                                   && !s.has_external_link && !s.slot_text && !(s.status === 'booked' || s.status === 'blocked')
                                   && !s.is_resource_saturated
                                   && !rtbOverridesCtb(game, s)"
                                   disabled
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{ bss.call_to_book_text }}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                      <base-button style="z-index: 100; overflow-wrap: anywhere" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,  'padding-top': '6px', 'padding-bottom': '6px',
                                  'color': bss.button_color, 'width': '100%',
                                  'padding-left': '3px',  'padding-right': '3px' }"
                                   v-on:click="goToCallToBook(s)"
                                   v-if="(s.status === 'call_to_book' || s.block) && s.online_display_mode !== 'non_bookable' && s.has_external_link && !(s.status === 'booked' || s.status === 'blocked') && !s.is_resource_saturated && !rtbOverridesCtb(game, s)"
                                   simple >
                        <span class="slot-content-stack">
                          <span>{{getDisplayTime(s, locale.time_format)}}</span>
                          <span>{{ s.slot_text }}</span>
                          <span v-if="shouldUseCustomText(s, game)" class="slot-custom-text">{{ s.custom_message }}</span>
                        </span>
                      </base-button>
                    </div>
                  </div>
                  <div class="row justify-content-center see-more-times-row" style="margin-bottom: -10px" v-if="bss.show_calendar_link">
                    <div class="col text-center">
                      <base-button :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" link v-on:click="showCalendar(game)">
                        {{ $t('book.buttons.seeMoreTimes') }} >
                      </base-button>
                    </div>
                  </div>
                </card>
              </div>

              <div v-if="is_gift_card" style="display: inline-flex;" class="col-lg-4 col-md-6 col-sm-10 col-10">
                <card class="event-card-elevated" :style="{ 'background-color': bss.card_color}">
                  <div slot="image" class="card-img-top" style="padding-bottom: 0; height: 250px" v-if="gift_card_settings_init.url">
                    <div :style="{'background-color': gift_card_settings_init.background_color}"
                         style="border-radius: 5px; width: 100%; height: 250px; position: relative">
                      <img
                        :style="{'transform': 'translate(0%, 0%) scale(' + gift_card_settings_init.scale*0.01 + ')',
                      'left': gift_card_settings_init.x + 'px', 'top': gift_card_settings_init.y + 'px',
                      'object-fit':  gift_card_settings_init.object_fit, 'height': '100%'}"
                        class="card-img"
                        style="position: absolute; transform-origin: center center; will-change: transform"
                        slot="image" :src="gift_card_settings_init.url"  alt="Card image cap"/>
                    </div>
                  </div>
                  <div v-else-if="payment_settings.url">
                    <img
                      class="card-img"
                      slot="image" :src="payment_settings.url"  alt="Card image cap"/>
                  </div>
                  <div v-else>
                    <img
                      class="card-img"
                      slot="image" src="https://console.offthecouch.io/img/pandas/pandaflip.jpg"  alt="Card image cap"/>
                  </div>

                  <div class="row">
                    <div class="col" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color }">
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{ gift_card_settings_init.title }}
                      </h4>
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ gift_card_settings_init.subtext }}</p>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col" :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color }">
                      <base-button :style="{ 'font-family': bss.font_family_card,
                                  'border-color': bss.button_color,
                                  'color': bss.button_color, 'width': '100%', 'padding-left': '3px',  'padding-right': '3px' }"
                                   simple v-on:click="giftCardSelect()">
                        {{ gift_card_settings_init.button_text }}
                      </base-button>
                    </div>
                  </div>
                </card>

              </div>
            </div>

            <div class="row justify-content-center" v-if="show_calendar && (bss.layout_type_id === 1 || bss.layout_type_id === 2)">
              <!-- color: hour-axis labels inherit it, so they follow the site's text color
                   instead of the dark theme's white (invisible on light backgrounds).
                   Border var: neutral gray so gridlines show on any background color.
                   The extra vars feed the chip/day-header styles in _plugin-fullcalendar.scss,
                   scoped under .booking-week-cal so the check-in calendar is unaffected. -->
              <!-- --fc-page-bg-color: FullCalendar paints the sticky day-header band with it
                   (defaults to white); it must follow the site's background color. -->
              <div class="col-lg-8 col-10 booking-week-cal"
                   :style="{ 'color': bss.text_color, '--fc-border-color': 'rgba(125, 125, 125, 0.4)',
                             '--fc-page-bg-color': bss.background_color,
                             '--otc-cal-button': bss.button_color, '--otc-cal-bg': bss.background_color }">
                <fullCalendar ref="calendar" :options="calendarOptions" :hooks="calendarHooks"/>
                <!-- Slot fetch can take a few seconds; without this the empty grid renders
                     and reads as "no times this week" while the request is in flight.
                     Same svg spinner as LoadingPanel (classes are global), scoped to the
                     calendar area instead of the full screen. -->
                <div v-if="calendar_loading" class="cal-loading-overlay"
                     :style="{ 'background-color': bss.background_color }">
                  <svg class="custom-spinner" viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- List board layout -->
            <div v-if="!show_calendar && bss.layout_type_id === 2" class="row">
              <div class="col-12">
                <event-selection-list
                  :games="games"
                  :bss="bss"
                  :locale="locale"
                  :loading="loading"
                  :is-gift-card="is_gift_card"
                  :gift-card-link="gift_card_link"
                  :gift-card-settings="gift_card_settings_init"
                  :gift-card-image="gift_card_settings_init ? gift_card_settings_init.url : null"
                  @slot-selected="onListSlotSelected"
                  @gift-card-select="giftCardSelect()"
                  @show-calendar="showCalendar"
                />
              </div>
            </div>

            <!-- Calendar view layout -->
            <div v-if="!show_calendar && bss.layout_type_id === 3" class="row">
              <div class="col-12">
                <event-selection-calendar
                  :games="games"
                  :bss="bss"
                  :locale="locale"
                  :loading="loading"
                  :is-gift-card="is_gift_card"
                  :gift-card-link="gift_card_link"
                  :gift-card-settings="gift_card_settings_init"
                  :gift-card-image="gift_card_settings_init ? gift_card_settings_init.url : null"
                  @slot-selected="onListSlotSelected"
                  @gift-card-select="giftCardSelect()"
                />
              </div>
            </div>
          </wizard-tab>
          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              <!--              <span :style="{'color': bss.text_color_card, 'font-weight': 'bold', 'font-size': 'large'}">2</span>-->
              <i class="tim-icons icon-calendar-60"></i>
              <p class="d-sm-block d-none" v-show="bss.display_section_titles" :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{ $t('book.bookingDetails') }}</p>
            </template>
            <div class="row justify-content-center" v-show="!loading" v-if="gift_card_select && !show_addons">
              <div class="col-11 col-lg-6">
                <card :style="{ 'background-color': bss.card_color}">
                  <div class="row justify-content-center">
                    <div class="col-lg-8 text-center">
                      <el-carousel v-on:change="setGiftCardDesign" :autoplay="false" indicator-position="outside">
                        <el-carousel-item  style="border-radius: 15px;" :style="{'background-color': item.background_color}"
                                           v-for="(item, index) in gift_card_designs" :key="'CS' + index">
                          <img :style="{'transform': 'translate(0%, 0%) scale(' + item.scale*0.01 + ')',
                            'left': item.x + 'px', 'top': item.y + 'px', 'object-fit':  item.object_fit, 'height': '100%'}"
                               style="cursor: all-scroll; border-radius: 15px;" :src="item.url" alt="Gift Card">
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                  <div class="row justify-content-between">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title text-uppercase">{{ $tc('book.giftCard', 1) }}</p>
                    </div>
                  </div>
                  <div class="row " :key="gc_key">
                    <div class="col-lg-6">
                      <!--                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.value') }}</label>-->
                      <base-input :secondary-color="bss.text_color_card">
                        <base-dropdown :style="{'font-family': bss.font_family_card }"
                                       title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="bss.font_family_card"
                                       :title="selectedGiftCardType.name"
                        >
                          <a v-for="(d, i) in gift_card_types"  :style="{'font-family': bss.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#" :key="'D' + i" v-on:click.prevent="selectGiftCardType(d, $event)">
                            {{ d.name }}</a>
                        </base-dropdown>
                      </base-input>
                    </div>
                  </div>

                  <div class="row" v-if="selectedGiftCardType.value_type === 0" :key="gc_key + 'T'">
                    <div class="col-lg-6">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.customValue') }}
                        {{getCurrencySymbol(locale.currency)}}{{getAmount(selectedGiftCardType.min_purchase_value)}} {{getCurrencyCode(locale.currency)}} -
                        {{getCurrencySymbol(locale.currency)}}{{getAmount(selectedGiftCardType.max_purchase_value)}} {{getCurrencyCode(locale.currency)}}
                      </label>
                      <base-input :secondary-color="bss.text_color_card" v-on:change="getGiftCardTotal('value_type')" v-model="gift_card.custom_amount"
                                  :error="errors.gift_card.custom_amount" :input-style="{'color': bss.text_color_card}"
                                  :placeholder="$t('book.value')">
                      </base-input>
                    </div>
                  </div>

                  <div class="row"  >
                    <div class="col-lg-6 mt-2" v-if="selectedGiftCardType.value_type === 2 && selectedGiftCardType.game_display_mode !== 1">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.game') }}</label>
                      <base-input :secondary-color="bss.text_color_card">
                        <base-dropdown :style="{'font-family': bss.font_family_card }"
                                       title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="bss.font_family_card"
                                       :title="selectedGame.game_name"
                        >
                          <a v-for="(g, i) in gift_card_games"  :style="{'font-family': bss.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#" :key="'D' + i" v-on:click.prevent="getGiftCardTotal('game', g, $event)">
                            {{ g.game_name }}</a>
                        </base-dropdown>
                      </base-input>
                    </div>
                    <div class="col-lg-4" v-if="selectedGiftCardType.value_type === 2" :key="gc_key">
                      <div v-for="(c, i) in pricing_categories" :key="'C' + i">
                        <label class="mt-2 text-uppercase d-block" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{c.category}}</label>
                        <div class="el-input-number" >
                          <span role="button" class="el-input-number__decrease" v-on:click="decrementCounter(c, 'gc')"
                                :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}">
                            <i class="el-icon-minus"></i>
                          </span>
                          <span role="button" v-on:click="incrementCounter(c, 'gc')"
                                :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}"
                                class="el-input-number__increase">
                            <i class="el-icon-plus"></i>
                          </span>
                          <div class="el-input">
                            <input disabled :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color,  'background-color': 'inherit'}"
                                   v-model="c.number_of_players"
                                   type="text" autocomplete="off" max="4" min="0" class="el-input__inner" role="spinbutton" aria-disabled="false">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <label class="d-block d-sm-none mt-2" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.quantity') }}</label>
                  <div class="row">
                    <div class="col-lg-4 col-12" v-if="selectedGiftCardType.allow_bulk_purchase">
                      <label class="d-none d-sm-block" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.quantity') }}</label>
                      <div class="el-input-number" >
                          <span role="button" class="el-input-number__decrease" v-on:click="decrementCounterGCQuantity()"
                                :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}">
                            <i class="el-icon-minus"></i>
                          </span>
                        <span role="button" v-on:click="incrementCounterGCQuantity()"
                              :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}"
                              class="el-input-number__increase">
                            <i class="el-icon-plus"></i>
                          </span>
                        <div class="el-input">
                          <input disabled :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color,  'background-color': 'inherit'}"
                                 v-model="gift_card.quantity"
                                 type="text" autocomplete="off" max="4" min="0" class="el-input__inner" role="spinbutton" aria-disabled="false">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col">
                      <div class="mt-2 d-block d-sm-none"></div>
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.giftCardValue') }}</label>
                      <base-input :secondary-color="bss.text_color_card">
                        <h1 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{getCurrencySymbol(locale.currency)}}{{getAmount(gift_card.unit_value)}}{{getCurrencyCode(locale.currency)}}
                        </h1>
                      </base-input>
                    </div>
                    <div class="col" v-if="selectedGiftCardType.value_type === 1">
                      <div class="mt-2 d-block d-sm-none"></div>
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.price') }}</label>
                      <base-input :secondary-color="bss.text_color_card">
                        <h1 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{getCurrencySymbol(locale.currency)}}{{getAmount(gift_card.unit_price)}}{{getCurrencyCode(locale.currency)}}
                        </h1>
                      </base-input>
                    </div>
                    <div class="col">
                      <div class="mt-2 d-block d-sm-none"></div>
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.totalCost') }}</label>
                      <base-input :secondary-color="bss.text_color_card">
                        <h1 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{getCurrencySymbol(locale.currency)}}{{getAmount(gift_card.total)}}{{getCurrencyCode(locale.currency)}}
                        </h1>
                      </base-input>
                    </div>
                  </div>


                  <div class="row justify-content-between">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title text-uppercase">
                        {{ $t('book.deliveryDetails') }}
                      </p>
                    </div>
                  </div>

                  <div class="row mb-3" v-if="selectedGiftCardType.allow_customer_set_delivery_date">
                    <div class="col">
                      <div
                        class="btn-group btn-group-toggle"
                        :class="'float-left'"
                        data-toggle="buttons"
                      >
                        <label
                          class="btn btn-sm btn-primary btn-simple"
                          :style="buttonGroupStyle[0]"
                        >
                          <input
                            type="radio"
                            @click="selectGiftCardDeliveryMethod(1)"
                            name="options"
                            autocomplete="off"
                            :checked="gift_card.send_instantly"
                          />
                          <span style="font-size: medium; font-weight: lighter">{{ $t('book.sendInstantly') }}</span>
                        </label>
                        <label
                          class="btn btn-sm btn-primary btn-simple"
                          :style="buttonGroupStyle[1]" >
                          <input
                            type="radio"
                            @click="selectGiftCardDeliveryMethod(0)"
                            name="options"
                            autocomplete="off"
                            :checked="!gift_card.send_instantly"
                          />
                          <span style="font-size: medium; font-weight: lighter">{{ $t('book.sendInFuture') }}</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!selectedGiftCardType.allow_customer_set_delivery_date">
                    <div class="col" v-if="selectedGiftCardType.delivery_type === 0">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{ $t('book.deliveryTypeImmediate') }}
                      </p>
                    </div>
                  </div>

                  <div class="row" v-if="!selectedGiftCardType.allow_customer_set_delivery_date">
                    <div class="col" v-if="selectedGiftCardType.delivery_type === 1">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{selectedGiftCardType.delivery_value}}
                        <span v-if="selectedGiftCardType.delivery_period === 2">{{ $tc('book.day', selectedGiftCardType.delivery_value) }}</span>
                        <span v-if="selectedGiftCardType.delivery_period === 3">{{ $tc('book.week', selectedGiftCardType.delivery_value) }}</span>
                        <span v-if="selectedGiftCardType.delivery_period === 4">{{ $tc('book.month', selectedGiftCardType.delivery_value) }}</span>
                        <span v-if="selectedGiftCardType.delivery_period === 5">{{ $tc('book.year', selectedGiftCardType.delivery_value) }}</span>
                        {{ $t('book.deliveryTypeAfterPurchase') }}
                      </p>
                    </div>
                  </div>

                  <div class="row" v-if="!selectedGiftCardType.allow_customer_set_delivery_date">
                    <div class="col" v-if="selectedGiftCardType.delivery_type === 2">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{ $t('book.deliveryTypeDate') }} {{getFormattedDate(locale.date_format, selectedGiftCardType.delivery_date)}}
                      </p>
                    </div>
                  </div>

                  <div class="row mt-2 justify-content-between" v-if="!gift_card.send_instantly">
                    <div class="col-lg-6">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.deliveryDate') }}</label>

                      <base-input :secondary-color="bss.text_color_card">
                        <el-date-picker :key="$i18n.locale" :editable="false"
                                        class="custom-cursor date-field-themed"
                                        :style="{'--date-field-color': bss.text_color_card}"
                                        prefix-icon="' '"
                                        type="date"
                                        placeholder="Select date"
                                        value-format="yyyy-MM-dd"
                                        :format="day_of_week + ' ' + locale.date_format "
                                        v-model="gift_card.delivery_date"
                                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </base-input>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col">
                      <base-checkbox :border-color="bss.button_color" :check-mark-color="bss.card_color" :accent-color="bss.button_color" v-model="gift_card.send_to_self">
                        <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.sendToSelf') }}</p></base-checkbox>
                    </div>
                  </div>
                  <div class="row justify-content-center" v-if="!gift_card.send_to_self">
                    <div class="col-12 col-lg-6">
                      <base-input :secondary-color="bss.text_color_card" :error="errors.gift_card.first_name"
                                  :input-style="{'color': bss.text_color_card}"
                                  v-model="gift_card.recipient_first_name" :placeholder="$t('book.placeholders.recipientFirstName')"></base-input>
                    </div>
                    <div class="col-12 col-lg-6" >
                      <base-input :secondary-color="bss.text_color_card" :error="errors.gift_card.last_name" :input-style="{'color': bss.text_color_card}" v-model="gift_card.recipient_last_name"
                                  :placeholder="$t('book.placeholders.recipientLastName')"></base-input>
                    </div>
                  </div>
                  <div class="row justify-content-center" v-if="!gift_card.send_to_self">
                    <div class="col">
                      <base-input :secondary-color="bss.text_color_card" :error="errors.gift_card.email || (giftEmailBlurred ? emailTypoWarning(gift_card.recipient_email) : '')" :input-style="{'color': bss.text_color_card}"
                                  v-model="gift_card.recipient_email" :placeholder="$t('book.placeholders.recipientEmail')" @blur="giftEmailBlurred = true"></base-input>
                    </div>
                  </div>

                  <div class="row mt-2 justify-content-between">
                    <div class="col">
                      <p class="card-title text-uppercase" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.personalMessage')}}</p>
                    </div>
                  </div>

                  <div class="row  justify-content-center">
                    <div class="col">
                      <base-input :secondary-color="bss.text_color_card" :input-style="{'color': bss.text_color_card}">
                        <textarea :style="{'color': bss.text_color_card}" class="form-control" :placeholder="$t('book.placeholders.addPersonalMessage')" v-model="gift_card.personal_message" rows="2"></textarea>
                      </base-input>
                    </div>
                  </div>

                  <div class="row mt-2 justify-content-between" v-if="selectedGiftCardType.include_policy_section">
                    <div class="col">
                      <p class="card-title text-uppercase" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{selectedGiftCardType.policy_section_title}}
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center" v-if="selectedGiftCardType.include_policy_section">
                    <div class="col">
                      <small v-html="selectedGiftCardType.redemption_policy"
                             :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{selectedGiftCardType.redemption_policy}}</small>
                    </div>
                  </div>

                  <div :style="{ 'color': bss.text_color_card}" class="row mt-2" v-if="selectedGiftCardType.require_terms">
                    <div class="col">
                      <base-checkbox :border-color="bss.button_color" :check-mark-color="bss.card_color" :accent-color="bss.button_color" v-model="gift_card.terms" :error="errors.gift_card.terms">
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.iAgreeTo')}}
                           <a :style="{'font-family': bss.font_family_card, 'color': bss.link_color}" v-if="selectedGiftCardType.include_tos_link"
                              :href="selectedGiftCardType.external_tos_link" target="_blank">{{ selectedGiftCardType.tos_text }}</a>
                          <span v-else>{{ selectedGiftCardType.tos_text }}</span>
                          </span>
                      </base-checkbox>
                      <p :style="{'font-family': bss.font_family_card, 'color': '#ec250d'}" class="small ml-4" v-if="errors.gift_card.terms">{{$t('book.acceptToS')}}</p>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-lg-1 col-2">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                        v-on:click="changeDateTime(1)" link >
                        <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                      </base-button>
                    </div>
                    <div class="col-lg-11 col-10">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"
                        v-on:click="setGiftCard()" simple >{{$t('book.buttons.continue')}}</base-button>
                    </div>
                  </div>

                </card>
              </div>
            </div>
            <div class="row justify-content-center" v-show="!loading" v-if="!gift_card_select && !show_addons">
              <div class="col-11 col-lg-6">
                <card :style="{ 'background-color': bss.card_color}">
                  <div v-if="selectedGame.hasOwnProperty('game_images')" slot="image" class="card-img-top" style="padding-bottom: 0; height: 300px">
                    <el-carousel :key="'GD-' + gameImagesFor(selectedGame.game_images).length + (isMobileViewport ? '-m' : '-d')"
                                 :arrow="getArrowSetting(gameImagesFor(selectedGame.game_images))" :autoplay="!!bss.allow_autoscroll" indicator-position="none" :interval="5000">
                      <el-carousel-item style="border-radius: 5px; width: 100%; height: 300px;"
                                        :style="{'background-color': item.background_color}" v-for="(item, index) in gameImagesFor(selectedGame.game_images)"
                                        :key="'CS' + index">
                        <div  style="border-radius: 5px; width: 100%; height: 300px; position: relative">
                          <img
                            :style="{'transform': 'translate(0%, 0%) scale(' + item.scale*0.01 + ')', 'left': item.x + 'px', 'top': item.y + 'px', 'object-fit':  imageFitInBox(item), 'height': '100%'}"
                            class="card-img"
                            style="position: absolute; transform-origin: center center; will-change: transform"
                            slot="image" v-twin-src="item.url"  alt="Card image cap"/>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <div class="row">
                    <div class="col">
                      <h3 v-if="bss.show_game_title" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{selectedGame.game_name}}</h3>
                      <p v-html="selectedGame.game_description" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" ></p>
                    </div>
                  </div>
                  <hr :style="{ 'background-color': bss.text_color_card}">
                  <div class="row">
                    <div class="col">

                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        <i class="tim-icons icon-calendar-60"></i>&nbsp;{{getDayOfWeek(selectedBooking.booking_date)}} {{getFormattedDate(locale.date_format, selectedBooking.booking_date)}}
                        <span v-if="!selectedBooking.is_all_day">
                          <i class="tim-icons icon-time-alarm"></i>&nbsp;{{getTime(locale.time_format, selectedBooking.start_time)}}<span v-if="selectedEndTime()">&nbsp;{{ $t('book.to') }}&nbsp;{{getTime(locale.time_format, selectedEndTime())}}</span>&nbsp;
                        </span>
                        <base-button
                          :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                          size="sm"
                          v-on:click="changeDateTime()" simple>{{$t('book.buttons.changeDateTime')}}</base-button>
                      </h4>
                      <!-- Multiple durations: pick the length before the participant counts -->
                      <div class="row mb-2" v-if="price_settings.enable_multiple_durations && durations.length > 1">
                        <div class="col">
                          <label class="text-uppercase" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ $t('book.duration') }}</label>
                          <div>
                            <base-button v-for="d in durations" :key="'D' + d.id" size="sm" simple class="mr-2 mb-2"
                              :style="durationButtonStyle(d)" @click="selectDuration(d)">
                              {{ d.duration_minutes }} {{ $t('book.minutes') }}
                            </base-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="bss.show_available_ticket_count && !selectedBooking.is_resource_saturated && ((isPublicBooking(selectedGame, selectedBooking)
                               && hasRemainingSlots(selectedGame, selectedBooking)))">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{ getRemainingTickets(selectedGame, selectedBooking) }}/{{selectedGame.max_players_count}} {{ $t('book.availableTickets') }}
                      </p>
                    </div>
                  </div>

                  <div class="row" v-if="allowReservationTypeUpgrade
                              && isPublicBooking(selectedGame, selectedBooking)
                              && hasNotBeenBooked">
                    <div class="col">
                      <base-button @click="toggleUpgradeReservationType()" v-if="!book_entire_slot"
                        :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                        size="sm" simple>{{$t('book.buttons.upgradeReservationType')}}</base-button>
                      <base-button @click="toggleUpgradeReservationType()" v-if="book_entire_slot"
                                   :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                                   size="sm" simple>{{$t('book.buttons.downgradeReservationType')}}</base-button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div v-for="(c, i) in pricing_categories" :key="'C' + i">
                        <div class="row">
                          <div class="col">
                            <label class="mt-2 text-uppercase" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{c.category}}</label>
                          </div>
                        </div>
                        <div class="el-input-number" >
                          <span role="button" class="el-input-number__decrease" v-on:click="decrementCounter(c)"
                                :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}">
                            <i class="el-icon-minus"></i>
                          </span>
                          <span role="button" v-on:click="incrementCounter(c)"
                                :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}"
                                class="el-input-number__increase">
                            <i class="el-icon-plus"></i>
                          </span>
                          <div class="el-input">
                            <input disabled :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color,  'background-color': 'inherit'}"
                                   v-model="c.number_of_players"
                                   type="text" autocomplete="off" max="4" min="0" class="el-input__inner" role="spinbutton" aria-disabled="false">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-lg-6 mt-2">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="text-uppercase">{{$t('book.subtotal')}}</p>
                      <h2 style="margin-bottom: 0px" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{getCurrencySymbol(locale.currency)}}{{ getNumberFormat(getAmount(subtotal)) }} {{getCurrencyCode(locale.currency)}}
                      </h2>
                      <small v-if="!price_settings.hide_pricing_rate && (!book_entire_slot || price_settings.reservation_upgrade_pricing_mode === 'tickets_plus_fee')">
                        <div  v-for="(c, i) in pricing_categories" :key="'CC' + i">
                          <span  :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getRate(c)}}</span>
                        </div>
                      </small>
                      <small v-if="book_entire_slot && price_settings.reservation_upgrade_pricing_mode === 'tickets_plus_fee'">
                        <div :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">+ {{getCurrencySymbol(locale.currency)}}{{ getNumberFormat(getAmount(price_settings.reservation_upgrade_fee)) }} {{getCurrencyCode(locale.currency)}} {{$t('book.privateBookingFee')}}</div>
                      </small>

                      <div class="mt-2" v-if="bss.show_total_pricing_on_events">
                        <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="text-uppercase">{{$t('book.total')}}</p>
                        <h2  style="margin-bottom: 0px" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{getCurrencySymbol(locale.currency)}}{{ getNumberFormat(getAmount(getSubtotalWithTaxFee(subtotal, number_of_players))) }} {{getCurrencyCode(locale.currency)}}
                        </h2>
                        <small>
                          <div  v-for="(t, i) in taxes" :key="'CCT' + i" v-if="(t.pricing_type === 0 || (t.pricing_type === 1 && t.show_tax_line_items))">
                            <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                              {{ t.name }} <span v-if="t.pricing_type === 1"> (included)</span>:
                              {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTaxForGame(t, subtotal, number_of_players, selectedBooking)))}} {{getCurrencyCode(locale.currency)}}
                            </span>
                          </div>
                          <div  v-for="(f, i) in fees" :key="'CCF' + i">
                            <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                              {{ f.name }}: {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getFeeForGame(f, subtotal, number_of_players, selectedBooking)))}} {{getCurrencyCode(locale.currency)}}
                            </span>
                          </div>
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input :secondary-color="bss.text_color_card" :error="errors.number_of_players"><p></p></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-1 col-2">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                        v-on:click="changeDateTime(1)" link >
                        <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                      </base-button>
                    </div>
                    <div class="col-lg-11 col-10">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"
                        v-on:click="tabTwo(2)" simple >{{$t('book.buttons.continue')}}</base-button>
                    </div>
                  </div>
                </card>
              </div>
            </div>
            <div class="row justify-content-center" v-show="!loading" v-if="show_addons">
              <div class="col-11 col-lg-7">
                <card :style="{ 'background-color': bss.card_color}" v-if="!loading">
                  <div v-if="hasAddonsHeaderText" class="mb-3">
                    <h3 v-if="bss.addons_title && bss.addons_title.trim()" style="margin-bottom: 5px" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ getDynamicString(bss.addons_title) }}</h3>
                    <small v-if="bss.addons_subtext && bss.addons_subtext.trim()" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'white-space': 'pre-line'}">{{ getDynamicString(bss.addons_subtext) }}</small>
                  </div>
                  <div v-for="(ao, i) in addons" :key="'AO' + i" :style="{ 'background-color': bss.card_color}">
                    <div class="justify-content-between d-block d-sm-none" style="align-items: center; margin-bottom: 30px; border-radius: 5px;">
                      <div v-if="ao.image_id" :style="{'background-color': ao.background_color}" style="border-radius: 5px;">
                        <img :src="ao.url"
                             :style="{'transform': 'translate(0%, 0%) scale(' + ao.scale*0.01 + ')',
                       'left': ao.x + 'px', 'top': ao.y + 'px', 'object-fit':  ao.object_fit }"
                             alt="Image" style="height: 250px; ">
                      </div>

                      <div class="mt-3">
                        <h3 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ao.name}}</h3>
                        <small :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'white-space': 'pre-line'}">{{ao.description}}</small>
                      </div>

                      <div>
                        <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="text-uppercase mt-3">{{$t('book.quantity')}}</p>
                        <div class="el-input-number" >
                        <span role="button" class="el-input-number__decrease" v-on:click="decrementAddonQuantity(ao)"
                              :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}">
                          <i class="el-icon-minus"></i>
                        </span>
                          <span role="button" v-on:click="incrementAddonQuantity(ao)"
                                :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}"
                                class="el-input-number__increase">
                          <i class="el-icon-plus"></i>
                        </span>
                          <div class="el-input">
                            <input disabled :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color,  'background-color': 'inherit'}"
                                   v-model="ao.quantity"
                                   type="text" autocomplete="off" max="4" min="0" class="el-input__inner" role="spinbutton" aria-disabled="false">
                          </div>
                          <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="text-uppercase mt-3">{{$t('book.subtotal')}}</p>
                          <h2 style="margin-bottom: 0px" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                            {{getCurrencySymbol(locale.currency)}}{{ getNumberFormat(getAmount(ao.subtotal)) }} {{getCurrencyCode(locale.currency)}}
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div class="d-none d-sm-block">
                      <div class="justify-content-between" style="display: flex; align-items: center; min-height: 165px; margin-bottom: 30px; border-radius: 5px;">
                        <div v-if="ao.image_id" :style="{'background-color': ao.background_color}" style="width: 30%; height: 100%; border-radius: 5px;">
                          <img :src="ao.url"
                               :style="{'transform': 'translate(0%, 0%) scale(' + ao.scale*0.01 + ')',
                       'left': ao.x + 'px', 'top': ao.y + 'px', 'object-fit':  ao.object_fit,
                       'height': '100%'}"
                               alt="Image" style="height: 100%; ">
                        </div>
                        <div style="width: 45%; padding: 20px;">
                          <h3 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ao.name}}</h3>
                          <small :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'white-space': 'pre-line'}">{{ao.description}}</small>
                        </div>
                        <div style="padding: 20px;">
                          <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="text-uppercase mt-3">{{$t('book.quantity')}}</p>
                          <div class="el-input-number" >
                        <span role="button" class="el-input-number__decrease" v-on:click="decrementAddonQuantity(ao)"
                              :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}">
                          <i class="el-icon-minus"></i>
                        </span>
                            <span role="button" v-on:click="incrementAddonQuantity(ao)"
                                  :style="{ 'font-family': bss.font_family_card, 'border-radius' : '0px', 'border-color': bss.button_color, 'color': bss.card_color, 'background-color': bss.button_color}"
                                  class="el-input-number__increase">
                          <i class="el-icon-plus"></i>
                        </span>
                            <div class="el-input">
                              <input disabled :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color,  'background-color': 'inherit'}"
                                     v-model="ao.quantity"
                                     type="text" autocomplete="off" max="4" min="0" class="el-input__inner" role="spinbutton" aria-disabled="false">
                            </div>
                            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="text-uppercase mt-3">{{$t('book.subtotal')}}</p>
                            <h2 style="margin-bottom: 0px" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                              {{getCurrencySymbol(locale.currency)}}{{ getNumberFormat(getAmount(ao.subtotal)) }} {{getCurrencyCode(locale.currency)}}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr v-if="i < addons.length -1" :style="{ 'background-color': bss.text_color_card}">
                  </div>

                  <div class="row" style="padding-left: 20px; padding-right: 20px">
                    <div class="col-lg-1 col-2">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                        v-on:click="changeDateTime(1)" link >
                        <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                      </base-button>
                    </div>
                    <div class="col-lg-11 col-10">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"
                        v-on:click="tabTwo(2, 'addon')" simple >{{$t('book.buttons.continue')}}</base-button>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step4')">
            <template slot="label">
              <!--              <span :style="{'color': bss.text_color_card, 'font-weight': 'bold', 'font-size': 'large'}">3</span>-->
              <i class="tim-icons icon-single-02"></i>
              <p class="d-sm-block d-none" v-show="bss.display_section_titles" :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{$t('book.yourInfo')}}</p>
            </template>
            <div class="row justify-content-center" v-show="!loading">
              <div class="col-lg-6 col-10">
                <upsell-suggestions v-if="showUpsell && upsellPosition === 'above_form'"
                                    :games="games" :cart="cart" :bss="bss" :locale="locale"
                                    :format-amount="formatUpsellAmount" :cart-id="cart_id" :company-code="$route.params.company" :cart-synced="cart_sync_pending === 0"
                                    @select="selectUpsell" />
                <card :style="{ 'background-color': bss.card_color }">
                  <div class="row">
                    <div class="col">
                      <h3 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{$t('book.personalInfo')}}</h3>
                    </div>
                  </div>
                  <div class="row">
                    <div :style="{ 'color': bss.text_color_card}" class="col-12 col-lg-6">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.firstName')}}*</label>
                      <base-input v-on:change="addToCart(5)" :secondary-color="bss.text_color_card" :error="errors.first_name" :input-style="{'color': bss.text_color_card}" :placeholder="$t('book.placeholders.firstName')" v-model="user.first_name"></base-input>
                    </div>
                    <div :style="{ 'color': bss.text_color_card}" class="col-12 col-lg-6">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.lastName')}}*</label>
                      <base-input v-on:change="addToCart(5)" :secondary-color="bss.text_color_card" :error="errors.last_name" :input-style="{'color': bss.text_color_card}" :placeholder="$t('book.placeholders.lastName')" v-model="user.last_name"></base-input>
                    </div>
                  </div>
                  <div :style="{ 'color': bss.text_color_card}" class="row">
                    <div :class="emailColumnClass">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.email')}}*</label>
                      <base-input v-on:change="addToCart(5)" :secondary-color="bss.text_color_card" :error="errors.email || (emailBlurred ? emailTypoWarning(user.email) : '')" :input-style="{'color': bss.text_color_card}" placeholder="example@gmail.com" v-model="user.email" type="email" @blur="emailBlurred = true"></base-input>
                    </div>
                    <div class="col-12 col-lg-6" v-if="zipFieldMode !== 'hidden'">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{zipFieldLabel}}{{ zipFieldMode === 'required' ? '*' : '' }}</label>
                      <base-input :secondary-color="bss.text_color_card" :error="errors.customer_zip" :input-style="{'color': bss.text_color_card}"
                                  :placeholder="zipFieldPlaceholder" v-model="user.zip"></base-input>
                    </div>
                    <div class="col-12 col-lg-6" v-if="phoneFieldMode !== 'hidden'">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.phone')}}{{ phoneFieldMode === 'required' ? '*' : '' }}</label>
                      <base-input
                        :secondary-color="bss.text_color_card" v-on:change="addToCart(5)"
                        :error="errors.phone || (user.phoneBlurred ? user.phoneValidationMessage : '')"
                        :input-style="{'color': bss.text_color_card}">
                        <phone-number-input :input-style="{'color': bss.text_color_card}" @phone-update="handlePhoneUpdate"
                                            v-model="user.phone" ref="phoneInput"
                                            :default-country="country.code || 'US'"
                                            @blur="user.phoneBlurred = true"
                        />
                      </base-input>
                    </div>
                  </div>
                  <template v-if="addressFieldMode !== 'hidden'">
                    <div :style="{ 'color': bss.text_color_card}" class="row">
                      <div class="col-12">
                        <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.addressLine1')}}{{ addressFieldMode === 'required' ? '*' : '' }}</label>
                        <base-input :secondary-color="bss.text_color_card" :error="errors.address_line_1" :input-style="{'color': bss.text_color_card}"
                                    v-model="user.address_line_1"></base-input>
                      </div>
                    </div>
                    <div :style="{ 'color': bss.text_color_card}" class="row">
                      <div class="col-12">
                        <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.addressLine2')}}</label>
                        <base-input :secondary-color="bss.text_color_card" :input-style="{'color': bss.text_color_card}"
                                    v-model="user.address_line_2"></base-input>
                      </div>
                    </div>
                    <div :style="{ 'color': bss.text_color_card}" class="row">
                      <div class="col-12 col-lg-6">
                        <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cityFieldLabel}}{{ addressFieldMode === 'required' ? '*' : '' }}</label>
                        <base-input :secondary-color="bss.text_color_card" :error="errors.city" :input-style="{'color': bss.text_color_card}"
                                    v-model="user.city"></base-input>
                      </div>
                      <div class="col-12 col-lg-6">
                        <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{stateFieldLabel}}{{ addressFieldMode === 'required' ? '*' : '' }}</label>
                        <base-input :secondary-color="bss.text_color_card" :error="errors.state" :input-style="{'color': bss.text_color_card}"
                                    v-model="user.state"></base-input>
                      </div>
                    </div>
                    <div :style="{ 'color': bss.text_color_card}" class="row">
                      <div class="col-12 col-lg-6">
                        <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{zipFieldLabel}}{{ addressFieldMode === 'required' ? '*' : '' }}</label>
                        <base-input :secondary-color="bss.text_color_card" :error="errors.customer_zip" :input-style="{'color': bss.text_color_card}"
                                    :placeholder="zipFieldPlaceholder" v-model="user.zip"></base-input>
                      </div>
                      <div class="col-12 col-lg-6">
                        <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.placeholders.country')}}{{ addressFieldMode === 'required' ? '*' : '' }}</label>
                        <base-input :secondary-color="bss.text_color_card" placeholder="Select">
                          <base-dropdown :style="{'font-family': bss.font_family_card }"
                                         title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                         :font-family="bss.font_family_card"
                                         :title="selectedAddressCountryName || $t('book.placeholders.country')">
                            <a v-for="(c, i) in countries" :style="{'font-family': bss.font_family_card }"
                               style="white-space: normal; overflow-wrap: break-word;"
                               class="dropdown-item" href="#" :key="'ACTRY' + i" v-on:click.prevent="user.country = c.code">
                              {{ c.name }}</a>
                          </base-dropdown>
                        </base-input>
                      </div>
                    </div>
                  </template>
                  <div class="row mt-2" v-if="!hasVisibleCustomFields">
                    <div class="col-lg-1 col-2">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                        v-on:click="tabOne(1)" link >
                        <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                      </base-button>
                    </div>
                    <div class="col-10 col-lg-11">
                      <base-button v-if="getTotalAmount() > 0 && !payOnArrivalRequired()"
                                   :style="{ 'width': '100%', 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                                   v-on:click="tabThree(3, 0)" simple >{{$t('book.buttons.continue')}}</base-button>
                      <base-button v-if="getTotalAmount() <= 0 || payOnArrivalRequired()" :disabled="loading"
                                   :style="{ 'width': '100%', 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                                   v-on:click="tabThree(4, 1)" simple >{{$t('book.buttons.completeBooking')}}</base-button>
                    </div>
                  </div>
                </card>
                <!-- Also renders for SMS consent alone: a venue with no custom
                     fields still has to show the opt-in checkbox, and it belongs
                     in this section with the other agreements. -->
                <card :style="{ 'background-color': bss.card_color }" v-if="hasVisibleCustomFields || showSmsConsent">
                  <div class="row">
                    <div class="col">
                      <h3 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{$t('book.additionalInfo')}}</h3>
                    </div>
                  </div>
                  <div :style="{ 'color': bss.text_color_card}" class="row" v-for="(cf, i) in custom_fields" :key="'CF' + i">
                    <div class="col mb-3" v-if="cf.type === 1 && isFieldVisibile(cf)">
                      <base-checkbox v-on:input="handleCustomFieldInput(cf)" :key="j"
                                     :border-color="bss.button_color" :accent-color="bss.button_color" :check-mark-color="bss.card_color"
                                     v-model="cf.customer_response"
                                     simple size="sm">
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}</span>
                        <span v-for="(el, i) in cf.external_links" :key="'EL'+ i">
                              <a v-on:click="recordInteraction(el)"
                                 :style="{'font-family': bss.font_family_card, 'color': bss.link_color}" target="_blank"
                                 :href="el.link"> {{el.link_text}}</a>
                        </span>
                        <span v-for="(p, i) in cf.policies" :key="'PLI' + i">
                          <base-button
                            :style="{'font-family': bss.font_family_card, 'color': bss.link_color}"
                            style="font-weight:300; font-size: small; padding: 0"
                            size="sm" link class="btn btn-link" href="" v-on:click="openPolicy(p, cf, $event)">{{p.policy_link_text}}</base-button>
                        </span>
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" v-if="cf.required || (cf.type === 1 && cf.interaction_required)">*</span>
                      </base-checkbox>
                      <p :style="{'font-family': bss.font_family_card, 'color': '#ec250d'}" class="ml-4" v-if="cf.error">
                        {{ cf.error }}</p>
                    </div>
                    <div class="col mb-3" v-if="cf.type === 2 && isFieldVisibile(cf)">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}<span v-if="cf.required">*</span>
                      </label>
                      <base-input :secondary-color="bss.text_color_card" :error="cf.error" :input-style="{'color': bss.text_color_card}"
                                  v-model="cf.customer_response">

                      </base-input>
                    </div>
                    <div class="col mb-3" v-if="cf.type === 5 && isFieldVisibile(cf)">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}<span v-if="cf.required">*</span>
                      </label>
                      <base-input :secondary-color="bss.text_color_card" :error="cf.error" :input-style="{'color': bss.text_color_card}">
                        <textarea :style="{'color': bss.text_color_card}" class="form-control" rows="4" v-model="cf.customer_response"></textarea>
                      </base-input>
                    </div>
                    <div class="col mb-3" v-if="cf.type === 3 && isFieldVisibile(cf)">
                      <div class="row">
                        <div class="col-lg-6">
                          <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.label}}<span v-if="cf.required">*</span>
                          </label>
                          <base-input :secondary-color="bss.text_color_card" placeholder="Select" :error="cf.error">
                            <base-dropdown :key="'CFF' + j" :style="{'font-family': bss.font_family_card }"
                                           title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                           :font-family="bss.font_family_card"
                                           :title="getDropDownLabel(cf.customer_response)"

                            >
                              <a v-for="(c, i) in cf.dropdown_options"  :style="{'font-family': bss.font_family_card }"
                                 style=" white-space: normal; overflow-wrap: break-word;"
                                 class="dropdown-item" href="#" :key="'DOJ' + i" v-on:click.prevent="selectDropdown(cf, c, $event)">
                                {{ getDropDownLabel(c) }}</a>
                            </base-dropdown>
                          </base-input>
                        </div>

                        <div class="col" v-if="cf.customer_response">
                          <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{cf.customer_response.follow_up_field_label}}
                            <span v-if="cf.required && cf.customer_response.has_follow_up_field">*</span>
                          </label>
                          <base-input :secondary-color="bss.text_color_card" :input-style="{'color': bss.text_color_card}" v-model="cf.customer_response.follow_up_response"
                                      v-if="cf.customer_response && cf.customer_response.has_follow_up_field"></base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Sits with the other agreement checkboxes rather than in
                       Personal information: this is a consent, not a contact
                       detail. Still gated on a phone field existing, since
                       there is nothing to consent to without one. -->
                  <div class="row" v-if="showSmsConsent">
                    <div class="col mb-3">
                      <sms-consent
                        :enabled="true"
                        :theme="bss"
                        :business-name="smsBusinessName"
                        :platform-name="smsPlatformName"
                        :privacy-url="smsPrivacyUrl"
                        :terms-url="smsTermsUrl"
                        :transactional-consent.sync="smsTransactionalConsent"
                        :marketing-consent.sync="smsMarketingConsent"
                        @consent-text="onSmsConsentText"
                      />
                    </div>
                  </div>
                  <modal :show.sync="modals.policy" id="policyModal"
                         :scroll-to-bottom="false"
                         :class="['content-modal', { 'embedded-modal': isEmbedded }]"
                         :style="isEmbedded ? { paddingTop: embeddedModalTop + 'px' } : null"
                         body-classes="p-0"
                         modal-classes="modal-dialog-centered modal-lg">
                    <card :style="{ 'background-color': bss.background_color}"
                          header-classes="bg-white pb-5"
                          class="border-0 mb-0">
                      <p :style="{'color': bss.text_color}" v-html="selectedPolicy.policy"></p>
                      <div class="row mt-3 justify-content-center">
                        <div class="col text-center">
                          <base-button
                            :style="{ 'width': '100%', 'font-family': bss.font_family_card,
                            'border-color': bss.text_color, 'color': bss.text_color }" simple
                            v-on:click="agreeToPolicy()">{{$t('book.iAgree')}}</base-button>
                        </div>
                      </div>
                    </card>
                  </modal>
                  <modal :show.sync="modals.dropdown_popup"
                         :scroll-to-bottom="false"
                         :class="['content-modal', { 'embedded-modal': isEmbedded }]"
                         :style="isEmbedded ? { paddingTop: embeddedModalTop + 'px' } : null"
                         body-classes="p-0"
                         modal-classes="modal-dialog-centered modal-lg">
                    <card :style="{ 'background-color': bss.background_color}"
                          header-classes="bg-white pb-5"
                          class="border-0 mb-0">
                      <h4 v-if="popupOption" :style="{'font-family': bss.font_family_card, 'color': bss.text_color}">{{ popupOption.name }}</h4>
                      <div v-if="popupOption" :style="{'color': bss.text_color, 'font-family': bss.font_family_card}" v-html="popupOption.description"></div>
                      <div class="row mt-3 justify-content-center">
                        <div class="col text-center">
                          <base-button
                            :style="{ 'width': '100%', 'font-family': bss.font_family_card,
                            'border-color': bss.button_color, 'color': bss.button_color }" simple
                            v-on:click="modals.dropdown_popup = false">OK</base-button>
                        </div>
                      </div>
                    </card>
                  </modal>
                  <div class="row mt-2">
                    <div class="col-lg-1 col-2">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                        v-on:click="tabOne(1)" link >
                        <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                      </base-button>
                    </div>
                    <div class="col-10 col-lg-11">
                      <base-button v-if="getTotalAmount() > 0 && !payOnArrivalRequired()"
                                   :style="{ 'width': '100%', 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                                   v-on:click="tabThree(3, 0)" simple >{{$t('book.buttons.continue')}}</base-button>
                      <base-button v-if="getTotalAmount() <= 0 || payOnArrivalRequired()" :disabled="loading"
                                   :style="{ 'width': '100%', 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"
                                   v-on:click="tabThree(4, 1)" simple >{{$t('book.buttons.completeBooking')}}</base-button>
                    </div>
                  </div>
                </card>
                <upsell-suggestions v-if="showUpsell && upsellPosition === 'below_form'"
                                    :games="games" :cart="cart" :bss="bss" :locale="locale"
                                    :format-amount="formatUpsellAmount" :cart-id="cart_id" :company-code="$route.params.company" :cart-synced="cart_sync_pending === 0"
                                    @select="selectUpsell" />
              </div>
              <div class="col-lg-3 col-10">
                <card :style="{ 'background-color': bss.card_color }">
                  <div class="row justify-content-center">
                    <base-button :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"  v-on:click="tabZero(0)" class="button-wide no-upper-margin" simple size="sm">
                      {{$t('book.buttons.addAnotherBooking')}}
                    </base-button>
                  </div>
                  <div class="row mt-3" v-if="cart.length > 0">
                    <div class="col-11">
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">
                        {{$t('book.yourPurchases')}}
                        <i class="tim-icons icon-cart"></i>
                      </h4>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="cart.length <= 0">
                    <div class="col ml-2 mr-2"
                         :style="{'border-radius': '.1875rem', 'min-height' : '100px', 'padding': '20px 0 15px', 'text-align': 'center', 'border': '1px solid ' + bss.button_color }">
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: 2em">
                          <i class="fas fa-exclamation-triangle"></i>
                        </span>
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{$t('book.yourCartIsEmpty')}}</h4>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0">
                    <div class="col-12">
                      <div v-for="(c, index) in cart" :key="'M' + index">
                        <div v-if="c.hasOwnProperty('gift_card')">
                          <div class="row">
                            <div class="col-3">
                              <img class="game-img" style="object-fit: contain" :src="c.gift_card.design_url.url"/>
                            </div>
                            <div class="col-9">
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                                {{$tc('book.giftCard', 1)}} {{c.gift_card.name}}
                                <base-button
                                  @click="removeBooking(index, c)"
                                  class="like btn-link"
                                  type="danger"
                                  size="sm"
                                  icon
                                ><i class="tim-icons icon-trash-simple"></i>
                                </base-button>
                              </p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.quantity')}}:</span> {{c.gift_card.quantity}}</p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.giftCardValue')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.gift_card.total))}} {{getCurrencyCode(locale.currency)}}</p>
                            </div>
                          </div>
                        </div>

                        <div v-else-if="c.hasOwnProperty('item')">
                          <div class="row">
                            <div class="col-3">
                              <img class="game-img" style="object-fit: contain" :src="c.item.url"/>
                            </div>
                            <div class="col-9">
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                                {{c.item.name}}
                                <base-button
                                  @click="removeBooking(index, c)"
                                  class="like btn-link"
                                  type="danger"
                                  size="sm"
                                  icon
                                ><i class="tim-icons icon-trash-simple"></i>
                                </base-button>
                              </p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.quantity')}}:</span> {{c.item.quantity}}</p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.subtotal')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.item.subtotal))}} {{getCurrencyCode(locale.currency)}}</p>
                            </div>
                          </div>
                        </div>

                        <div v-else>
                          <div class="row">
                            <div class="col-3"
                                 v-if="c.game.hasOwnProperty('game_images') && c.game.game_images !== null && c.game.game_images.length > 0 ">
                              <img class="game-img" :style="{'object-fit': gameImagesFor(c.game.game_images)[0].object_fit || 'cover'}" v-twin-src="gameImagesFor(c.game.game_images)[0].url"/>
                            </div>
                            <div class="col-9">
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{c.game.game_name}}
                                <base-button
                                  @click="removeBooking(index, c)"
                                  class="like btn-link"
                                  type="danger"
                                  size="sm"
                                  icon
                                ><i class="tim-icons icon-trash-simple"></i>
                                </base-button>
                              </p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.date')}}:</span> {{getDayOfWeek(c.booking.booking_date)}} {{getFormattedDate(locale.date_format, c.booking.booking_date)}}</p>
                              <p v-if="!c.booking.is_all_day" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.time')}}:</span> {{getTime(locale.time_format, c.booking.start_time)}}<span v-if="cartLineEndTime(c)"> {{ $t('book.to') }} {{getTime(locale.time_format, cartLineEndTime(c))}}</span></p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.quantity')}}:</span> {{c.quantity}}</p>
                              <p v-if="ppp" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.rate')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(ppp)}} {{getCurrencyCode(locale.currency)}} {{$t('book.perPerson')}}</p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.bookingSubtotal')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.subtotal))}} {{getCurrencyCode(locale.currency)}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3" v-if="promoFieldOnInfoStep()">
                    <div class="col">
                      <div style="display: flex; width: 100%;">
                        <base-input :secondary-color="bss.text_color_card" v-model="promo_code"
                                    style="flex-grow: 1; border-radius: 0px;"
                                    :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                                    :placeholder="bss.promo_code_placeholder_text">
                        </base-input>
                        <base-button simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                                     :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                                     v-on:click="applyPromo()">
                          {{$t('book.apply')}}
                        </base-button>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="payment_settings.allow_tipping
                  && ((payment_settings.allow_preset_tipping_options && tipping_options.length > 0)
                  || payment_settings.allow_custom_tipping_options)">
                    <div class="col">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{payment_settings.tip_label}}</label>
                      <base-input :secondary-color="bss.text_color_card" v-if="payment_settings.allow_preset_tipping_options && tipping_options.length > 0">
                        <base-dropdown :style="{'font-family': bss.font_family_card }"
                                       title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="bss.font_family_card"
                                       :title="tip_title"
                        >
                          <a v-for="(t, i) in tipping_options"  :style="{'font-family': bss.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#" :key="'T' + i" v-on:click.prevent="computeTip(t)">
                            {{ getTipAmount(t) }}</a>
                        </base-dropdown>
                      </base-input>

                      <div style="display: flex; width: 100%;">
                        <base-input
                          v-if="(payment_settings.allow_custom_tipping_options && !payment_settings.allow_preset_tipping_options) || selectedCustomTipOption"
                          :secondary-color="bss.text_color_card" v-model.number="applied_tip_amount"
                          style="flex-grow: 1; border-radius: 0px;"
                          :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                          :placeholder="tip_placeholder">
                        </base-input>
                        <base-button v-if="(payment_settings.allow_custom_tipping_options && !payment_settings.allow_preset_tipping_options) || selectedCustomTipOption"
                                     simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                                     :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                                     v-on:click="computeTip({id: 0, name: $t('book.customAmount'), amount: applied_tip_amount, value_type: payment_settings.custom_tipping_value_type})">
                          {{$t('book.apply')}}
                        </base-button>
                      </div>
                    </div>
                  </div>

                  <hr :style="{ 'background-color': bss.text_color_card}" v-if="cart.length > 0">
                  <div class="row" v-if="cart.length > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.subtotal')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getCartSubtotal()))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-for="(t, i) in taxes" :key="'J' + i" v-if="cart.length > 0 && hasBookingsInCart() &&
                        (t.pricing_type === 0 || (t.pricing_type === 1 && t.show_tax_line_items)) && isTaxApplicableToCart(t)">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{ t.name }} <span v-if="t.pricing_type === 1"> (included)</span>
                      </p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTax(t)))}} {{getCurrencyCode(locale.currency)}}
                      </p>
                    </div>
                  </div>

                  <div class="row" v-for="(f, i) in fees" :key="'K' + i" v-if="cart.length > 0">
                    <div class="col" v-if="getFee(f) > 0">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ f.name }}</p>
                    </div>
                    <div class="col" v-if="getFee(f) > 0">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getFee(f)))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && applied_tip > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{payment_settings.tip_line_item_label}}
                      </p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(applied_tip))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>

                  <div class="row" v-for="(p, i) in promo_codes" :key="pc_key + i" v-if="cart.length > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ p.name }}
                        <!--                        <base-button :style="{'color': bss.text_color_card}" @click="removePromoCode(p)" style="padding: 0; margin: 0"  icon class="btn-link d-inline">-->
                        <i style="cursor: pointer" :style="{'color': bss.text_color_card}" @click="removePromoCode(p)"  class="tim-icons icon-simple-remove"></i>
                        <!--                        </base-button>-->
                      </p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">-{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(p.display_amount != null ? p.display_amount : p.value_amount))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>

                  <hr :style="{ 'background-color': bss.text_color_card}" v-if="cart.length > 0">
                  <div class="row" v-if="cart.length > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.total')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTotalAmount()))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-for="(a, i) in applied_gift_cards" :key="pc_key + i + i" v-if="cart.length > 0">
                    <div class="col-8">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$tc('book.giftCard', 1)}} ***{{a.code.slice(-4)}}
                        <i :style="{'color': bss.text_color_card}" style="cursor: pointer" @click="removeGiftCard(a)" class="tim-icons icon-simple-remove"></i>
                      </p>
                      <p v-if="a.balance_from_api !== undefined" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-size': '0.9em', 'opacity': '0.85', 'margin-top': '-10px'}">({{$t('book.remainingBalance')}} {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(a.balance_from_api))}}{{getCurrencyCode(locale.currency)}})</p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">-{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(a.remaining))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && (pay_deposit || applied_gift_cards.length > 0)">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{$t('book.dueNow')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(due_now))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && pay_deposit">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.dueLater')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(due_later))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                </card>
                <upsell-suggestions v-if="showUpsell && upsellPosition === 'below_cart'" compact
                                    :games="games" :cart="cart" :bss="bss" :locale="locale"
                                    :format-amount="formatUpsellAmount" :cart-id="cart_id" :company-code="$route.params.company" :cart-synced="cart_sync_pending === 0"
                                    @select="selectUpsell" />
              </div>
            </div>
          </wizard-tab>
          <wizard-tab :before-change="() => validateStep('step5')">
            <template slot="label">
              <!--              <span :style="{'color': bss.text_color_card, 'font-weight': 'bold', 'font-size': 'large'}">4</span>-->
              <i class="tim-icons icon-cart"></i>
              <p class="d-sm-block d-none" v-show="bss.display_section_titles" :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{$t('book.headers.payment')}}</p>
            </template>
            <div v-show="!loading" class="row justify-content-center">
              <div class="col-lg-6 col-10">
                <upsell-suggestions v-if="showUpsell && upsellPosition === 'above_form'"
                                    :games="games" :cart="cart" :bss="bss" :locale="locale"
                                    :format-amount="formatUpsellAmount" :cart-id="cart_id" :company-code="$route.params.company" :cart-synced="cart_sync_pending === 0"
                                    @select="selectUpsell" />
                <card :style="{ 'background-color': bss.card_color }">
                  <div class="row">
                    <div class="col">
                      <h3 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{$t('book.billingInfo')}}</h3>
                    </div>
                  </div>
                  <div class="row mb-2" v-if="getTotalAmount() <= 0">
                    <div class="col ml-3 mr-3"
                         :style="{'border-radius': '.1875rem', 'min-height' : '100px', 'padding': '20px 0 15px', 'text-align': 'center', 'border': '1px solid ' + bss.button_color }">
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: 2em">
                          <i class="fas fa-exclamation-triangle"></i>
                        </span>
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.nothingDue')}}</h4>
                    </div>
                  </div>
                  <!-- Booking request notice: what happens after submission and how payment is handled -->
                  <div class="row mb-3" v-if="cartHasRequest">
                    <div class="col ml-3 mr-3"
                         :style="{'border-radius': '.1875rem', 'padding': '12px 16px', 'border': '1px solid ' + bss.button_color }">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="mb-1">{{$t('book.requestBanner')}}</p>
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="mb-0" style="font-weight: 600">
                        {{ requestNoCapture ? $t('book.requestBannerOnApproval') : $t('book.requestBannerChargeNow') }}
                      </p>
                    </div>
                  </div>
                  <div class="row mb-3" v-if="getTotalAmount() > 0 && allow_pay_on_arrival && !cartHasRequest">
                    <div class="col">
                      <base-checkbox :border-color="bss.button_color" :check-mark-color="bss.card_color" v-on:input="selectPayOnArrival()" :accent-color="bss.button_color"
                                     v-model="pay_on_arrival"
                                     simple size="sm">
                        <span v-if="payment_settings.enable_pay_on_arrival_text" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{payment_settings.pay_on_arrival_text}}</span>
                        <span v-else :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.payOnArrival')}}</span>
                      </base-checkbox>
                    </div>
                  </div>
                  <!-- Deposit choice: presentation controlled per booking site template -->
                  <div class="row mb-3" v-if="getTotalAmount() > 0 && allow_deposit && !require_deposit && depositLayout === 'checkbox'">
                    <div class="col">
                      <p v-if="hasCustomDepositText" class="deposit-info-text" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{bss.deposit_text}}</p>
                      <base-checkbox :border-color="bss.button_color" :check-mark-color="bss.card_color"
                                     v-on:input="onDepositToggle" :accent-color="bss.button_color"
                                     v-model="pay_deposit"
                                     simple size="sm">
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.payDeposit')}} - {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(deposit))}} {{getCurrencyCode(locale.currency)}}</span>
                      </base-checkbox>
                    </div>
                  </div>
                  <!-- Buttons/cards layouts collapse to no choice when the deposit equals the
                       total (depositDueLater 0) — two identical amounts would look broken -->
                  <div class="row mb-3" v-if="getTotalAmount() > 0 && allow_deposit && !require_deposit && depositLayout !== 'checkbox' && depositDueLater > 0">
                    <div class="col">
                      <p class="deposit-info-text" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ hasCustomDepositText ? bss.deposit_text : $t('book.depositInfoDefault') }}</p>
                      <div v-if="depositLayout === 'buttons'" class="button-group">
                        <button type="button" class="payment-btn" :class="{ 'active': !pay_deposit }"
                                :style="{
                                  fontFamily: bss.font_family_card,
                                  backgroundColor: !pay_deposit ? bss.button_color : 'transparent',
                                  color: !pay_deposit ? '#fff' : bss.button_color,
                                  borderColor: bss.button_color
                                }"
                                @click="setPayDeposit(false)">
                          {{$t('book.payInFull')}} - {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTotalAmount()))}} {{getCurrencyCode(locale.currency)}}
                        </button>
                        <button type="button" class="payment-btn" :class="{ 'active': pay_deposit }"
                                :style="{
                                  fontFamily: bss.font_family_card,
                                  backgroundColor: pay_deposit ? bss.button_color : 'transparent',
                                  color: pay_deposit ? '#fff' : bss.button_color,
                                  borderColor: bss.button_color
                                }"
                                @click="setPayDeposit(true)">
                          {{$t('book.payDeposit')}} - {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(depositDueNow))}} {{getCurrencyCode(locale.currency)}}
                        </button>
                      </div>
                      <div v-if="depositLayout === 'cards'" class="deposit-cards">
                        <div class="deposit-card" :class="{ 'active': !pay_deposit }" role="button" tabindex="0"
                             :style="{ borderColor: bss.button_color, backgroundColor: !pay_deposit ? bss.button_color : 'transparent' }"
                             @click="setPayDeposit(false)"
                             @keydown.enter.prevent="setPayDeposit(false)" @keydown.space.prevent="setPayDeposit(false)">
                          <span class="deposit-card-title" :style="{ fontFamily: bss.font_family_card, color: !pay_deposit ? '#fff' : bss.text_color_card }">{{$t('book.payInFull')}}</span>
                          <span class="deposit-card-amount" :style="{ fontFamily: bss.font_family_card, color: !pay_deposit ? '#fff' : bss.text_color_card }">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTotalAmount()))}} {{getCurrencyCode(locale.currency)}}</span>
                          <span class="deposit-card-sub" :style="{ fontFamily: bss.font_family_card, color: !pay_deposit ? '#fff' : bss.text_color_card }">{{$t('book.dueNow')}}</span>
                        </div>
                        <div class="deposit-card" :class="{ 'active': pay_deposit }" role="button" tabindex="0"
                             :style="{ borderColor: bss.button_color, backgroundColor: pay_deposit ? bss.button_color : 'transparent' }"
                             @click="setPayDeposit(true)"
                             @keydown.enter.prevent="setPayDeposit(true)" @keydown.space.prevent="setPayDeposit(true)">
                          <span class="deposit-card-title" :style="{ fontFamily: bss.font_family_card, color: pay_deposit ? '#fff' : bss.text_color_card }">{{$t('book.payDeposit')}}</span>
                          <span class="deposit-card-amount" :style="{ fontFamily: bss.font_family_card, color: pay_deposit ? '#fff' : bss.text_color_card }">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(depositDueNow))}} {{getCurrencyCode(locale.currency)}}</span>
                          <span class="deposit-card-sub" :style="{ fontFamily: bss.font_family_card, color: pay_deposit ? '#fff' : bss.text_color_card }">{{$t('book.dueLater')}}: {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(depositDueLater))}} {{getCurrencyCode(locale.currency)}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Forced deposit: informational only — the buttons/cards layouts (or an
                       operator description) explain the split the hidden checkbox never did -->
                  <div class="row mb-3" v-if="getTotalAmount() > 0 && allow_deposit && require_deposit && depositDueLater > 0 && (depositLayout !== 'checkbox' || hasCustomDepositText)">
                    <div class="col">
                      <p class="deposit-info-text" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ hasCustomDepositText ? bss.deposit_text : $t('book.depositRequiredInfo') }}</p>
                      <p v-if="depositLayout !== 'checkbox'" class="deposit-required-line" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{$t('book.dueNow')}}: {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(depositDueNow))}} {{getCurrencyCode(locale.currency)}} &middot; {{$t('book.dueLater')}}: {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(depositDueLater))}} {{getCurrencyCode(locale.currency)}}
                      </p>
                    </div>
                  </div>

                  <label v-if="!noCaptureCheckout && due_now > 0" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                    {{$t('book.paymentMethod')}}
                  </label>
                  <div class="row" v-if="!noCaptureCheckout && due_now > 0 && payment_settings.payment_layout_type === 'dropdown'">
                    <div class="col-lg-6">
                      <base-input :secondary-color="bss.text_color_card" placeholder="Select">
                        <base-dropdown  :style="{'font-family': bss.font_family_card }"
                                        title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                        :font-family="bss.font_family_card"
                                        :title="selectedPaymentOption.display_name"
                        >
                          <a v-if="evaluateGCPaymentMethodValidity(pm)" v-for="(pm, i) in payment_methods" :key="'PM' + i" :style="{'font-family': bss.font_family_card }" style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#"  v-on:click.prevent="setPaymentOption(pm)">
                            <span >{{ pm.display_name }}</span></a>
                        </base-dropdown>
                      </base-input>
                    </div>
                  </div>

                  <div class="row mb-3" v-if="!noCaptureCheckout && due_now > 0 && payment_settings.payment_layout_type === 'buttons'">
                    <div class="col">
                      <div class="payment-methods-buttons">
                        <div class="button-group">
                          <button
                            v-for="(pm, i) in payment_methods"
                            v-if="evaluateGCPaymentMethodValidity(pm)"
                            :key="'PM' + i"
                            type="button"
                            class="payment-btn"
                            :class="{ 'active': selectedPaymentOption.id === pm.id }"
                            :style="{
                                fontFamily: bss.font_family_card,
                                backgroundColor: selectedPaymentOption.id === pm.id ? bss.button_color : 'transparent',
                                color: selectedPaymentOption.id === pm.id ? '#fff' : bss.button_color,
                                borderColor: bss.button_color
                              }"
                            @click="setPaymentOption(pm)"
                          >
                            {{ pm.display_name }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-show="!noCaptureCheckout && due_now > 0 &&
                    (selectedPaymentOption.name !== 'Card' || (selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id !== 3) ||
                    (selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 3 && stripe_payment_method === 'card'))">
                    <div class="col-12 col-lg-6">
                      <label v-if="selectedPaymentOption.name === 'Card'" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.nameOnCard')}}</label>
                      <label v-else :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.name')}}</label>
                      <base-input :secondary-color="bss.text_color_card" :error="errors.cardholder_first_name" :input-style="{'color': bss.text_color_card}"
                                  :placeholder="$t('book.placeholders.firstName')" v-model="payment.cardholder_first_name"></base-input>
                    </div>
                    <div class="col-12 col-lg-6">
                      <label class="d-sm-block d-none" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">&nbsp;</label>
                      <base-input :secondary-color="bss.text_color_card" :error="errors.cardholder_last_name" :input-style="{'color': bss.text_color_card}" :placeholder="$t('book.placeholders.lastName')" v-model="payment.cardholder_last_name" type="text"></base-input>
                    </div>
                  </div>

                  <div v-if="getTotalAmount() > 0 && selectedPaymentOption.name !== 'Card' && selectedPaymentOption.name !== 'Gift card'">
                    <div class="row">
                      <div class="col">
                        <span v-html="selectedPaymentOption.content"></span>
                      </div>
                    </div>
                  </div>

                  <div v-show="selectedPaymentOption.name === 'Card'">
                    <!--        Stripe-->
                    <div class="row mb-5" v-show="getTotalAmount() > 0 && payment_settings.payment_gateway_id === 3 && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <form id="payment-form">
                          <div v-if="!stripeElementReady" class="text-center py-4">
                            <i class="fas fa-spinner fa-spin" :style="{'color': bss.text_color_card}"></i>
                          </div>
                          <div v-show="expressCheckoutEnabled && expressCheckoutAvailable" id="express-checkout-element" class="mb-3"></div>
                          <div id="payment-element">
                            <!--Stripe.js injects the Payment Element-->
                          </div>
                          <div id="payment-message" class="hidden"></div>
                        </form>
                      </div>
                    </div>

                    <!-- Save card for future use - info text when forced by deposit requirement -->
                    <div class="row mb-3" v-if="requireCardSaveForced && payment_settings.payment_gateway_id === 3 && payment_settings.store_credit_card && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'opacity': '0.7', 'font-size': '0.85em', 'margin-bottom': '0'}">
                          <i class="tim-icons icon-lock-circle mr-1"></i>
                          {{$t('book.cardWillBeSaved') || 'Your card will be saved on file for the remaining balance.'}}
                        </p>
                      </div>
                    </div>
                    <!-- Save card for future use checkbox (Stripe only) -->
                    <div class="row mb-3" v-if="!requireCardSaveForced && payment_settings.payment_gateway_id === 3 && payment_settings.store_credit_card && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <base-checkbox
                          v-model="save_card_for_future"
                          :border-color="bss.button_color"
                          :accent-color="bss.button_color"
                          :check-mark-color="bss.card_color"
                          simple
                          size="sm">
                          <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                            {{ $t('book.saveCardForFuture') || 'Save my payment method for future purchases' }}
                          </span>
                        </base-checkbox>
                      </div>
                    </div>

                    <!--                  Square-->
                    <div class="row" v-show="getTotalAmount() > 0 && payment_settings.payment_gateway_id === 2 && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <form id="payment-form-square">
                          <div id="card-container"></div>
                        </form>
                        <div id="payment-status-container"></div>
                      </div>
                    </div>

                    <!-- Save card for future use - info text when forced by deposit requirement -->
                    <div class="row mb-3" v-if="requireCardSaveForced && payment_settings.payment_gateway_id === 2 && payment_settings.store_credit_card && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'opacity': '0.7', 'font-size': '0.85em', 'margin-bottom': '0'}">
                          <i class="tim-icons icon-lock-circle mr-1"></i>
                          {{$t('book.cardWillBeSaved') || 'Your card will be saved on file for the remaining balance.'}}
                        </p>
                      </div>
                    </div>
                    <!-- Save card for future use checkbox (Square) -->
                    <div class="row mb-3" v-if="!requireCardSaveForced && payment_settings.payment_gateway_id === 2 && payment_settings.store_credit_card && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <base-checkbox
                          v-model="save_card_for_future"
                          :border-color="bss.button_color"
                          :accent-color="bss.button_color"
                          :check-mark-color="bss.card_color"
                          simple
                          size="sm">
                          <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                            {{$t('book.saveCardForFuture')}}
                          </span>
                        </base-checkbox>
                      </div>
                    </div>

                    <!--                  Authorize.net (Accept.js)-->
                    <div class="row" v-show="getTotalAmount() > 0 && payment_settings.payment_gateway_id === 1 && !noCaptureCheckout && due_now > 0">
                      <div class="col">
                        <enhanced-payment-form
                          ref="authorizePaymentForm"
                          :font-family="bss.font_family_card"
                          :text-color="bss.text_color_card"
                          :border-color="inputBorderSolid"
                          :zip-label="'Billing ' + (country.zip_label || '').toLowerCase()"
                          :zip-placeholder="country.zip_placeholder"
                          :api-login-id="payment_settings.api_name"
                          :public-client-key="payment_settings.public_client_key"
                          :is-live="!!payment_settings.is_live"
                          :show-security-indicators="false"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="selectedPaymentOption.name === 'Gift card' && !noCaptureCheckout && due_now > 0">
                    <div class="col">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.giftCardCode')}}</label>
                      <div style="display: flex; width: 100%;">

                        <base-input :secondary-color="bss.text_color_card" v-model="gift_card_code"
                                    style="flex-grow: 1; border-radius: 0px;" :error="errors.gift_card_code"
                                    :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                                    :placeholder="$t('book.giftCardCode')">
                        </base-input>
                        <base-button simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                                     :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                                     v-on:click="applyGiftCard()">
                          {{$t('book.apply')}}
                        </base-button>
                      </div>
                    </div>

                    <!--                    <div class="col">-->
                    <!--                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">Gift card code</label>-->
                    <!--                      <base-input :secondary-color="bss.text_color_card" :input-style="{'color': bss.text_color_card}"-->
                    <!--                                  placeholder="Gift card code" v-model="gift_card_code" :error="errors.gift_card_code">-->
                    <!--                      </base-input>-->
                    <!--                    </div>-->
                  </div>

                  <div class="row">
                    <div class="col-lg-1 col-2">
                      <base-button
                        :style="{ 'font-family': bss.font_family_card,
                        'border-color': bss.button_color,
                        'color': bss.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                        v-on:click="returnFromPaymentStep" link >
                        <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                      </base-button>
                    </div>
                    <div class="col-10 col-lg-11">
                      <base-button v-if="payment_settings.payment_gateway_id === 4 && selectedPaymentOption.name === 'Card'" :disabled="disable_submit"
                                   :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"
                                   v-on:click="tabFive(5)" type="primary" simple >
                        {{$t('book.buttons.makePayment')}}</base-button>
                      <base-button v-if="!(payment_settings.payment_gateway_id === 4 && selectedPaymentOption.name === 'Card')" :disabled="disable_submit || tokenizing"
                                   ref="payButton"
                                   :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"
                                   v-on:click="payButtonClick()" type="primary" simple >
                        <i v-if="tokenizing" class="fas fa-spinner fa-spin mr-1"></i>
                        {{ tokenizing ? $t('book.buttons.processing') || 'Processing...' : (walletAwaitingConfirm ? (wallet_pending_method === 'apple_pay' ? $t('book.buttons.confirmWithApplePay') : $t('book.buttons.confirmWithGooglePay')) : $t('book.buttons.completeBooking')) }}</base-button>
                    </div>
                  </div>
                </card>
                <upsell-suggestions v-if="showUpsell && upsellPosition === 'below_form'"
                                    :games="games" :cart="cart" :bss="bss" :locale="locale"
                                    :format-amount="formatUpsellAmount" :cart-id="cart_id" :company-code="$route.params.company" :cart-synced="cart_sync_pending === 0"
                                    @select="selectUpsell" />
              </div>
              <div class="col-lg-3 col-10">
                <card :style="{ 'background-color': bss.card_color}">
                  <div class="row justify-content-center">
                    <base-button :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color }"  v-on:click="tabZero(0)" type="success" class="button-wide no-upper-margin" simple size="sm">
                      {{$t('book.buttons.addAnotherBooking')}}</base-button>
                  </div>
                  <div class="row mt-3" v-if="cart.length > 0">
                    <div class="col-11">
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{$t('book.yourPurchases')}}
                        <i class="tim-icons icon-cart"></i>
                      </h4>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="cart.length <= 0">
                    <div class="col ml-2 mr-2"
                         :style="{'border-radius': '.1875rem', 'min-height' : '100px', 'padding': '20px 0 15px', 'text-align': 'center', 'border': '1px solid ' + bss.button_color }">
                        <span :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: 2em">
                          <i class="fas fa-exclamation-triangle"></i>
                        </span>
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.yourCartIsEmpty')}}</h4>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0">
                    <div class="col-12">
                      <div  v-for="(c, index) in cart" :key="'A' + index">
                        <div v-if="c.hasOwnProperty('gift_card')">
                          <div class="row">
                            <div class="col-3">
                              <img class="game-img" style="object-fit: contain" :src="c.gift_card.design_url.url"/>
                            </div>
                            <div class="col-9">
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                                {{$tc('book.giftCard', 1)}} {{c.gift_card.name}}
                                <base-button
                                  @click="removeBooking(index, c)"
                                  class="like btn-link"
                                  type="danger"
                                  size="sm"
                                  icon
                                ><i class="tim-icons icon-trash-simple"></i>
                                </base-button>
                              </p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.quantity')}}:</span> {{c.gift_card.quantity}}</p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.giftCardValue')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.gift_card.total))}} {{getCurrencyCode(locale.currency)}}</p>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="c.hasOwnProperty('item')">
                          <div class="row">
                            <div class="col-3">
                              <img class="game-img" style="object-fit: contain" :src="c.item.url"/>
                            </div>
                            <div class="col-9">
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                                {{c.item.name}}
                                <base-button
                                  @click="removeBooking(index, c)"
                                  class="like btn-link"
                                  type="danger"
                                  size="sm"
                                  icon
                                ><i class="tim-icons icon-trash-simple"></i>
                                </base-button>
                              </p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.quantity')}}:</span> {{c.item.quantity}}</p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.subtotal')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.item.price))}} {{getCurrencyCode(locale.currency)}}</p>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="row">
                            <div class="col-3"
                                 v-if="c.game.hasOwnProperty('game_images') && c.game.game_images !== null && c.game.game_images.length > 0 ">
                              <img class="game-img" :style="{'object-fit': gameImagesFor(c.game.game_images)[0].object_fit || 'cover'}" v-twin-src="gameImagesFor(c.game.game_images)[0].url"/>
                            </div>
                            <div class="col-9">
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{c.game.game_name}}
                                <base-button
                                  @click="removeBooking(index, c)"
                                  class="like btn-link"
                                  type="danger"
                                  size="sm"
                                  icon
                                ><i class="tim-icons icon-trash-simple"></i>
                                </base-button>
                              </p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.date')}}:</span> {{getDayOfWeek(c.booking.booking_date)}} {{getFormattedDate(locale.date_format, c.booking.booking_date)}}</p>
                              <p v-if="!c.booking.is_all_day" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.time')}}:</span> {{getTime(locale.time_format, c.booking.start_time)}}<span v-if="cartLineEndTime(c)"> {{ $t('book.to') }} {{getTime(locale.time_format, cartLineEndTime(c))}}</span></p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.quantity')}}:</span> {{c.quantity}}</p>
                              <p v-if="ppp" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.rate')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getAmount(ppp)}} {{getCurrencyCode(locale.currency)}} {{$t('book.perPerson')}}</p>
                              <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}"><span class="font-weight-bold">{{$t('book.bookingSubtotal')}}:</span> {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.subtotal))}} {{getCurrencyCode(locale.currency)}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3" v-if="bss.show_promo_code_field === 1">
                    <div class="col">
                      <div style="display: flex; width: 100%;">
                        <base-input :secondary-color="bss.text_color_card" v-model="promo_code"
                                    style="flex-grow: 1; border-radius: 0px;"
                                    :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                                    :placeholder="bss.promo_code_placeholder_text">
                        </base-input>
                        <base-button simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                                     :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                                     v-on:click="applyPromo()">
                          {{$t('book.apply')}}
                        </base-button>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="payment_settings.allow_tipping
                  && ((payment_settings.allow_preset_tipping_options && tipping_options.length > 0)
                  || payment_settings.allow_custom_tipping_options)">
                    <div class="col">
                      <label :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{payment_settings.tip_label}}</label>
                      <base-input :secondary-color="bss.text_color_card" v-if="payment_settings.allow_preset_tipping_options && tipping_options.length > 0">
                        <base-dropdown :style="{'font-family': bss.font_family_card }"
                                       title-classes="form-group form-control" :text-color="bss.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                       :font-family="bss.font_family_card"
                                       :title="tip_title"
                        >
                          <a v-for="(t, i) in tipping_options"  :style="{'font-family': bss.font_family_card }"
                             style="white-space: normal; overflow-wrap: break-word;"
                             class="dropdown-item" href="#" :key="'T' + i" v-on:click.prevent="computeTip(t)">
                            {{ getTipAmount(t) }}</a>
                        </base-dropdown>
                      </base-input>

                      <div style="display: flex; width: 100%;">
                        <base-input
                          v-if="(payment_settings.allow_custom_tipping_options && !payment_settings.allow_preset_tipping_options) || selectedCustomTipOption"
                          :secondary-color="bss.text_color_card" v-model.number="applied_tip_amount"
                          style="flex-grow: 1; border-radius: 0px;"
                          :input-style="{'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.text_color_card,
                              'border-radius': '5px 0px 0px 5px'}"
                          :placeholder="tip_placeholder">
                        </base-input>
                        <base-button v-if="(payment_settings.allow_custom_tipping_options && !payment_settings.allow_preset_tipping_options) || selectedCustomTipOption"
                                     simple style="flex-grow: 0; border-radius: 0px 5px 5px 0px; border-left: none;"
                                     :style="{ 'font-family': bss.font_family_card,
                         'background-color': bss.card_color,
                         'margin-left': '0px', 'margin-top': '0px', 'margin-bottom': '10px',
                         'padding-top': '0px', 'padding-bottom': '0px',
                         'padding-left': '10px', 'padding-right': '10px',
                         'border-color': 'var(--input-border-color, #7d7d7d99)', 'color': bss.button_color }"
                                     v-on:click="computeTip({id: 0, name: 'Custom amount', amount: applied_tip_amount, value_type: payment_settings.custom_tipping_value_type})">
                          {{$t('book.apply')}}
                        </base-button>
                      </div>
                    </div>
                  </div>
                  <hr :style="{ 'background-color': bss.text_color_card}" v-if="cart.length > 0">
                  <div class="row" v-if="cart.length > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.subtotal')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getCartSubtotal()))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-for="(t, i) in taxes" :key="'J' + i" v-if="cart.length > 0 && hasBookingsInCart() &&
                      (t.pricing_type === 0 || (t.pricing_type === 1 && t.show_tax_line_items)) && isTaxApplicableToCart(t)">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{ t.name }} <span v-if="t.pricing_type === 1"> (included)</span>
                      </p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                        {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTax(t)))}} {{getCurrencyCode(locale.currency)}}
                      </p>
                    </div>
                  </div>
                  <div class="row" v-for="(f, i) in fees" :key="'K' + i" v-if="cart.length > 0">
                    <div class="col" v-if="getFee(f) > 0">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ f.name }}</p>
                    </div>
                    <div class="col" v-if="getFee(f) > 0">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getFee(f)))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && applied_tip > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{payment_settings.tip_line_item_label}}
                      </p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(applied_tip))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-for="(p, i) in promo_codes" :key="pc_key + i" v-if="cart.length > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{ p.name }}
                        <!--                        <base-button :style="{'color': bss.text_color_card}" @click="removePromoCode(p)" style="padding: 0; margin: 0"  icon class="btn-link d-inline">-->
                        <i style="cursor: pointer" :style="{'color': bss.text_color_card}" @click="removePromoCode(p)"  class="tim-icons icon-simple-remove"></i>
                        <!--                        </base-button>-->
                      </p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">-{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(p.display_amount != null ? p.display_amount : p.value_amount))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <hr :style="{ 'background-color': bss.text_color_card}" v-if="cart.length > 0">
                  <div class="row" v-if="cart.length > 0">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.total')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTotalAmount()))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-for="(a, i) in applied_gift_cards" :key="pc_key + i + i" v-if="cart.length > 0">
                    <div class="col-8">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$tc('book.giftCard', 1)}} ***{{a.code.slice(-4)}}
                        <i :style="{'color': bss.text_color_card}" style="cursor: pointer" @click="removeGiftCard(a)" class="tim-icons icon-simple-remove"></i>
                      </p>
                      <p v-if="a.balance_from_api !== undefined" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-size': '0.9em', 'opacity': '0.85', 'margin-top': '-10px'}">({{$t('book.remainingBalance')}} {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(a.balance_from_api))}}{{getCurrencyCode(locale.currency)}})</p>
                    </div>
                    <div class="col">
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">-{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(a.remaining))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && (pay_deposit || applied_gift_cards.length > 0)">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{$t('book.dueNow')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card, 'font-weight': 'bold'}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(due_now))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && pay_deposit">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.dueLater')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(due_later))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                  <div class="row" v-if="cart.length > 0 && pay_on_arrival">
                    <div class="col">
                      <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.dueNow')}}</p>
                    </div>
                    <div class="col" >
                      <p style="float:right" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(0))}} {{getCurrencyCode(locale.currency)}}</p>
                    </div>
                  </div>
                </card>
                <upsell-suggestions v-if="showUpsell && upsellPosition === 'below_cart'" compact
                                    :games="games" :cart="cart" :bss="bss" :locale="locale"
                                    :format-amount="formatUpsellAmount" :cart-id="cart_id" :company-code="$route.params.company" :cart-synced="cart_sync_pending === 0"
                                    @select="selectUpsell" />
              </div>
            </div>
          </wizard-tab>
          <wizard-tab :before-change="() => wizardComplete()">
            <template slot="label">
              <!--              <span :style="{'color': bss.text_color_card, 'font-weight': 'bold', 'font-size': 'large'}">5</span>-->

              <i class="tim-icons icon-check-2"></i>
              <p class="d-sm-block d-none" v-show="bss.display_section_titles" :style="{'font-family': bss.font_family, 'color': bss.text_color}">{{$t('book.review')}}</p>
            </template>
            <div v-show="!loading" class="row justify-content-center">
              <div class="col-lg-6 col-10">
                <card :style="{ 'background-color': bss.card_color}">
                  <div class="row ml-1 mr-1 justify-content-center">
                    <h3 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" class="card-title">{{getDynamicString(bss.confirmation_message)}}</h3>
                  </div>
                  <div class="row ml-1 mr-1 justify-content-center" v-if="isBookingRequest">
                    <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.requestPendingApprovalInfo')}}</p>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col">
                      <hr class="white-content">
                      <h4 :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.bookingDetails')}}</h4>

                      <div v-if="order_number" class="row mt-3 mr-2 justify-content-end">
                        <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">{{$t('book.orderReference')}}: #{{order_number}}</p>
                      </div>
                      <div v-if="order_number" class="row mr-2 justify-content-end">
                        <p v-if="isBookingRequest"
                           :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{$t('book.requestStatus')}}: <span class="text-warning text-uppercase">{{$t('book.requestStatusPending')}}</span>
                        </p>
                        <p v-if="!pay_on_arrival && !pay_deposit && !isCustomPaymentUnpaid && !isBookingRequest"
                           :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{$t('book.paymentStatus')}}: <span class="text-success text-uppercase">{{$t('book.paid')}}</span>
                        </p>
                        <p v-if="!pay_on_arrival && pay_deposit && !isCustomPaymentUnpaid && !isBookingRequest"
                           :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{$t('book.paymentStatus')}}: <span class="text-warning text-uppercase">{{$t('book.partiallyPaid')}}</span>
                        </p>
                        <p v-if="pay_on_arrival && !isBookingRequest"
                           :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{$t('book.paymentStatus')}}: <span v-if="applied_gift_cards.length <= 0" class="text-danger">{{$t('book.unpaid')}}</span>
                          <span v-if="applied_gift_cards.length > 0" class="text-warning">{{$t('book.partiallyPaid')}}</span>
                        </p>
                        <p v-if="isCustomPaymentUnpaid && !isBookingRequest"
                           :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}">
                          {{$t('book.paymentStatus')}}: <span class="text-danger text-uppercase">{{$t('book.unpaid')}}</span>
                        </p>
                      </div>

                      <div class="row mt-3" v-for="(c, index) in cart" :key="'RP' + index">
                        <div v-if="c.hasOwnProperty('gift_card')">
                          <div class="col-12">
                            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                              <span >{{$tc('book.giftCard', 1)}}</span> {{$t('book.forTheAmountOf')}} {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(c.gift_card.total))}} {{getCurrencyCode(locale.currency)}}
                            </p>
                          </div>
                          <div class="col-12">
                            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{$t('book.quantity')}}: {{c.gift_card.quantity}}
                            </p>
                          </div>
                        </div>
                        <div v-else-if="c.hasOwnProperty('item')">
                          <div class="col-12">
                            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                              <span >{{c.item.name}}</span> x{{c.item.quantity}}
                            </p>
                          </div>
                        </div>
                        <div v-else>
                          <div class="col-12">
                            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                              <span>{{c.game.game_name}}</span>: <span  v-if="!c.booking.is_all_day">{{getTime(locale.time_format, c.booking.start_time)}}<span v-if="cartLineEndTime(c)"> {{ $t('book.to') }} {{getTime(locale.time_format, cartLineEndTime(c))}}</span>,</span> {{getDayOfWeek(c.booking.booking_date)}} {{getFormattedDate(locale.date_format, c.booking.booking_date)}}
                            </p>
                          </div>
                          <div class="col-12">
                            <p :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">{{$t('book.quantity')}}: {{c.quantity}}
                            </p>
                          </div>
                        </div>

                      </div>
                      <div class="row">
                        <div class="col-12">
                          <p v-if="due_now > 0 || applied_gift_cards.length > 0" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                            {{$t('book.amountPaid')}}: {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(getTotalAmount() - due_later))}} {{getCurrencyCode(locale.currency)}}
                          </p>
                          <p v-if="due_later > 0" :style="{'font-family': bss.font_family_card, 'color': bss.text_color_card}" style="font-size: medium">
                            {{$t('book.amountDue')}}: {{getCurrencySymbol(locale.currency)}}{{getNumberFormat(getAmount(due_later))}} {{getCurrencyCode(locale.currency)}}
                          </p>
                        </div>
                      </div>
                      <div class="row justify-content-center mt-3" v-if="!bss.auto_redirect">
                        <div class="col-12 col-lg-6">
                          <base-button :style="{ 'font-family': bss.font_family_card, 'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"  v-on:click="goHome()" simple>
                            {{ bss.redirect_button_text }}</base-button>
                          <base-button v-if="hasBookingsInCart() && bss.display_waiver_link && bss.waivers_enabled"
                                       :style="{ 'font-family': bss.font_family_card,
                                       'border-color': bss.button_color, 'color': bss.button_color, 'width': '100%' }"
                                       v-on:click="goToCheckIn()" class="button-wide" simple>{{$t('book.checkIn')}}</base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import { SimpleWizard, WizardTab } from 'src/components'
import SelectGame from "@/pages/Bookings/SelectGame";
import swal from 'sweetalert2'
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import axios from "axios";
import { parseGameImages, MOBILE_BREAKPOINT } from '@/util/gameImages'
import gameImageOrientation from '@/mixins/gameImageOrientation'

import {Input, Button, Carousel, CarouselItem} from "element-ui";
import {formattedDate, date, time, dayOfWeek} from "@/plugins/dateFormatter";
import {syncServerNow, getNow} from "@/util/serverTime";
import NotFoundPage from "../../pages/GeneralViews/NotFoundPage";
import _ from "lodash";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import gbLocale from '@fullcalendar/core/locales/en-gb';
import currencies from "@/assets/currencies.json";
import countries from "@/assets/countries.json";
import EventRatings from '@/components/EventRatings.vue'
import es from '@fullcalendar/core/locales/es';
import fr from '@fullcalendar/core/locales/fr';
import sv from '@fullcalendar/core/locales/sv';
import el from '@fullcalendar/core/locales/el';
import da from '@fullcalendar/core/locales/da';
import moment from "moment";
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import SMSConsent from '@/components/SMSConsent.vue';
import emailTypoWarning from '@/mixins/emailTypoWarning';
import { getSmsConsentVenue, SMS_PLATFORM_NAME } from '@/util/smsConsent';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { setLocale, applyPageLocale } from '@/i18n';
import EnhancedPaymentForm from "@/components/Payments/EnhancedPaymentForm";
import { isValidEmail as validateEmail } from '@/util/emailValidator';
import { showPromoFieldOnInfoStep } from '@/util/promoFieldVisibility';
import { cardFormCompleteEnablesSubmit, giftCardBalanceBlocksSubmit } from '@/util/paymentGate';
import { inputBorderColor, inputBorderColorSolid, sdkPalette } from '@/util/bookingTheme';
import EventSelectionList from '@/pages/Bookings/EventSelectionList';
import EventSelectionCalendar from '@/pages/Bookings/EventSelectionCalendar';
import UpsellSuggestions from '@/pages/Bookings/UpsellSuggestions';
import { BookingWebSocket } from '@/util/bookingWebSocket';

export default {
  name: "CreateBooking",
  mixins: [gameImageOrientation, emailTypoWarning],
  components: {
    SimpleWizard,
    WizardTab,
    SelectGame,
    [Input.name]: Input,
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    NotFoundPage,
    FullCalendar,
    EventRatings,
    PhoneNumberInput,
    // Explicit kebab key: Vue resolves <sms-consent> to "SmsConsent", which
    // would not match a bare "SMSConsent" registration.
    'sms-consent': SMSConsent,
    EnhancedPaymentForm,
    EventSelectionList,
    EventSelectionCalendar,
    UpsellSuggestions,
    LanguageSwitcher
  },
  data() {
    return {
      // A2P 10DLC opt-in. Both default false: carriers reject any campaign whose
      // consent box is pre-checked, so never seed these from anything.
      smsTransactionalConsent: false,
      smsMarketingConsent: false,
      smsConsentText: null,
      isCustomPaymentUnpaid: false,
      infoFlippedGameIds: [],
      windowWidth: window.innerWidth,
      bookingSubmitted: false,
      book_entire_slot: false,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      referer: null,
      stripe_payment_method: 'card',
      wallet_pending_response: null,
      wallet_pending_method: null,
      expressCheckoutElement: null,
      expressCheckoutAvailable: false,
      // The pending Express Checkout confirm event. Stripe keeps the wallet
      // sheet in a processing state until confirmPayment runs or
      // event.paymentFailed() is called; this holds the event so failure
      // paths can release the sheet.
      eceConfirmEvent: null,
      paymentElement: null,
      has_addons: false,
      show_addons: false,
      payment_intent_amount: 0,
      addons: [],
      lastSentHeight: 0, // Cache last height to prevent loops
      observer: null,
      scrollDebounceTimer: null, // Debounce timer for scroll postMessage
      gift_card_settings_init: '',
      gift_card_types: [],
      gift_card_games: [],
      all_gift_card_games: [],
      selectedGiftCardType: '',
      selectedCf: '',
      applied_tip: 0,
      applied_tip_amount: '',
      tip_title: this.$t('book.tipAmount'),
      selectedCustomTipOption: false,
      tipping_options: [],
      tip_placeholder: this.$t('book.tipAmountPercent'),
      applied_gift_cards: [],
      payment_methods: [],
      gift_card_link: false,
      cart_id: '',
      parentHandlesPixel: false,
      pixelHandshakeTimer: null,
      pixelHandshakeListener: null,
      pixelHandshakeRetries: [],
      is_gift_card: false,
      gift_card_code: '',
      selectedPaymentOption: {id: 0, name: ''},
      disable_submit: true,
      selectedPolicy: '',
      modals: { policy: false, dropdown_popup: false },
      embeddedModalTop: 0, // document offset where an embedded popup is placed (embedded only)
      popupOption: null,
      custom_fields: [],
      payment_intent_id: '',
      gc_key: 0,
      gift_card_settings: {},
      gift_card_designs: [],
      gift_card_amounts: [],
      buttonGroupStyle: [],
      buttonGroupPriceStyle: [],
      gift_card: {
        personal_message: '',
        design_url: '',
        custom_amount: '',
        recipient_first_name: '',
        recipient_last_name: '',
        recipient_email: '',
        total: 0,
        unit_price: 0,
        unit_value: 0,
        quantity: 1,
        send_to_self: 0,
        send_instantly: true,
        delivery_date: new Date(),
        terms: false
      },
      selected_gift_card_amount: '',
      gift_card_select: false,
      rows: 0,
      currencies: currencies.currencies,
      value: new Date(),
      bss: {
        background_color: "#f0f0f0",
        layout_type_id: null,
      },
      locale: '',
      hash: '',
      notFound: false,
      day_of_week: '',
      promo_code: '',
      promo_codes: [],
      upsell_prefill_quantity: null,
      upsell_promo_pending: null,
      // Cart syncs to the server still in flight: the upsell card asks the promo
      // endpoint about the server cart, so it waits until this is zero
      cart_sync_pending: 0,
      monday: '',
      sunday: '',
      subtotal: 0,
      number_of_players: 0,
      loading: false,
      empty: false,
      games: '',
      pricing: '',
      ppp: '',
      booking_slots: '',
      incrementCount: 0,
      selectedGame: {
        difficulty_level: 0
      },
      selectedBooking: '',
      cart: [],
      week: [],
      is_authenticated: false,
      day: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
      month: ["January","February","March","April","May","June","July",
        "August","September","October","November","December"],
      country: '',
      countries: countries.countries,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phoneE164: '',
        phoneValidationStatus: 'valid',
        phoneValidationMessage: '',
        phoneBlurred: false,
        address_line_1: '',
        address_line_2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      },
      payment: {
        amount: '',
        cardNumber: '',
        expirationDate: '',
        cardCode: '',
        zip: '',
        cardholder_first_name: '',
        cardholder_last_name: ''
      },
      authorize_opaque_data: null,
      authorize_zip: null,
      tokenizing: false,
      order_number: '',
      timestamp: '',
      emailBlurred: false,
      giftEmailBlurred: false,
      errors: {
        gift_card_code: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address_line_1: '',
        city: '',
        state: '',
        customer_zip: '',
        ccn: '',
        zip: '',
        expiration: '',
        cvv: '',
        cardholder_first_name: "",
        cardholder_last_name: "",
        number_of_players: '',
        gift_card: {
          email: '',
          first_name: '',
          last_name: '',
          custom_amount: '',
          terms: ''
        }
      },
      j: 0,
      pay_on_arrival: false,
      allow_pay_on_arrival: false,
      isBookingRequest: false,
      allow_deposit: false,
      require_deposit: false,
      pay_deposit: false,
      deposit: 0,
      due_now: 0,
      due_later: 0,
      taxes: [],
      fees: [],
      pricing_categories: [],
      price_settings: '',
      // Multiple durations: every row the pricing call returned, the offered durations, the chosen one
      pricing_all: [],
      durations: [],
      selected_duration: null,
      base_pricing: false,
      payment_settings: '',
      save_card_for_future: false,
      card: '',
      elements: '',
      prevent_submit: false,
      stripeElementReady: true,
      stripe: '',
      square: '',
      squareAppId: '',
      squareLocationId: '',
      currentDay: '',
      currentTime: '',
      pc_key: 0,
      show_calendar: false,
      calendar_loading: false,
      time_slot_key: 0,
      min_period: {},
      nowTick: getNow().getTime(),
      calendarOptions: {
        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
        initialView: 'timeGridWeek',
        allDaySlot: false,
        // Registered locale packs; `locale` is the ISO code so it resolves against these
        locales: [ gbLocale, es, fr, sv, el, da ],
        locale: this.$i18n.locale,
        firstDay: 1,
        headerToolbar: {
          left: '',
          right: '' // Replace 'title' with your custom title
        },
        views: {
          timeGridDay: { // name of view
            titleFormat: { year: '2-digit', month: '2-digit', day: '2-digit' }
            // other view-specific options here
          }
        },
        scrollTime: '10:00:00',
        stickyHeaderDates: true,
        // auto: no internal scrollbar; the grid lays out at full height and the
        // page scrolls, with the day-header row staying sticky.
        height: 'auto',
        initialEvents: [],
        slotDuration: '00:30:00',
        slotLabelInterval: 30,
        slotLabelFormat: function (date) {
          let hour = date.date.hour
          let dd = 'AM'
          if (date.date.minute == 0){
            if (parseInt(hour) >= 12) {
              hour = parseInt(date.date.hour) - 12;
              dd = 'PM'

            }
            if (hour == 0) {
              hour = 12;
            }
            return hour + ':00 ' + dd
          }
        },
        datesSet: this.getBookingSlots,
        eventClick: this.handleEventClick,
        eventContent: this.renderCalendarEvent,
        eventDidMount: this.styleCalendarEvent,
        dayHeaderContent: this.renderCalendarDayHeader,
        editable: true,
        selectable: false,
      },
      calendarHooks: {
        dayCellContent({ date, dayEl }) {
          if (date.toDateString() === getNow().toDateString()) {
            dayEl.style.backgroundColor = 'transparent';
          }
        },
      },
    }
  },
  computed: {
    isEmbedded() {
      return window !== window.top
    },
    allowRequestToBook(){
      return Number(this.bss && this.bss.allow_request_to_book) === 1
    },
    // The cart holds a booking request (request carts are single purpose, so
    // this doubles as "this checkout IS a request").
    // Upsell card: shown once a booking is in the cart, never beside a booking
    // request (a request must be alone in its cart)
    showUpsell(){
      return Number(this.bss.show_upsell_section) === 1 && this.cart.length > 0 && !this.cartHasRequest
    },
    // Where the template places the upsell card on the details and payment steps
    upsellPosition(){
      const position = this.bss.upsell_position
      return position === 'below_form' || position === 'below_cart' ? position : 'above_form'
    },
    cartHasRequest(){
      return Array.isArray(this.cart) && this.cart.some(c => c && c.booking && c.booking.is_request_booking)
    },
    // Requests in on_approval mode capture nothing at checkout: card fields
    // and gift card redemption are hidden exactly the way pay on arrival
    // hides them.
    requestNoCapture(){
      return this.cartHasRequest && this.bss.request_to_book_payment_mode === 'on_approval'
    },
    noCaptureCheckout(){
      return this.pay_on_arrival || this.requestNoCapture
    },
    smsConsentVenue() {
      return getSmsConsentVenue(this.$route.params.company);
    },
    // Shown only where a phone number is actually collected, and only for
    // venues registered for A2P messaging.
    showSmsConsent() {
      if (this.phoneFieldMode === 'hidden') return false;
      return this.smsConsentVenue !== null;
    },
    // Registered legal business name, not the display name: a mismatch against
    // the brand registration is what Twilio error 30927 flags on review.
    smsBusinessName() {
      return this.smsConsentVenue ? this.smsConsentVenue.businessName : '';
    },
    smsPlatformName() {
      return SMS_PLATFORM_NAME;
    },
    smsPrivacyUrl() {
      return this.smsConsentVenue ? this.smsConsentVenue.privacyUrl : '';
    },
    smsTermsUrl() {
      return this.smsConsentVenue ? this.smsConsentVenue.termsUrl : '';
    },
    expressCheckoutEnabled(){
      // Express checkout live for all Stripe venues (full launch 2026-07-29).
      return true
    },
    walletAwaitingConfirm(){
      return this.wallet_pending_response !== null
    },
    // Opaque input-border color for payment SDKs / inline gateway styles
    // (Stripe appearance, Square card style, Authorize.net inputs) which can't
    // read the --input-border-color CSS var.
    inputBorderSolid(){
      return inputBorderColorSolid(this.bss)
    },
    hasVisibleCustomFields(){
      return (this.custom_fields || []).some(cf => this.isFieldVisibile(cf))
    },
    // Minimum booking notice countdown (OTC-1767) ----------------------------
    bookingNoticeCountdownEnabled(){
      return !!(this.bss && (this.bss.show_booking_notice_countdown === true || this.bss.show_booking_notice_countdown === 1))
    },
    bookingNoticeWindowSeconds(){
      const m = parseInt(this.bss && this.bss.booking_notice_countdown_minutes)
      return (isNaN(m) ? 15 : m) * 60
    },
    // Earliest close deadline across every booking currently in the cart (whole-cart).
    cartCloseDeadline(){
      if(!Array.isArray(this.cart)) return null
      let earliest = null
      for(const item of this.cart){
        if(!item || !item.booking) continue   // skip gift card / standalone item entries
        const deadline = this.getSlotCloseDeadline(item.booking)
        if(deadline && (earliest === null || deadline < earliest)){
          earliest = deadline
        }
      }
      return earliest
    },
    bookingNoticeSecondsRemaining(){
      if(!this.cartCloseDeadline) return null
      return Math.floor((this.cartCloseDeadline.getTime() - this.nowTick) / 1000)
    },
    bookingNoticeExpired(){
      const remaining = this.bookingNoticeSecondsRemaining
      return remaining !== null && remaining <= 0
    },
    showBookingNoticeCountdown(){
      if(this.order_number) return false   // booking confirmed — hide the countdown
      if(!this.bookingNoticeCountdownEnabled) return false
      const remaining = this.bookingNoticeSecondsRemaining
      if(remaining === null) return false
      // Appear once inside the configured window; keep the expired message up
      // briefly (5 min) after the cutoff, then hide.
      return remaining <= this.bookingNoticeWindowSeconds && remaining > -300
    },
    bookingNoticeCountdownText(){
      let remaining = this.bookingNoticeSecondsRemaining
      if(remaining === null || remaining < 0) remaining = 0
      const minutes = Math.floor(remaining / 60)
      const seconds = remaining % 60
      return minutes + ':' + (seconds < 10 ? '0' + seconds : seconds)
    },
    bookingNoticeBannerStyle(){
      const accent = (this.bss && this.bss.button_color) || '#e14eca'
      const isHex6 = /^#[0-9a-fA-F]{6}$/.test(accent)
      return {
        color: accent,
        borderColor: accent,
        backgroundColor: isHex6 ? accent + '1f' : 'rgba(225,78,202,0.12)',
        fontFamily: (this.bss && this.bss.font_family) || undefined
      }
    },
    // Corner placement for the "learn more" trigger on card layout (OTC-2477)
    gameInfoTriggerPositionStyle(){
      const pos = (this.bss && this.bss.game_info_trigger_position) || 'bottom-right'
      const v = pos.startsWith('top') ? { top: '8px', bottom: 'auto' } : { bottom: '8px', top: 'auto' }
      const h = pos.endsWith('left') ? { left: '8px', right: 'auto' } : { right: '8px', left: 'auto' }
      return { ...v, ...h }
    },
    // Built-in customer info field modes (per booking site template, OTC-2035)
    phoneFieldMode(){
      return (this.bss && this.bss.phone_field_mode) || 'required'
    },
    addressFieldMode(){
      return (this.bss && this.bss.address_field_mode) || 'hidden'
    },
    zipFieldMode(){
      // When the address block is shown, zip is collected there instead
      if(this.addressFieldMode !== 'hidden') return 'hidden'
      return (this.bss && this.bss.zip_field_mode) || 'hidden'
    },
    // Email pairs with whichever single field shares its row (phone or zip);
    // with both or neither visible it spans the full width and zip + phone
    // wrap onto their own row together
    emailColumnClass(){
      const phoneShown = this.phoneFieldMode !== 'hidden'
      const zipShown = this.zipFieldMode !== 'hidden'
      return phoneShown !== zipShown ? 'col-12 col-lg-6' : 'col-12'
    },
    cityFieldLabel(){
      return (this.country && this.country.city_label) || this.$t('book.placeholders.city')
    },
    stateFieldLabel(){
      return (this.country && this.country.state_label) || this.$t('book.placeholders.state')
    },
    zipFieldLabel(){
      return (this.country && this.country.zip_label) || this.$t('book.placeholders.zipCode')
    },
    zipFieldPlaceholder(){
      return (this.country && this.country.zip_placeholder) || ''
    },
    selectedAddressCountryName(){
      const match = _.find(this.countries, { code: this.user.country })
      return match ? match.name : ''
    },
    hasNotBeenBooked(){
      try {
        return this.selectedBooking.group_size === 0
      } catch (e) {
        return false;
      }
    },
    allowReservationTypeUpgrade(){
      try {
        return this.price_settings.allow_reservation_type_upgrade || false;
      } catch (e) {
        return false;
      }
    },
    pickerOptions() {
      return {
        disabledDate: (time) => this.disabledDates(time, this.current),
        // group setting is 0-6 (Sunday=0, FullCalendar convention); Element UI wants 1-7 (Sunday=7)
        firstDayOfWeek: this.locale.first_day_of_week === 0 ? 7 : this.locale.first_day_of_week
      };
    },
    isMobile() {
      const userAgent = navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return mobileRegex.test(userAgent);
    },
    isMobileViewport() {
      return this.windowWidth <= MOBILE_BREAKPOINT
    },
    requireCardSaveForced() {
      if (!this.payment_settings.store_credit_card) return false
      // Mandatory deposit + venue-side deposit flag → no choice, info text shown
      if (this.payment_settings.require_card_for_deposit && this.require_deposit) return true
      // No deposit branch (booking doesn't require it and customer isn't opting in) +
      // venue-side full-payment flag → no choice, info text shown
      if (this.payment_settings.require_card_for_full_payment && !this.pay_deposit && !this.require_deposit) return true
      // Cross-product: both flags on + opted-in optional deposit → no escape
      // (toggling deposit off would just hit the full-payment force), info text shown
      if (this.payment_settings.require_card_for_deposit && this.payment_settings.require_card_for_full_payment && this.pay_deposit) return true
      return false
    },
    depositLayout() {
      // Anything that isn't a known new layout renders the classic checkbox —
      // covers NULL/undefined from templates created before the column existed
      return ['buttons', 'cards'].includes(this.bss.deposit_layout_type) ? this.bss.deposit_layout_type : 'checkbox'
    },
    hasCustomDepositText() {
      return Boolean(this.bss.enable_deposit_text && this.bss.deposit_text && this.bss.deposit_text.trim())
    },
    hasAddonsHeaderText() {
      return Boolean((this.bss.addons_title && this.bss.addons_title.trim()) || (this.bss.addons_subtext && this.bss.addons_subtext.trim()))
    },
    depositDueNow() {
      return Math.min(this.deposit, this.getTotalAmount())
    },
    depositDueLater() {
      return Math.max(0, this.getTotalAmount() - this.depositDueNow)
    },
  },
  watch: {
    // The guest language switcher changes $i18n.locale after mount; keep the
    // week calendar's day and month names in step with it.
    '$i18n.locale'(newLocale) {
      this.calendarOptions.locale = newLocale
    },
    games() {
      this.probeGameImageOrientations()
    },
    selectedGame() {
      this.probeGameImageOrientations()
    },
    // The mobile device filter changes which images display, so re-probe on
    // breakpoint crossing (mobile-only images are unseen while on desktop).
    isMobileViewport() {
      this.probeGameImageOrientations()
    },
    save_card_for_future(newVal) {
      if (newVal) return
      if (this.requireCardSaveForced) {
        // No graceful escape: re-force on next tick.
        this.$nextTick(() => { this.save_card_for_future = true })
        return
      }
      // Legacy escape: unchecking save while in optional-deposit mode reverts to
      // full payment. Only available if full payment doesn't also require save.
      if (this.payment_settings.require_card_for_deposit && this.pay_deposit && !this.payment_settings.require_card_for_full_payment) {
        this.pay_deposit = false
        this.recalculatePromos('deposit')
      }
    },
    pay_deposit(newVal) {
      this.invalidateWalletPending()
      if (newVal && this.payment_settings.require_card_for_deposit && !this.save_card_for_future) {
        this.save_card_for_future = true
      } else if (!newVal && this.payment_settings.require_card_for_full_payment && !this.save_card_for_future) {
        this.save_card_for_future = true
      }
    },
  },
  methods: {
    // Verbatim wording the customer saw, stored alongside the consent row so a
    // later dispute is answered with what was actually shown, not with whatever
    // the current build renders.
    onSmsConsentText(snapshot) {
      this.smsConsentText = snapshot;
    },
    // Returns nothing when the checkbox was never rendered. The backend treats
    // an absent field as "never asked" and writes no consent row; sending
    // `false` from a site that has no checkbox would record a refusal the
    // customer was never given the chance to make.
    smsConsentPayload() {
      if (!this.showSmsConsent) return {};
      return {
        sms_transactional_consent: this.smsTransactionalConsent,
        sms_marketing_consent: this.smsMarketingConsent,
        sms_consent_text: this.smsConsentText
      };
    },
    isSlotSoldOut(s, game) {
      if (s.online_display_mode === 'non_bookable') return true
      if (s.is_resource_saturated) return true
      if (s.status === 'booked' && (s.is_reservation_upgraded || !this.isPublicBooking(game, s) || (this.isPublicBooking(game, s) && !this.hasRemainingSlots(game, s)))) return true
      return false
    },
    shouldShowSlotBadge(s, game) {
      if (!s.custom_message || !s.custom_message_active || s.custom_message_display !== 'badge') return false
      if (this.bss.hide_custom_message_when_sold_out && this.isSlotSoldOut(s, game)) return false
      return true
    },
    shouldUseCustomText(s, game) {
      if (!s.custom_message || !s.custom_message_active || s.custom_message_display !== 'text') return false
      if (this.bss.hide_custom_message_when_sold_out && this.isSlotSoldOut(s, game)) return false
      return true
    },
    onDepositToggle() {
      this.recalculatePromos('deposit')
    },
    setPayDeposit(value) {
      // Re-clicking the already-active option must not re-fire — recalculatePromos
      // clears applied gift cards and re-fetches every promo
      if (this.pay_deposit === value) return
      this.pay_deposit = value
      this.onDepositToggle()
    },
    // The "Learn more" panel shows the short booking-page highlight, falling back to the full
    // event description when the highlight is blank. The full description is still used on the
    // checkout description card (step 2).
    resolvedGameDescription(game) {
      const short = game.game_short_description || ''
      const hasShort = short.replace(/<[^>]*>/g, '').trim() !== '' || /<img\b/i.test(short)
      return hasShort ? short : (game.game_description || '')
    },
    hasGameDescription(game) {
      const html = this.resolvedGameDescription(game)
      return html.replace(/<[^>]*>/g, '').trim() !== '' || /<img\b/i.test(html)
    },
    showInfoTrigger(game) {
      return !!this.bss.show_game_description && this.hasGameDescription(game)
    },
    isGameInfoOpen(game) {
      return this.infoFlippedGameIds.includes(game.game_id || game.id)
    },
    toggleGameInfo(game) {
      const id = game.game_id || game.id
      if (this.infoFlippedGameIds.includes(id)) {
        this.infoFlippedGameIds = this.infoFlippedGameIds.filter(x => x !== id)
      } else {
        this.infoFlippedGameIds = [...this.infoFlippedGameIds, id]
      }
    },
    // UTM tracking persistence utilities
    // Keyed per venue: every venue's booking page shares the offthecouch.io origin,
    // so a single key would credit one venue's ad campaign to another venue's booking.
    utmStorageKey() {
      return 'utm_tracking_' + this.$route.params.company
    },
    saveUTMToStorage(utmData) {
      const storageData = {
        utm_source: utmData.utm_source,
        utm_medium: utmData.utm_medium,
        utm_campaign: utmData.utm_campaign,
        referer: utmData.referer,
        timestamp: new Date().getTime()
      };
      localStorage.setItem(this.utmStorageKey(), JSON.stringify(storageData));
    },
    getUTMFromStorage() {
      // Drop the legacy cross-venue key so it can never be read again
      localStorage.removeItem('utm_tracking');

      const key = this.utmStorageKey();
      const stored = localStorage.getItem(key);
      if (!stored) return null;

      try {
        const data = JSON.parse(stored);
        const expirationTime = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
        const now = new Date().getTime();

        // Check if data has expired
        if (now - data.timestamp > expirationTime) {
          localStorage.removeItem(key);
          return null;
        }

        return data;
      } catch (e) {
        console.error('Error parsing UTM storage:', e);
        localStorage.removeItem(key);
        return null;
      }
    },
    clearUTMFromStorage() {
      localStorage.removeItem(this.utmStorageKey());
    },
    getDisplayTime(slot, format) {
      if (slot.is_all_day) {
        return slot.all_day_text || this.$t('book.allDay');
      }
      return this.getTime(format, slot.start_time);
    },
    toggleUpgradeReservationType(){
      this.errors.number_of_players = ''
      this.book_entire_slot = !this.book_entire_slot
      if(this.book_entire_slot){
        this.applyUpgradeSubtotal()
      } else {
        this.getSubtotal()
      }
    },
    // Subtotal for an upgraded (whole-slot) reservation. Buyout replaces the
    // per-ticket total with a flat fee; tickets+fee charges normal per-ticket
    // pricing PLUS the fixed private booking fee. Mirrors the console's
    // applyPrivateUpgrade so the customer site and console stay in lockstep.
    applyUpgradeSubtotal(){
      const mode = this.price_settings.reservation_upgrade_pricing_mode || 'buyout'
      const fee = parseFloat(this.price_settings.reservation_upgrade_fee) || 0
      if(mode === 'tickets_plus_fee'){
        this.getSubtotal() // sets this.subtotal (per-ticket) + this.number_of_players
        this.subtotal = Number(Math.round(Number((this.subtotal + fee) + 'e2')) + 'e-2')
      } else {
        this.subtotal = fee
        this.updateTotalPlayerCount()
      }
    },
    handlePhoneUpdate(phoneData) {
      this.user.phoneE164 = phoneData.e164;
      this.user.phoneValidationStatus = phoneData.validationStatus || 'valid';
      this.user.phoneValidationMessage = phoneData.validationMessage || '';
    },
    sanitizeNameInput(name) {
      if (!name || typeof name !== 'string') return '';

      // Normalize spacing
      name = name.trim().replace(/\s+/g, ' ');

      // Disallow email addresses
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(name)) return '';

      // Disallow phone numbers (7+ digits)
      const digitsOnly = name.replace(/[\s\-\(\)+]/g, '');
      if (/^\d{7,}$/.test(digitsOnly)) return '';

      // Require at least one valid letter (Latin or Greek)
      if (!/[a-zA-Z\u0370-\u03FF\u1F00-\u1FFF]/.test(name)) return '';

      // Disallow common bad values
      const bad = ['n/a', 'na', 'test', 'unknown', 'none'];
      if (bad.includes(name.toLowerCase())) return '';

      // Enforce length limits
      if (name.length < 2 || name.length > 100) return '';

      return name;
    },
    isValidEmail(email) {
      // Use centralized email validator utility with comprehensive TLD whitelist
      return validateEmail(email);
    },
    getDynamicString(string){
      if(!string){
        return ''
      }
      string = string.replaceAll('[Company Name]', this.bss.company_name)
      string = string.replaceAll('[Company Group Name]', this.bss.company_group_name)
      return string
    },
    decrementAddonQuantity(item){
      if(item.quantity > 0){
        item.quantity--
      }
      item.subtotal = item.price * item.quantity
    },
    incrementAddonQuantity(item){
      if(item.enforce_purchase_limit && item.quantity >= item.max_purchase_quantity){
        return
      }
      if((!item.unlimited_available_quantity && item.quantity < item.available) || item.unlimited_available_quantity){
        item.quantity++
      }
      item.subtotal = item.price * item.quantity
    },
    selectGiftCardType(type, event){
      if(event){
        event.preventDefault()
      }

      this.selectedGiftCardType = type
      this.gift_card_designs = JSON.parse(this.selectedGiftCardType.designs)
      this.gift_card.design_url = this.gift_card_designs[0]
      //Fixed values
      if(this.selectedGiftCardType.value_type === 0 || this.selectedGiftCardType.value_type === 2){
        this.gift_card.custom_amount = ''
        this.gift_card.unit_value = 0
        this.gift_card.total = 0
      }
      if(this.selectedGiftCardType.value_type === 1){
        this.gift_card.unit_value = this.selectedGiftCardType.redemption_amount
        this.gift_card.unit_price = this.selectedGiftCardType.price
        this.gift_card.total = this.gift_card.unit_price * this.gift_card.quantity
      }

      // Filter games based on linked_game_ids
      if(this.selectedGiftCardType.value_type === 2){
        const linked = this.selectedGiftCardType.linked_game_ids || []
        if(linked.length > 0){
          this.gift_card_games = this.all_gift_card_games.filter(g => linked.includes(g.game_id))
        } else {
          this.gift_card_games = this.all_gift_card_games
        }

        // Auto-calculate mode: auto-select the single linked game
        if(this.selectedGiftCardType.game_display_mode === 1 && this.gift_card_games.length > 0){
          this.getGiftCardTotal('game', this.gift_card_games[0])
        }
      }

      this.gc_key++
    },
    evaluateGCPaymentMethodValidity(payment_method){
      let cartHasGC = false
      for(let n in this.cart){
        if(this.cart[n].hasOwnProperty('gift_card')){
          cartHasGC = true
        }
      }
      if(payment_method.display_name === 'Gift card'
        && !this.payment_settings.allow_gift_card_purchase_on_gift_card
        && cartHasGC){
        return false
      }
      return true
    },
    handleCustomFieldInput(field){
      let ready = false
      if(field.interaction_required){
        let total_field_count = 0
        let interactive_count = 0
        let links = field.external_links

        for(let n in links){
          total_field_count++
          if(links[n].user_interaction){
            interactive_count++
          }
        }

        let policies = field.policies
        for(let n in policies){
          total_field_count++
          if(policies[n].user_interaction){
            interactive_count++
          }
        }
        if(total_field_count === interactive_count){
          ready = true
          field.error = ""
        } else {
          ready = false
          field.customer_response = false
          field.error = "Please read all attached policies"
        }
        this.j++
      } else {
        ready = true
      }
      return ready
    },
    recordInteraction(item){
      item.user_interaction = 1
    },
    // Promo box on the information step (the payment step always shows it).
    // Reads payment_methods directly: payOnArrivalRequired() has side effects.
    promoFieldOnInfoStep(){
      return showPromoFieldOnInfoStep({
        showField: this.bss.show_promo_code_field,
        position: this.bss.promo_code_field_position,
        total: this.getTotalAmount(),
        payOnArrivalRequired: Array.isArray(this.payment_methods) && this.payment_methods.some(pm => pm && pm.id === -1)
      })
    },
    payOnArrivalRequired(){
      for(let n in this.payment_methods){
        if(this.payment_methods[n].id === -1){
          this.pay_on_arrival = true
          this.pay_deposit = false
          return true
        }
      }
      return false
    },
    computeTip(tip){
      this.invalidateWalletPending()
      if(tip.id === 0 && !this.selectedCustomTipOption && this.payment_settings.allow_preset_tipping_options){
        this.tip_title = tip.name
        this.selectedCustomTipOption = true
        return
      } else {
        this.selectedCustomTipOption = false
      }
      if(tip.amount === '' || tip.amount === null || tip.amount === undefined || isNaN(parseFloat(tip.amount))){
        tip.amount = ''
        return
      }
      if(tip.value_type === 0){
        this.tip_title = tip.name + ' ' + tip.amount + '%'
        this.applied_tip = this.getPercentage(tip.amount, this.subtotal)
      } else {
        this.tip_title = tip.name + ' ' + this.getCurrencySymbol(this.locale.currency) + this.roundToFixed(tip.amount, 2) + this.getCurrencyCode(this.locale.currency)
        this.applied_tip = tip.amount
      }
      this.recomputeDueAmounts()

      if(this.payment_settings.payment_gateway_id === 3 && this.payment_intent_id){
        this.$nextTick(() => {
          if (this.bookingSubmitted) return;
          const total = this.getTotalAmount()
          const amount = this.pay_deposit ? this.due_now : total
          this.updateStripePaymentIntent(amount)
        });
      }
    },
    getTipAmount(tip){
      if(tip.id === 0){
        return tip.name
      } else if(tip.value_type === 0){
        return tip.name + ' ' + tip.amount + '%'
      }
      return tip.name + ' ' + this.getCurrencySymbol(this.locale.currency) + this.roundToFixed(tip.amount, 2) + this.getCurrencyCode(this.locale.currency)
    },
    isFieldVisibile(field){
      const allowed_games = field.visibility_conditions ? JSON.parse(field.visibility_conditions) : []
      const allowed_gift_card_types = field.gift_card_type_visibility_conditions ? JSON.parse(field.gift_card_type_visibility_conditions) : []

      // Events: visibility=0 → 'all'; visibility=1+empty → 'none'; rows → 'specific'
      let event_scope
      if (allowed_games.length > 0) event_scope = 'specific'
      else if (field.visibility) event_scope = 'none'
      else event_scope = 'all'

      // Gift cards: rows → 'specific'; boolean=1 → 'any'; else → 'none'
      let gift_card_scope = 'none'
      if (allowed_gift_card_types.length > 0) gift_card_scope = 'specific'
      else if (field.show_when_gift_card_in_cart) gift_card_scope = 'any'

      // Cart rows for gift cards carry a `.game` reference (since gift cards can be
      // value-of-game), so we must classify by row type — not by presence of `.game`.
      // A gift card row contributes to the gift card axis only.
      for (let n in this.cart) {
        const item = this.cart[n]
        if (item.hasOwnProperty('gift_card')) {
          if (gift_card_scope === 'any') return true
          if (gift_card_scope === 'specific' && _.find(allowed_gift_card_types, {id: item.gift_card.gift_card_type_id})) return true
        } else if (item.game) {
          if (event_scope === 'all') return true
          if (event_scope === 'specific' && _.find(allowed_games, {id: item.game.game_id})) return true
        }
      }
      return false
    },
    async setPaymentOption(option){
      // Switching the payment option does not fire the Stripe element change
      // handler and does not change tabs, so release any wallet-held booking
      // here. No-op unless a wallet confirm is pending.
      this.invalidateWalletPending()
      this.disable_submit = true

      if(option.name !== 'Card'){
        if(this.payment_settings.payment_gateway_id === 1 && this.$refs.authorizePaymentForm){
          this.$refs.authorizePaymentForm.reset()
        }
        this.payment.cardholder_first_name = this.user.first_name
        this.payment.cardholder_last_name = this.user.last_name
      } else {
        if(this.payment_settings.payment_gateway_id === 1 || this.payment_settings.payment_gateway_id === 2
          || this.payment_settings.payment_gateway_id === 4){
          this.disable_submit = false
        }

        if (this.payment_settings.payment_gateway_id === 2 && !this.card) {
          await this.initializeSquare();
        }
      }
      // if(option.name !== 'Card' && option.name !== 'Gift card'){
      //   this.allow_deposit = false
      //   this.pay_deposit = false
      //   this.pay_on_arrival = false
      //   this.allow_pay_on_arrival = false
      //   this.disable_submit = false
      // } else {
      //   this.allow_pay_on_arrival = this.bss.allow_pay_on_arrival
      //   this.computeDeposit()
      // }
      this.allow_pay_on_arrival = this.bss.allow_pay_on_arrival
      this.computeDeposit()

      this.selectedPaymentOption = option
      this.setDisableSubmit()
    },
    setDisableSubmit(){
      // on_approval requests capture nothing at checkout: the card element is
      // hidden and never emits the completion event that would re-enable, so
      // the gateway-3 disable below would stick permanently. Submit stays live.
      if(this.requestNoCapture){
        this.disable_submit = false
        return
      }
      if(this.due_now > 0 && this.selectedPaymentOption.name === 'Gift card'){
        this.disable_submit = true
      } else {
        this.disable_submit = false
      }
      if(this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 3 && this.due_now > 0){
        this.disable_submit = true
      }
    },
    getDropDownLabel(item){
      if(item){
        return item.name
      }
      return ''
    },
    selectDropdown(question, option, event){
      question.customer_response = option
      this.j++
      if (option.has_popup && option.description) {
        const item = event && event.currentTarget
        this.popupOption = option
        this.openEmbeddedAware(item ? (item.closest('.dropdown') || item) : null, () => {
          this.modals.dropdown_popup = true
        })
      }
    },
    getBookingsFromCart(){

      let bookings =  []
      let gift_cards = []
      let items = []
      for(let n in this.cart){
        if(this.cart[n].hasOwnProperty('gift_card')){
          if(this.cart[n].gift_card.send_to_self){
            this.cart[n].gift_card.recipient_first_name = this.user.first_name
            this.cart[n].gift_card.recipient_last_name = this.user.last_name
            this.cart[n].gift_card.recipient_email = this.user.email
          }
          gift_cards.push(this.cart[n])
        } else if(this.cart[n].hasOwnProperty('item')){
          items.push({ id: this.cart[n].item.id, quantity: this.cart[n].item.quantity })
        } else {
          // bookings.push({tickets: this.cart[n].tickets,
          //   booking: this.cart[n].booking,
          //   game: { game_id: this.cart[n].game.game_id
          // }})
          bookings.push(this.cart[n])
        }
      }
      return { bookings, gift_cards, items}
    },
    async payWithYappy(){
      let errors = 0
      if((this.payment.cardholder_last_name === '' || this.sanitizeNameInput(this.payment.cardholder_last_name) === '' )
        && !this.pay_on_arrival){
        this.errors.cardholder_last_name = this.$t('checkin.errors.lastName')
        errors++
      } else {
        this.errors.cardholder_last_name = ""
      }
      if((this.payment.cardholder_first_name == '' || this.sanitizeNameInput(this.payment.cardholder_first_name) === '')
        && !this.pay_on_arrival){
        this.errors.cardholder_first_name = this.$t('checkin.errors.firstName')
        errors++
      } else {
        this.errors.cardholder_first_name = ""
      }
      if(errors > 0){
        return
      }
      let custom_fields = []
      let resp = ''
      for(let n in this.custom_fields){
        if(!this.isFieldVisibile(this.custom_fields[n])) continue
        resp = this.custom_fields[n].customer_response
        if(this.custom_fields[n].type === 3 && this.custom_fields[n].customer_response){
          if(this.custom_fields[n].customer_response.has_follow_up_field){
            resp = this.custom_fields[n].customer_response.name + ': ' + this.custom_fields[n].customer_response.follow_up_response
          } else {
            resp = this.custom_fields[n].customer_response.name
          }
        }
        custom_fields.push({
          customer_response: resp,
          id: this.custom_fields[n].id,
          type: this.custom_fields[n].type
        })
      }

      let code = this.$route.params.company
      let url = API_LOCATION + 'yappy?code=' + code
      let cart = this.getBookingsFromCart()
      let data = {
        ...this.smsConsentPayload(),
        tip: this.roundToFixed(this.applied_tip, 2),
        cart: this.cart_id,
        bookings: cart.bookings,
        gift_cards: cart.gift_cards,
        items: cart.items,
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        payment: this.payment,
        discount: this.getDiscounts(),
        promo_codes: this.promo_codes,
        total: this.roundToFixed(this.due_now, 2),
        currency: this.locale.currency,
        deposit: this.pay_deposit ? Math.min(this.deposit, this.getTotalAmount()) : null,
        custom_fields: custom_fields,
        bss_id: this.bss && this.bss.id ? this.bss.id : null,
        applied_gift_cards: this.applied_gift_cards,
        locale: this.$i18n.locale
      }

      this.loading = true
      const yappyWindow = window.open('about:blank', '_blank');
      axios.post(url, data)
        .then(response => {
          this.loading = false
          this.trackPixelEvent('Purchase', this.due_now, this.cart_id)
          if(window.dataLayer) {
            window.dataLayer.push({
              event: 'purchase',
              currency: this.locale.currency,
              value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
            });
          }
          if(window.gtag) {
            if (window !== window.top) {
              let eventData = {
                eventType: 'purchase',
                eventValue: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now,
                currency: this.locale.currency
              }
              this.$nextTick(() => {
                this.postMessageTrackingEvent(eventData)
              });
            } else {
              gtag("event", "purchase", {
                currency: this.locale.currency,
                value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
              })
            }
          }
          // window.location.href = response.data.url
          // window.open(response.data.url, '_blank');
          yappyWindow.location.href = response.data.url;
        })
        .catch(err => {
          yappyWindow.close();
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal({
              title: this.$t('book.swals.invalidTransaction'),
              text: err.response.data,
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#fd5d93',
              confirmButtonText: this.$t('book.swals.backToBooking')
            }).then((response)=> {
            })
          }
        })
    },
    addMetaPixel(pixel_id) {
      // Check if Pixel is already added to avoid duplicates
      if (!window.fbq) {
        !(function(f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        // Replace 'YOUR_PIXEL_ID' with your actual Meta Pixel ID
        fbq('init', pixel_id);
        fbq('track', 'PageView');
      }
    },
    initializeGtm(gtmId) {
      if (!gtmId) return; // Check if GTM ID is provided

      // GTM script content
      const gtmScriptContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');`;

      // Create a new script element
      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.textContent = gtmScriptContent;

      // Insert the script element into the document head
      document.head.appendChild(scriptElement);

      // Insert the noscript fallback
      const iframe = document.createElement('noscript');
      const iframeContent = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      iframe.innerHTML = iframeContent;
      document.body.insertBefore(iframe, document.body.firstChild);
    },
    insertGoogleAnalyticsScript(gaMeasurementId) {
      if (!gaMeasurementId) return; // Check if GA Measurement ID is provided

      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      if (!window.gtag) {
        const script = document.createElement('script');
        script.async = true;
        script.onload = () => {
          window.gtag = gtag; // Define the global gtag function after the script loads
          gtag('js', new Date());
          gtag('config', gaMeasurementId);
        };
        script.src = `https://www.googletagmanager.com/gtag/js?id=` + gaMeasurementId;
        document.head.appendChild(script);
      }

      if (window !== window.top) {
        let eventData = {
          eventType: 'page_view', id: gaMeasurementId
        }
        this.$nextTick(() => {
          this.postMessageTrackingEvent(eventData)
        });
      } else {
        gtag('event', 'page_view');
      }
    },
    agreeToPolicy(){
      this.recordInteraction(this.selectedPolicy)
      if(this.handleCustomFieldInput(this.selectedCf)){
        this.selectedCf.customer_response = true
      }
      this.modals.policy = false
    },
    openEmbeddedAware(anchorEl, open){
      // Standalone: the popup is a normal fixed, centered modal.
      if (!this.isEmbedded) {
        open()
        return
      }
      // Inside the embed the iframe is the whole page, so a fixed, centered dialog lands
      // wherever the middle of the page is, not where the customer is. Place the popup at
      // the top of the part of the page currently visible in the host window instead.
      // An IntersectionObserver on the document reports that visible slice even across
      // origins; if it cannot, fall back to the element the customer tapped.
      const finish = (top) => {
        this.embeddedModalTop = Math.max(0, Math.round(top))
        open()
        // The modal locks body scrolling (body.modal-open). The placed dialog needs the
        // page to keep scrolling, both in the height-synced embed and in venue iframes
        // that scroll on their own. Runs after the modal's own show watcher.
        this.$nextTick(() => document.body.classList.remove('modal-open'))
      }
      const fallbackTop = () => {
        const rect = anchorEl ? anchorEl.getBoundingClientRect() : null
        return rect ? rect.top + window.scrollY : 0
      }
      if (typeof IntersectionObserver === 'undefined') {
        finish(fallbackTop())
        return
      }
      let settled = false
      let observer = null
      let timer = null
      const settle = (top) => {
        if (settled) return
        settled = true
        if (observer) observer.disconnect()
        clearTimeout(timer)
        finish(top)
      }
      observer = new IntersectionObserver((entries) => {
        const entry = entries[0]
        const visible = entry && entry.isIntersecting ? entry.intersectionRect : null
        settle(visible && visible.height > 0 ? visible.top + window.scrollY + 16 : fallbackTop())
      })
      timer = setTimeout(() => settle(fallbackTop()), 250)
      observer.observe(document.documentElement)
    },
    openPolicy(item, field, event){
      this.selectedCf = field
      this.selectedPolicy = item
      this.openEmbeddedAware(event && event.currentTarget, () => {
        this.modals.policy = true
      })
    },
    getArrowSetting(images){
      if(!images){
        return ''
      }
      if(images.length <= 1){
        return 'never'
      }
      return "hover"
    },
    gameImagesFor(rawGameImages){
      return parseGameImages(rawGameImages, this.isMobileViewport)
    },
    // url -> portrait flag, read from the file's natural dimensions (the baked
    // file is the source of truth for orientation; probes resolve from cache).
    probeGameImageOrientations(){
      if (Array.isArray(this.games)) {
        this.games.forEach(g => this.probeImageOrientation(this.gameImagesFor(g.game_images)))
      }
      if (this.selectedGame && this.selectedGame.game_images) {
        this.probeImageOrientation(this.gameImagesFor(this.selectedGame.game_images))
      }
    },
    selectPayOnArrival(){
      this.applied_gift_cards = []
      if(this.pay_on_arrival){
        this.disable_submit = false
      } else {
        if(this.payment_settings.payment_gateway_id === 3 ||
          this.selectedPaymentOption.name === 'Gift card'){
          this.disable_submit = true
        }
      }
      // Pay on arrival captures nothing, so the deposit comes off while it is
      // ticked. Unticking has to put a required deposit back, or the checkout
      // lands in a no-deposit state the event does not allow, with the due rows
      // hidden and due_now left at whatever it was before.
      this.pay_deposit = !this.pay_on_arrival && this.require_deposit
      this.recomputeDueAmounts()
    },
    // selectPayDeposit(){
    //   this.due_now = this.deposit
    //   this.pay_on_arrival = false
    //   let gift_card_amount = 0
    //   for(let n in this.cart){
    //     if(this.cart[n].hasOwnProperty('gift_card')){
    //       gift_card_amount += parseFloat(this.cart[n].gift_card.total) * this.cart[n].gift_card.quantity
    //     }
    //   }
    //   this.due_now = this.due_now + parseFloat(gift_card_amount)
    //   let gift_card_payments = 0
    //   for(let n in this.applied_gift_cards){
    //     this.due_now = parseFloat(this.due_now) - this.applied_gift_cards[n].remaining
    //     gift_card_payments += this.applied_gift_cards[n].remaining
    //   }
    //
    //   gift_card_payments = Math.round((parseFloat(gift_card_payments) + Number.EPSILON) * 100) / 100
    //   if(this.due_now < 0){
    //     this.due_now = 0
    //     this.disable_submit = false
    //   }
    //
    //   this.$nextTick(() => {
    //     this.due_later = this.getTotalAmount() - this.due_now - gift_card_payments
    //   });
    //
    //   if(!this.pay_deposit){
    //     this.due_now = this.getDueNow()
    //     this.due_later = 0
    //   }
    //
    //   if(this.payment_settings.payment_gateway_id === 3 && this.payment_intent_id){
    //     this.$nextTick(() => {
    //       if (this.bookingSubmitted) return;
    //       const total = this.getTotalAmount()
    //       let amount = this.pay_deposit ? this.due_now : total
    //       if(this.applied_gift_cards.length > 0){
    //         amount = this.due_now
    //       }
    //       this.updateStripePaymentIntent(amount)
    //     });
    //   }
    // },
    selectPayDeposit(){
      this.pay_on_arrival = false
      this.recomputeDueAmounts()

      if(this.payment_settings.payment_gateway_id === 3 && this.payment_intent_id){
        this.$nextTick(() => {
          if (this.bookingSubmitted) return;
          const total = this.getTotalAmount()
          let amount = this.pay_deposit ? this.due_now : total
          if(this.applied_gift_cards.length > 0){
            amount = this.due_now
          }
          this.updateStripePaymentIntent(amount)
        });
      }
    },
    // Rewrites due_now / due_later from the current total, deposit choice and
    // gift cards. Anything that changes the total after the deposit rows were
    // last written (a tip, for instance) must call this, or the rows go stale.
    // Deliberately does not touch pay_on_arrival.
    recomputeDueAmounts(){
      // Calculate gift card amounts in cart (not payments)
      let gift_card_amount = 0
      for(let n in this.cart){
        if(this.cart[n].hasOwnProperty('gift_card')){
          gift_card_amount += parseFloat(this.cart[n].gift_card.total) * this.cart[n].gift_card.quantity
        }
      }

      // Get the actual total after all discounts
      const totalAmount = this.getTotalAmount()

      // If paying deposit, due_now is the lesser of deposit or total amount
      if(this.pay_deposit){
        this.due_now = Math.min(this.deposit, totalAmount)
      } else {
        this.due_now = totalAmount
      }

      // Add gift card purchases (these are always paid now)
      this.due_now = this.due_now + parseFloat(gift_card_amount)

      // Subtract applied gift card payments
      let gift_card_payments = 0
      for(let n in this.applied_gift_cards){
        gift_card_payments += this.applied_gift_cards[n].remaining
        this.due_now = parseFloat(this.due_now) - this.applied_gift_cards[n].remaining
      }

      gift_card_payments = Math.round((parseFloat(gift_card_payments) + Number.EPSILON) * 100) / 100

      // Ensure due_now doesn't go negative
      if(this.due_now < 0){
        this.due_now = 0
        this.disable_submit = false
      }

      // Calculate due_later
      this.$nextTick(() => {
        if(this.pay_deposit){
          // Due later is total minus what's paid now minus gift card payments
          this.due_later = Math.max(0, totalAmount - (this.due_now - gift_card_amount) - gift_card_payments)
        } else {
          this.due_later = 0
        }
      });

      if(!this.pay_deposit){
        this.due_now = this.getDueNow()
        this.due_later = 0
      }
    },
    getDueNow(){
      let due_now = this.getTotalAmount()
      for(let n in this.applied_gift_cards){
        due_now = due_now - this.applied_gift_cards[n].remaining
      }
      return due_now
    },
    incrementCounterGCQuantity(){
      if(this.gift_card.quantity >= this.gift_card_settings.gift_cards_max_purchase_amount){
        return
      }
      else {
        this.gift_card.quantity++
      }
      this.getGiftCardTotal('quantity')
    },
    decrementCounterGCQuantity(){
      if(this.gift_card.quantity <= 1){
        return
      }
      else {
        this.gift_card.quantity--
      }
      this.getGiftCardTotal('quantity')
    },
    incrementCounter(c, source){
      if(c.number_of_players >= c.maximum_players_for_category){
        this.errors.number_of_players = this.$t('book.errors.totalNumberOfPlayersFor') + c.category + this.$t('book.errors.cannotBeGreaterThan') + c.maximum_players_for_category
        return
      } else if((c.maximum_participants && c.number_of_players >= c.maximum_participants)){
        this.errors.number_of_players = this.$t('book.errors.totalNumberOfPlayersFor') + c.category + this.$t('book.errors.cannotBeGreaterThan') + c.maximum_participants
        return
      }
      else {
        this.errors.number_of_players = ''
        c.number_of_players++
      }
      if(source === 'gc'){
        this.getGiftCardTotal('players', this.selectedGame)
      } else {
        // Upgraded reservation: buyout uses the flat fee, tickets+fee recomputes
        // per-ticket pricing plus the fixed fee (applyUpgradeSubtotal).
        if(this.book_entire_slot){
          this.applyUpgradeSubtotal()
        } else {
          this.getSubtotal()
        }
      }
    },
    decrementCounter(c, source){
      // Only validate per-category minimum, not total group size
      if(c.number_of_players <= c.minimum_participants){
        this.errors.number_of_players = this.$t('book.errors.numberOf') + c.category + this.$t('book.errors.cannotBeLessThan') + c.minimum_participants
        return
      } else {
        this.errors.number_of_players = ''
        c.number_of_players--
      }
      if(source === 'gc'){
        this.getGiftCardTotal('players', this.selectedGame)
      } else {
        // Upgraded reservation: buyout uses the flat fee, tickets+fee recomputes
        // per-ticket pricing plus the fixed fee (applyUpgradeSubtotal).
        if(this.book_entire_slot){
          this.applyUpgradeSubtotal()
        } else {
          this.getSubtotal()
        }
      }
    },
    selectGiftCardDeliveryMethod(source){
      this.gift_card.send_instantly = source
      if(source){
        this.buttonGroupStyle[1] = { 'font-family': this.bss.font_family_card,
          'border-color': this.bss.button_color,
          'color': this.bss.button_color}
        this.buttonGroupStyle[0] = { 'font-family': this.bss.font_family_card,
          'border-color': this.bss.button_color,
          'background-color': this.bss.button_color,
          'background-image': 'linear-gradient(to bottom left,' + this.bss.button_color + ', ' + this.bss.button_color + ', ' + this.bss.button_color + ') !important',
          'color': this.bss.card_color}
      } else {
        this.buttonGroupStyle[0] = { 'font-family': this.bss.font_family_card,
          'border-color': this.bss.button_color,
          'color': this.bss.button_color}
        this.buttonGroupStyle[1] = { 'font-family': this.bss.font_family_card,
          'border-color': this.bss.button_color,
          'background-color': this.bss.button_color,
          'background-image': 'linear-gradient(to bottom left,' + this.bss.button_color + ', ' + this.bss.button_color + ', ' + this.bss.button_color + ') !important',
          'color': this.bss.card_color}
      }
    },
    setGiftCardDesign(index){
      this.gift_card.design_url = this.gift_card_designs[index]
    },
    async getGiftCardTotal(source, game, event){
      if(event){
        event.preventDefault()
      }
      if(source === 'value_type' || source === 'quantity'){
        if(this.selectedGiftCardType.value_type === 0){
          if(this.gift_card.custom_amount === ''){
            return
          }
          if(isNaN(this.gift_card.custom_amount)){
            this.gift_card.custom_amount = this.selectedGiftCardType.min_purchase_value
          }
          if(this.gift_card.custom_amount < this.selectedGiftCardType.min_purchase_value){
            this.gift_card.custom_amount = this.selectedGiftCardType.min_purchase_value
          } else if (this.gift_card.custom_amount > this.selectedGiftCardType.max_purchase_value){
            this.gift_card.custom_amount = this.selectedGiftCardType.max_purchase_value
          }
          this.gift_card.unit_value = this.gift_card.custom_amount
          this.gift_card.total = this.gift_card.custom_amount * this.gift_card.quantity
        } else if(this.selectedGiftCardType.value_type === 1) {
          this.gift_card.total = this.gift_card.unit_price * this.gift_card.quantity
        }
        else if(this.selectedGiftCardType.value_type === 2 ) {
          if(source === 'value_type'){
            this.gift_card.total = 0
            this.gift_card.unit_value = 0
          } else if(source === 'quantity'){
            this.gift_card.total = 0
            this.gift_card.unit_value = 0
            this.number_of_players = 0
            this.getGiftCardGamePrice()
          }
        }
      }

      if(source === 'game'){
        this.gift_card.total = 0
        this.gift_card.unit_value = 0
        this.number_of_players = 0
        this.gift_card.quantity = 1
        this.selectedGame = game
        await this.getGiftCardPricing()
      }
      if(source === 'players'){
        this.gift_card.total = 0
        this.gift_card.unit_value = 0
        this.number_of_players = 0
        this.getGiftCardGamePrice()
      }

      this.gc_key++
    },
    getGiftCardGamePrice(){
      this.number_of_players = 0
      if(this.selectedGame.cumulative_category_pricing){
        if(this.selectedGame.pricing_type_id === 1){
          for(let m in this.pricing_categories) {
            this.number_of_players += this.pricing_categories[m].number_of_players
          }
          for(let m in this.pricing_categories){
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.number_of_players >= this.pricing[n].min_players
                && this.number_of_players <= this.pricing[n].max_players) {
                this.gift_card.unit_value += this.pricing[n].price * this.pricing_categories[m].number_of_players
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.number_of_players > this.pricing[last_index].max_players){
              this.gift_card.unit_value += this.pricing[last_index].price * this.pricing_categories[m].number_of_players
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.number_of_players !== 0 &&
              this.number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += smallest_price_category.price * this.pricing_categories[m].number_of_players
            }
          }
        }
        else if(this.selectedGame.pricing_type_id === 2){
          for(let m in this.pricing_categories) {
            this.number_of_players += this.pricing_categories[m].number_of_players
          }
          for(let m in this.pricing_categories){
            // Empty categories are never sold; total headcount only picks the tier (OTC-2911)
            if(!(this.pricing_categories[m].number_of_players > 0)) continue
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.number_of_players >= this.pricing[n].min_players
                && this.number_of_players <= this.pricing[n].max_players) {
                this.gift_card.unit_value += this.pricing[n].price
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.number_of_players > this.pricing[last_index].max_players){
              this.gift_card.unit_value += this.pricing[last_index].price
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.number_of_players !== 0 &&
              this.number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += smallest_price_category.price
            }
          }
        }
      } else {
        if(this.selectedGame.pricing_type_id === 1){
          for(let m in this.pricing_categories){

            this.number_of_players += this.pricing_categories[m].number_of_players
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.pricing_categories[m].number_of_players >= this.pricing[n].min_players
                && this.pricing_categories[m].number_of_players <= this.pricing[n].max_players) {
                this.gift_card.unit_value += this.pricing[n].price * this.pricing_categories[m].number_of_players
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players > this.pricing[last_index].max_players){
              this.gift_card.unit_value += this.pricing[last_index].price * this.pricing_categories[m].number_of_players
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players !== 0 &&
              this.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += smallest_price_category.price * this.pricing_categories[m].number_of_players
            }
          }
        }
        else if(this.selectedGame.pricing_type_id === 2){
          for(let m in this.pricing_categories){
            this.number_of_players += this.pricing_categories[m].number_of_players
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.pricing_categories[m].number_of_players >= this.pricing[n].min_players
                && this.pricing_categories[m].number_of_players <= this.pricing[n].max_players) {
                this.gift_card.unit_value += this.pricing[n].price
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players > this.pricing[last_index].max_players){
              this.gift_card.unit_value += this.pricing[last_index].price
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players !== 0 &&
              this.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += smallest_price_category.price
            }
          }
        }
      }

      if(this.selectedGiftCardType.include_taxes_and_fees){
        // Same taxes-and-fees math as the booking preview, so the card value
        // covers every tax and fee type the linked event carries.
        this.gift_card.unit_value = this.getSubtotalWithTaxFee(this.gift_card.unit_value, this.number_of_players)
      }
      this.gift_card.total = this.gift_card.unit_value * this.gift_card.quantity
    },
    getGiftCardPricing(){
      let url = API_LOCATION + 'games/' + this.selectedGame.game_id + '/pricing'
      axios.get(url)
        .then(response => {
          this.pricing = response.data.pricing
          this.number_of_players = 0
          this.pricing_categories = []

          for(let n in this.pricing){
            if(!(_.find(this.pricing_categories, { category_id: this.pricing[n].category_id }))){
              this.pricing_categories.push({
                category_id: this.pricing[n].category_id,
                category: this.pricing[n].category.toLowerCase(),
                number_of_players: this.pricing[n].default_participants,
                price: this.pricing[n].price,
                minimum_participants: this.pricing[n].minimum_participants,
                maximum_participants: this.pricing[n].maximum_participants
              })
              this.number_of_players++
            }
          }
          this.getGiftCardGamePrice()
          if (window !== window.top) {
            this.$nextTick(() => {
              this.updateParentAboutPageChange()
            });
          }
        })
        .catch(err => {
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    getGiftCardAmount(amount){
      if(amount === 'Custom value' || amount === 'Value of a game'){
        return amount
      }
      return this.getCurrencySymbol(this.locale.currency) + this.getAmount(amount) + this.getCurrencyCode(this.locale.currency)
    },
    formatUpsellAmount(value){
      return this.getCurrencySymbol(this.locale.currency) + this.getNumberFormat(this.getAmount(value)) + ' ' + this.getCurrencyCode(this.locale.currency)
    },
    // "Book now" on an upsell suggestion: the normal ticket step for that slot.
    selectUpsell({ game, slot }){
      const bookings = this.cart.filter(c => c && c.booking && c.booking.id && !c.item && !c.gift_card)
      const anchor = bookings.length > 0 ? bookings[bookings.length - 1] : null
      this.tabOne(1, game, slot)
      // tabOne can return early (request guard); only arm the upsell state when
      // the slot was really selected. getPricing resolves later, so the prefill
      // set here still lands.
      if(this.selectedBooking === slot){
        this.upsell_prefill_quantity = anchor && anchor.quantity ? Number(anchor.quantity) : null
        this.upsell_promo_pending = this.bss.upsell_promo_code ? this.bss.upsell_promo_code : null
      }
    },
    getRate(item){
      if(this.price_settings.cumulative_category_pricing){
        for(let n in this.pricing){
          if(this.pricing[n].category_id === item.category_id
            && this.number_of_players >= this.pricing[n].min_players
            && this.number_of_players <= this.pricing[n].max_players) {
            return this.price_settings.pricing_type_id === 1 ?
              this.getCurrencySymbol(this.locale.currency) + this.getAmount(this.pricing[n].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.per') + item.category
              : this.pricing[n].min_players === this.pricing[n].max_players ?
                this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[n].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + this.pricing[n].min_players + ' ' + item.category
                : this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[n].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + this.pricing[n].min_players + '-' + this.pricing[n].max_players + ' ' + item.category

          }
        }

        let last_index = _.findLastKey(this.pricing, {category_id: item.category_id})
        if(this.number_of_players > this.pricing[last_index].max_players){
          return this.price_settings.pricing_type_id === 1 ? this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[last_index].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.per') + item.category
            :  this.pricing[last_index].min_players === this.pricing[last_index].max_players ?
              this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[last_index].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + this.pricing[last_index].min_players + ' ' + item.category
              : this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[last_index].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + this.pricing[last_index].min_players + '-' + this.pricing[last_index].max_players + ' ' + item.category
        }

        let smallest_price_category = _.find(this.pricing, {category_id : item.category_id})
        if(this.number_of_players !== 0 &&
          this.number_of_players < smallest_price_category.min_players){
          return this.price_settings.pricing_type_id === 1 ? this.getCurrencySymbol(this.locale.currency) + this.getAmount(smallest_price_category.price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.per') + item.category
            : smallest_price_category.min_players === smallest_price_category.max_players ?
              this.getCurrencySymbol(this.locale.currency) + this.getAmount(smallest_price_category.price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + smallest_price_category.min_players + ' ' + item.category
              : this.getCurrencySymbol(this.locale.currency) + this.getAmount(smallest_price_category.price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' ' + item.category
        }
      } else {
        for(let n in this.pricing){
          if(this.pricing[n].category_id === item.category_id
            && item.number_of_players >= this.pricing[n].min_players
            && item.number_of_players <= this.pricing[n].max_players) {
            return this.price_settings.pricing_type_id === 1 ? this.getCurrencySymbol(this.locale.currency) + this.getAmount(this.pricing[n].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.per') + item.category
              : this.pricing[n].min_players === this.pricing[n].max_players ?
                this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[n].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + item.category + ' (' + this.pricing[n].min_players + this.$t('book.playersRate') + ')'
                : this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[n].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + item.category + ' (' + this.pricing[n].min_players + '-' + this.pricing[n].max_players + this.$t('book.playersRate') + ')'

          }
        }

        let last_index = _.findLastKey(this.pricing, {category_id: item.category_id})
        if(item.number_of_players > this.pricing[last_index].max_players){
          return this.price_settings.pricing_type_id === 1 ? this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[last_index].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.per') + item.category
            : this.pricing[last_index].min_players === this.pricing[last_index].max_players ?
              this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[last_index].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + item.category + ' (' + this.pricing[last_index].min_players + this.$t('book.playersRate') + ')'
              : this.getCurrencySymbol(this.locale.currency) +  this.getAmount(this.pricing[last_index].price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + item.category + ' (' + this.pricing[last_index].min_players + '-' + this.pricing[last_index].max_players + this.$t('book.playersRate') + ')'
        }

        let smallest_price_category = _.find(this.pricing, {category_id : item.category_id})
        if(item.number_of_players !== 0 &&
          item.number_of_players < smallest_price_category.min_players){
          return this.price_settings.pricing_type_id === 1 ? this.getCurrencySymbol(this.locale.currency) + this.getAmount(smallest_price_category.price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.per') + item.category
            : smallest_price_category.min_players === smallest_price_category.max_players ?
              this.getCurrencySymbol(this.locale.currency) + this.getAmount(smallest_price_category.price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + item.category + ' (' + smallest_price_category.min_players + this.$t('book.playersRate') + ')'
              : this.getCurrencySymbol(this.locale.currency) + this.getAmount(smallest_price_category.price) + ' ' + this.getCurrencyCode(this.locale.currency) + this.$t('book.for') + item.category + ' (' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + this.$t('book.playersRate') + ')'
        }
      }

      return ''
    },
    removeGiftCard(item){
      this.invalidateWalletPending()
      _.remove(this.applied_gift_cards, {
        id: item.id
      });
      this.pc_key++
      this.addToCart(5)
      this.computeDeposit()
      this.setDisableSubmit()
    },
    async removePromoCode(item){
      this.invalidateWalletPending()
      // Clear discounts from cart items for this promo
      if(item.discounted_items && item.discounted_items.length > 0){
        this.clearDiscountedItemsFromCart(item.discounted_items)
      }
      _.remove(this.promo_codes, {
        name: item.name
      });
      this.recalculateTaxesAndFees()
      this.pc_key++
      this.addToCart(5)
      this.computeDeposit()
      this.setDisableSubmit()
      this.addToCart(5)
    },
    applyDiscountedItemsToCart(discountedItems){
      if(!discountedItems || discountedItems.length === 0) return

      for(const discountedItem of discountedItems){
        for(let n in this.cart){
          let matches = false

          if(discountedItem.type === 'items' && this.cart[n].hasOwnProperty('item')){
            matches = this.cart[n].item.id === discountedItem.id
          } else if(discountedItem.type === 'games' && this.cart[n].hasOwnProperty('game')){
            if(discountedItem.booking_slot_id && this.cart[n].booking){
              matches = this.cart[n].booking.id === discountedItem.booking_slot_id
            } else {
              matches = this.cart[n].game.game_id === discountedItem.id
            }
          } else if(discountedItem.type === 'gift_cards' && this.cart[n].hasOwnProperty('gift_card')){
            matches = this.cart[n].gift_card.gift_card_type_id === discountedItem.id
          }

          if(matches){
            this.cart[n].discount = (this.cart[n].discount || 0) + discountedItem.discount
            break
          }
        }
      }
    },
    clearDiscountedItemsFromCart(discountedItems){
      if(!discountedItems || discountedItems.length === 0) return

      for(const discountedItem of discountedItems){
        for(let n in this.cart){
          let matches = false

          if(discountedItem.type === 'items' && this.cart[n].hasOwnProperty('item')){
            matches = this.cart[n].item.id === discountedItem.id
          } else if(discountedItem.type === 'games' && this.cart[n].hasOwnProperty('game')){
            if(discountedItem.booking_slot_id && this.cart[n].booking){
              matches = this.cart[n].booking.id === discountedItem.booking_slot_id
            } else {
              matches = this.cart[n].game.game_id === discountedItem.id
            }
          } else if(discountedItem.type === 'gift_cards' && this.cart[n].hasOwnProperty('gift_card')){
            matches = this.cart[n].gift_card.gift_card_type_id === discountedItem.id
          }

          if(matches){
            this.cart[n].discount = Math.max(0, (this.cart[n].discount || 0) - discountedItem.discount)
            break
          }
        }
      }
    },
    // silent: used by the upsell auto-apply, which must never raise a popup
    async applyPromo(silent){
      this.invalidateWalletPending()
      let bookings = []
      for(let n in this.cart){
        if(this.cart[n].hasOwnProperty('gift_card')){
          bookings.push({type: 'gift_card', subtotal: this.cart[n].subtotal})
        } else if(this.cart[n].hasOwnProperty('item')) {
          bookings.push({type: 'item', subtotal: this.cart[n].subtotal})
        } else{
          bookings.push({id: this.cart[n].booking.id, booking_date: this.cart[n].booking.booking_date,
            start_time:  this.cart[n].booking.start_time,
            game_id: this.cart[n].game.game_id, subtotal: this.cart[n].subtotal,
            group_size: this.cart[n].quantity})
        }
      }
      this.loading = true


      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/promos-v2?code=' + encodeURIComponent(this.promo_code) +
        '&cart_id=' + encodeURIComponent(this.cart_id)

      return this.axios.get(url)
        .then(response => {
          this.loading = false
          if(JSON.stringify(response.data.promo_code) === '{}'){
            if(!silent) swal({
              title: this.$t('book.swals.error'),
              text: this.$t('book.swals.invalidPromoCode'),
              type: 'error',
              confirmButtonColor: '#1d8cf8',
              confirmButtonText: 'OK'
            })
            this.computeDeposit()
            return
          } else {
            if(parseFloat(response.data.promo_code.value_amount) < 0){
              if(!silent) swal({
                title: this.$t('book.swals.error'),
                text: this.$t('book.swals.promoCodeCannotBeApplied'),
                type: 'error',
                confirmButtonColor: '#1d8cf8',
                confirmButtonText: 'OK'
              })
              return
            }
            this.promo_code = ''
            let dupe = false
            for(let n in this.promo_codes){
              if(this.promo_codes[n].name === response.data.promo_code.name){
                dupe = true
              }
              if(this.promo_codes[n].is_combineable === 0 || response.data.promo_code.is_combineable === 0){
                if(!silent) swal(this.$t('book.swals.error'), this.$t('book.swals.nonCombineablePromo'), 'error')
                return
              }
            }
            if(!dupe){
              let value_amount = parseFloat(response.data.promo_code.value_amount)
              if(value_amount > this.getCartSubtotal() && response.data.promo_code.redemption_type === 1 ){
                value_amount = this.getCartSubtotal()
              }
              // else if (response.data.promo_code.redemption_type === 0){
              //   value_amount = this.getPercentage(this.getCartSubtotal(), value_amount)
              // }

              // Apply discounted_items to cart items
              const discountedItems = response.data.promo_code.discounted_items || []
              this.applyDiscountedItemsToCart(discountedItems)

              this.promo_codes.push(
                {
                  id: response.data.promo_code.id,
                  name: response.data.promo_code.name,
                  value_amount: value_amount,
                  display_amount: response.data.promo_code.display_amount != null
                    ? Math.min(parseFloat(response.data.promo_code.display_amount), this.getCartSubtotal())
                    : value_amount,
                  raw_value_amount: response.data.promo_code.raw_value_amount,
                  is_combineable: response.data.promo_code.is_combineable,
                  redemption_type: response.data.promo_code.redemption_type,
                  value_type: response.data.promo_code.value_type,
                  discounted_items: discountedItems
                }
              )
            }
          }
          this.recalculateTaxesAndFees()
          this.adjustAppliedGiftCards()
          this.computeDeposit()
          this.addToCart(5)
          // if(this.getTotalAmount() <= 0){
          //   this.disable_submit = false
          // }
          if(this.due_now <= 0){
            this.disable_submit = false
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          }
          else if (err.response && err.response.status === 500 && err.response.data === 'Expired cart'){
            swal({
              title: this.$t('book.swals.error'),
              text: this.$t('book.swals.expiredCart'),
              type: 'error',
              confirmButtonColor: '#1d8cf8',
              confirmButtonText: 'OK'
            }).then((response)=> {
              this.handleCartExpiration()
            })
          } else {
            if(!silent) swal({
              title: this.$t('book.swals.error'),
              text: this.bss.show_custom_promo_code_error_message ? this.bss.promo_code_error_message : this.$t('book.swals.promoCodeCannotBeApplied'),
              type: 'error',
              confirmButtonColor: '#1d8cf8',
              confirmButtonText: 'OK'
            })
          }
        })

    },
    adjustAppliedGiftCards() {
      let appliedGiftCardAmount = 0;
      for (let n in this.applied_gift_cards) {
        appliedGiftCardAmount += this.applied_gift_cards[n].remaining;
      }
      let applied_discounts = this.getDiscounts();
      let total = this.getTotalAmount();
      let i = 0;
      while (appliedGiftCardAmount > total && i < this.applied_gift_cards.length) {
        let excess = appliedGiftCardAmount - total;
        let currentGiftCard = this.applied_gift_cards[i];

        if (currentGiftCard.remaining >= excess) {
          currentGiftCard.remaining -= excess;
          appliedGiftCardAmount -= excess;
        } else {
          appliedGiftCardAmount -= currentGiftCard.remaining;
          currentGiftCard.remaining = 0;
        }

        i++;
      }
    },
    goToCallToBook(s){
      const w = window.open(s.external_link, '_blank');
      if (w) w.focus();
    },
    onListSlotSelected({ game, slot }) {
      this.tabOne(1, game, slot)
    },
    scrollToTop(){
      // Skip internal scrolling when embedded in iframe to prevent autoscroll issues
      // Both iOS Safari and Firefox have known iframe scrolling bugs
      // The parent window will handle scrolling via postMessage instead
      if (window !== window.top) {
        return;
      }

      window.requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      });
      // const root = document.getElementById('root');
      // window.requestAnimationFrame(() => {
      //   root.scrollTo({
      //     top: 0,
      //     left: 0,
      //     behavior: 'smooth',
      //   });
      // });
    },
    getCurrencyCode(code) {
      if (this.locale.currency_format === 1) {
        return code;
      }

      // Postfix krone currencies: the symbol goes after the amount
      if ((code === 'SEK' || code === 'DKK') && this.locale.currency_format === 0) {
        return code === 'DKK' ? 'kr.' : 'kr';
      }

      return '';
    },
    getCurrencySymbol(code) {
      if (this.locale.currency_format === 0) {
        let c = _.find(this.currencies, { code: code });
        if (!c) return '';

        // Postfix krone currencies: no prefix symbol
        if (code === 'SEK' || code === 'DKK') {
          return '';
        }
        return c.symbol;
      }
      return '';
    },
    showPrevious(d){
      if(!d) return false
      let current = new Date(d.split('-')[0], (d.split('-')[1])-1, d.split('-')[2])
      let today = getNow()
      return current > today
    },
    onDatePickerChange(){
      this.getSchedules()
      if (this._bookingWs) this._bookingWs.updateDate(this.currentDay)
    },
    decrementDay(d){
      let current = new Date(d.split('-')[0], (d.split('-')[1])-1, d.split('-')[2])
      current.setDate(current.getDate() - 1)
      this.currentDay = current.getFullYear() + '-' + ('0' + (current.getMonth()+1)).slice(-2) + '-' + ('0' + current.getDate()).slice(-2)
      this.getSchedules()
      if (this._bookingWs) this._bookingWs.updateDate(this.currentDay)
    },
    decrementWeek(d){
      let current = new Date(d.split('-')[0], (d.split('-')[1])-1, d.split('-')[2])
      current.setDate(current.getDate() - 7)
      this.currentDay = current.getFullYear() + '-' + ('0' + (current.getMonth()+1)).slice(-2) + '-' + ('0' + current.getDate()).slice(-2)
      this.getSchedules()
      if (this._bookingWs) this._bookingWs.updateDate(this.currentDay)
    },
    incrementWeek(d){
      let current = new Date(d.split('-')[0], (d.split('-')[1])-1, d.split('-')[2])
      current.setDate(current.getDate() + 7)
      this.currentDay = current.getFullYear() + '-' + ('0' + (current.getMonth()+1)).slice(-2) + '-' + ('0' + current.getDate()).slice(-2)
      this.getSchedules()
      if (this._bookingWs) this._bookingWs.updateDate(this.currentDay)
    },
    incrementDay(d){
      let current = new Date(d.split('-')[0], (d.split('-')[1])-1, d.split('-')[2])
      current.setDate(current.getDate() + 1)
      this.currentDay = current.getFullYear() + '-' + ('0' + (current.getMonth()+1)).slice(-2) + '-' + ('0' + current.getDate()).slice(-2)
      this.getSchedules()
      if (this._bookingWs) this._bookingWs.updateDate(this.currentDay)
    },
    handleEventClick(clickInfo) {
      const bookingSlot = clickInfo.event._def.extendedProps.bookingSlot
      // Display-only events (sold out, blocked, non-bookable custom statuses) carry
      // no bookingSlot — there's nothing to book, so ignore the click. External-link
      // events navigate via the event's url, not this handler.
      if (!bookingSlot) return
      // Request-to-book chips click through into the normal selection flow.
      if (clickInfo.event.extendedProps.slotKind === 'rtb') {
        this.tabOne(1, this.selectedGame, bookingSlot)
        return
      }
      if(clickInfo.event.title !== this.$t('book.available') && (bookingSlot.is_reservation_upgraded || bookingSlot.is_resource_saturated || !this.isPublicBooking(this.selectedGame, bookingSlot)
        || (this.isPublicBooking(this.selectedGame, bookingSlot) && !this.hasRemainingSlots(this.selectedGame, bookingSlot)))){
        return
      }
      this.tabOne(1, this.selectedGame, clickInfo.event.extendedProps.bookingSlot)
    },
    // Week-calendar chip content: bold time range, status text, and a localized
    // capacity pill for public slots. Colors are handled by styleCalendarEvent.
    renderCalendarEvent(arg){
      const wrap = document.createElement('div')
      wrap.className = 'booking-slot-chip'
      const time = document.createElement('span')
      time.className = 'booking-slot-chip__time'
      time.textContent = arg.timeText
      wrap.appendChild(time)
      const title = document.createElement('span')
      title.textContent = arg.event.title
      wrap.appendChild(title)
      const total = arg.event.extendedProps.capacityTotal
      if(total){
        const left = arg.event.extendedProps.capacityAvailable
        const cap = document.createElement('span')
        cap.className = 'booking-slot-chip__cap'
        if(left <= Math.ceil(total * 0.25)){
          cap.classList.add('booking-slot-chip__cap--low')
        }
        cap.textContent = this.$t('book.spotsLeft', { available: left, total: total })
        wrap.appendChild(cap)
      }
      return { domNodes: [wrap] }
    },
    // Repaint the default solid event block as a tinted chip. The chip still takes
    // its color from the operator's slot color settings (the event's backgroundColor);
    // text inherits the site text color from the calendar wrapper.
    styleCalendarEvent(info){
      info.el.classList.add('booking-slot-event')
      if(info.event.extendedProps.slotKind === 'soldout'){
        info.el.classList.add('booking-slot-event--soldout')
      }
      // Pointer cursor only where a click does something: bookable slots, and
      // call-to-book slots that navigate to an external link.
      if(info.event.extendedProps.slotKind === 'available' || info.event.extendedProps.slotKind === 'rtb' || info.event.url){
        info.el.classList.add('booking-slot-event--clickable')
      }
      info.el.style.setProperty('--slot-color', info.event.backgroundColor)
      info.el.style.backgroundColor = ''
      info.el.style.borderColor = ''
    },
    // Day headers: small uppercase weekday over the date, today circled in the
    // site's button color. Weekday names follow the visitor's language.
    renderCalendarDayHeader(arg){
      const wrap = document.createElement('span')
      wrap.className = 'booking-cal-dayhead'
      const dow = document.createElement('span')
      dow.className = 'booking-cal-dayhead__dow'
      dow.textContent = arg.date.toLocaleDateString(this.$i18n.locale, { weekday: 'short' })
      wrap.appendChild(dow)
      const dom = document.createElement('span')
      dom.className = 'booking-cal-dayhead__dom'
      if(arg.isToday){
        dom.classList.add('booking-cal-dayhead__dom--today')
      }
      dom.textContent = arg.date.getDate()
      wrap.appendChild(dom)
      return { domNodes: [wrap] }
    },
    showCalendar(game){
      this.selectedGame = game
      this.show_calendar = true
      setTimeout(()=>{
        let calendarApi = this.$refs.calendar.getApi();
        calendarApi.gotoDate(this.currentDay);
      }, 100);
    },
    disabledDates(time) {
      var date = getNow();
      var previousDate = date.setDate(date.getDate() - 1);
      return time.getTime() < previousDate;
    },
    hasRemainingSlots(game, slot){
      const playerHeadroom = game.max_players_count - slot.group_size
      if (slot.resource_max_remaining_seats != null) {
        return Math.min(playerHeadroom, slot.resource_max_remaining_seats) > 0
      }
      return playerHeadroom > 0
    },
    getRemainingTickets(game, slot){
      const playerHeadroom = game.max_players_count - slot.group_size
      if (slot.resource_max_remaining_seats != null) {
        return Math.min(playerHeadroom, slot.resource_max_remaining_seats)
      }
      return playerHeadroom
    },
    isPublicBooking(game, slot){
      if(slot.is_custom_pricing_enabled){
        return slot.is_public_booking
      } else {
        return game.is_public_booking
      }
    },
    // Request-to-book classification (mirror of slotDisplay.getSlotType). A
    // requestable slot offers a request button until its minimum notice
    // passes, then follows its own three-way past-notice behavior; an
    // available slot past its notice with request_past_min_notice set does
    // the same. A closed late-booking window is never requestable.
    isRequestToBookSlot(game, s){
      if(!this.allowRequestToBook) return false
      if(s.is_resource_saturated || s.online_display_mode === 'non_bookable') return false
      if(this.isPublicBooking(game, s)) return false
      if(s.status === 'requestable'){
        if(!s.remove && !s.block) return true
        return !s.remove && !!s.block && s.allow_late_booking !== 1 && Number(s.request_past_min_notice) === 1
      }
      if(s.status === 'available' && s.block && !s.remove && s.allow_late_booking !== 1
        && Number(s.request_past_min_notice) === 1 && !s.has_external_link) return true
      return false
    },
    // Slots the request-to-book feature takes out of the generic call-to-book
    // branches: pending-request claims, requestable-with-toggle-off (renders
    // blocked), and slots that render the request button.
    rtbOverridesCtb(game, s){
      if(s.status === 'requested') return true
      // Toggle off, or a public master (requests are private-only): renders blocked.
      if(s.status === 'requestable' && (!this.allowRequestToBook || this.isPublicBooking(game, s))) return true
      return this.isRequestToBookSlot(game, s)
    },
    getSlotCloseDeadline(slot){
      // Returns the Date at which this slot stops accepting bookings due to the
      // minimum booking notice, or null if it doesn't apply. Mirrors the block
      // math in getOrderedTimeSlots so the countdown can never disagree with
      // whether the slot is actually still bookable. Late-booking slots use a
      // different (post-start) deadline and are out of scope for the countdown.
      if(!slot || !slot.booking_date || !slot.start_time) return null
      if(slot.allow_late_booking === 1) return null
      if(slot.min_booking_period === null || slot.min_booking_period === undefined) return null

      const value = parseInt(slot.min_booking_value)
      if(isNaN(value)) return null

      // Slot start as a Date (venue wall-clock interpreted in the browser's
      // local zone, consistent with the existing availability logic).
      const slotStart = new Date()
      // Start from the 1st: the date begins as today, and setting the month while on
      // the 29th-31st overflows into the following month when the target month is shorter
      slotStart.setDate(1)
      slotStart.setFullYear(slot.booking_date.split('-')[0])
      slotStart.setMonth(parseInt(slot.booking_date.split('-')[1]) - 1)
      slotStart.setDate(slot.booking_date.split('-')[2])
      slotStart.setHours(slot.start_time.split(':')[0])
      slotStart.setMinutes(slot.start_time.split(':')[1])
      slotStart.setSeconds(0, 0)

      const deadline = new Date(slotStart.getTime())
      if(slot.min_booking_period === 0){          // minutes
        deadline.setMinutes(deadline.getMinutes() - value)
      } else if(slot.min_booking_period === 1){   // hours
        deadline.setMinutes(deadline.getMinutes() - value * 60)
      } else if(slot.min_booking_period === 2){   // days
        deadline.setDate(deadline.getDate() - value)
      } else if(slot.min_booking_period === 3){   // weeks
        deadline.setDate(deadline.getDate() - 7 * value)
      } else if(slot.min_booking_period === 4){   // months
        deadline.setMonth(deadline.getMonth() - value)
      } else {
        return null
      }
      return deadline
    },
    shouldSlotBeCallToBook(slot){
      // Check if a slot should be "call to book" based on time restrictions
      const currentTime = getNow();

      // Parse slot start date
      let slot_date = new Date()
      // Start from the 1st: the date begins as today, and setting the month while on
      // the 29th-31st overflows into the following month when the target month is shorter
      slot_date.setDate(1)
      slot_date.setFullYear(slot.booking_date.split('-')[0])
      slot_date.setMonth(parseInt(slot.booking_date.split('-')[1]) - 1)
      slot_date.setDate(slot.booking_date.split('-')[2])
      slot_date.setHours(slot.start_time.split(':')[0])
      slot_date.setMinutes(slot.start_time.split(':')[1])

      let blocked_days = 0
      let blocked_minutes = 0
      let unblock_date = getNow()

      // Calculate unblock_date based on booking settings
      if (slot.allow_late_booking === 1) {
        // Late booking: calculate deadline as slot_start_time + min_booking_value
        unblock_date = new Date(slot_date.getTime())

        if (slot.min_booking_period === 0) {
          blocked_minutes = slot.min_booking_value
          unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
        } else if (slot.min_booking_period === 1) {
          blocked_minutes = parseInt(slot.min_booking_value) * 60
          unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
        } else if (slot.min_booking_period === 2) {
          blocked_days = slot.min_booking_value
          unblock_date.setDate(unblock_date.getDate() + blocked_days)
        } else if (slot.min_booking_period === 3) {
          blocked_days = 7 * parseInt(slot.min_booking_value)
          unblock_date.setDate(unblock_date.getDate() + blocked_days)
        } else if (slot.min_booking_period === 4) {
          //months
          const slotDate = new Date(unblock_date.getTime());
          const futureDate = new Date(slotDate.getTime());

          futureDate.setMonth(futureDate.getMonth() + parseInt(slot.min_booking_value));
          const timeDifference = futureDate.getTime() - slotDate.getTime();
          blocked_days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          unblock_date.setDate(unblock_date.getDate() + blocked_days)
        } else if (slot.min_booking_period === null) {
          unblock_date = new Date(slot_date.getTime())
        }
      } else {
        // Normal booking: calculate minimum advance booking from current time
        if (slot.min_booking_period === 0) {
          blocked_minutes = slot.min_booking_value
          unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
        } else if (slot.min_booking_period === 1) {
          blocked_minutes = parseInt(slot.min_booking_value) * 60
          unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
        } else if (slot.min_booking_period === 2) {
          blocked_days = slot.min_booking_value
          unblock_date.setDate(unblock_date.getDate() + blocked_days)
        } else if (slot.min_booking_period === 3) {
          blocked_days = 7 * parseInt(slot.min_booking_value)
          unblock_date.setDate(unblock_date.getDate() + blocked_days)
        } else if (slot.min_booking_period === 4) {
          //months
          const currentDate = getNow();
          const futureDate = new Date(currentDate.getTime());

          futureDate.setMonth(futureDate.getMonth() + parseInt(slot.min_booking_value));
          const timeDifference = futureDate.getTime() - currentDate.getTime();
          blocked_days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          unblock_date.setDate(unblock_date.getDate() + blocked_days)
        } else if (slot.min_booking_period === null) {
          unblock_date = getNow()
        }
      }

      // Determine if slot should be call-to-book
      if (slot.allow_late_booking === 1) {
        // Late booking restrictions only apply AFTER the slot has started
        if (currentTime >= slot_date) {
          // Slot has started - check if we're past the deadline
          return currentTime > unblock_date;
        } else {
          // Slot hasn't started yet - should be available (not call to book)
          return false;
        }
      } else {
        // Normal booking: call-to-book if within the advance booking window
        return slot_date <= unblock_date;
      }
    },
    getOrderedTimeSlots(game, slots){
      let s = []

      if(this.bss.show_unavailable_slots === 0){
        for(let n in JSON.parse(slots)){
          let slot = JSON.parse(slots)[n]
          // Custom-status slots: visibility comes from online_display_mode, not
          // show_unavailable_slots. 'hidden' never shows; 'bookable'/'non_bookable' always show.
          if(slot.online_display_mode === 'hidden') continue
          if(slot.online_display_mode === 'bookable' || slot.online_display_mode === 'non_bookable'){
            s.push(slot)
            continue
          }
          // Claimed by a pending request: hides exactly as a booked private slot.
          if(slot.status === 'requested') continue
          // Requestable with the template toggle off, or on a public master
          // (requests are private-only): hides exactly as blocked.
          if(slot.status === 'requestable' && (!this.allowRequestToBook || this.isPublicBooking(game, slot))) continue
          if(this.isPublicBooking(game, slot)
            || (slot.status !== 'booked' && slot.status !== 'blocked')){
            s.push(slot)
          }
        }
      } else {
        // Show everything except hidden custom statuses, which must never appear online.
        s = (JSON.parse(slots) || []).filter(slot => slot.online_display_mode !== 'hidden')
      }

      if(s === null){
        s = []
      }
      // let displayedSlots = []
      let blocked_days = 0
      let blocked_minutes = 0
      let slot_date = new Date()
      //Don't show min period
      for(let n in s) {
        // Start from the 1st: the date begins as today, and setting the month while on
        // the 29th-31st overflows into the following month when the target month is shorter
        slot_date.setDate(1)
        slot_date.setFullYear(s[n].booking_date.split('-')[0])
        slot_date.setMonth(parseInt(s[n].booking_date.split('-')[1]) - 1)
        slot_date.setDate(s[n].booking_date.split('-')[2])
        slot_date.setHours(s[n].start_time.split(':')[0])
        slot_date.setMinutes(s[n].start_time.split(':')[1])
        blocked_days = 0
        blocked_minutes = 0
        let unblock_date = getNow()

        // When allow_late_booking is 1, calculate deadline from slot start time
        // Otherwise, calculate minimum advance booking time from current time
        if (s[n].allow_late_booking === 1) {
          // Late booking: calculate deadline as slot_start_time + min_booking_value
          unblock_date = new Date(slot_date.getTime())

          if (s[n].min_booking_period === 0) {
            blocked_minutes = s[n].min_booking_value
            unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
          } else if (s[n].min_booking_period === 1) {
            blocked_minutes = parseInt(s[n].min_booking_value) * 60
            unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
          } else if (s[n].min_booking_period === 2) {
            blocked_days = s[n].min_booking_value
            unblock_date.setDate(unblock_date.getDate() + blocked_days)
          } else if (s[n].min_booking_period === 3) {
            blocked_days = 7 * parseInt(s[n].min_booking_value)
            unblock_date.setDate(unblock_date.getDate() + blocked_days)
          } else if (s[n].min_booking_period === 4) {
            //months
            const slotDate = new Date(unblock_date.getTime());
            const futureDate = new Date(slotDate.getTime());

            futureDate.setMonth(futureDate.getMonth() + parseInt(s[n].min_booking_value));
            const timeDifference = futureDate.getTime() - slotDate.getTime();
            blocked_days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            unblock_date.setDate(unblock_date.getDate() + blocked_days)
          } else if (s[n].min_booking_period === null) {
            unblock_date = new Date(slot_date.getTime())
          }
        } else {
          // Normal booking: calculate minimum advance booking from current time
          if (s[n].min_booking_period === 0) {
            blocked_minutes = s[n].min_booking_value
            unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
          } else if (s[n].min_booking_period === 1) {
            blocked_minutes = parseInt(s[n].min_booking_value) * 60
            unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
          } else if (s[n].min_booking_period === 2) {
            blocked_days = s[n].min_booking_value
            unblock_date.setDate(unblock_date.getDate() + blocked_days)
          } else if (s[n].min_booking_period === 3) {
            blocked_days = 7 * parseInt(s[n].min_booking_value)
            unblock_date.setDate(unblock_date.getDate() + blocked_days)
          } else if (s[n].min_booking_period === 4) {
            //months
            const currentDate = getNow();
            const futureDate = new Date(currentDate.getTime());

            futureDate.setMonth(futureDate.getMonth() + parseInt(s[n].min_booking_value));
            const timeDifference = futureDate.getTime() - currentDate.getTime();
            blocked_days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            unblock_date.setDate(unblock_date.getDate() + blocked_days)
          } else if (s[n].min_booking_period === null) {
            unblock_date = getNow()
          }
        }

        let  max_days = 0

        //calculate the number of days in the future to make booking slots for
        if(s[n].max_booking_period === 0){
          max_days = parseInt(s[n].max_booking_value)
        } else if (s[n].max_booking_period === 1){
          max_days = parseInt(s[n].max_booking_value) * 7
        } else if (s[n].max_booking_period === 2){
          let future = getNow()
          let today = getNow()
          future.setMonth(future.getMonth() + parseInt(s[n].max_booking_value))
          let diffTime = Math.abs(future - today)
          max_days = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        } else if (s[n].max_booking_period === 3){
          let future = getNow()
          let today = getNow()
          future.setFullYear(future.getFullYear() + parseInt(s[n].max_booking_value))
          let diffTime = Math.abs(future - today)
          max_days = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        } else if (s[n].max_booking_period === null){
          max_days = 10
        }

        let max_date = getNow()
        max_date.setDate(max_date.getDate() + max_days)

        if (s[n].allow_late_booking === 1) {
          // Late booking: only block if past the deadline (late booking restrictions only apply after slot starts)
          const currentTime = getNow();
          // Before slot starts: available (not blocked)
          // After slot starts but before deadline: available (late booking window)
          // After deadline: blocked
          if(currentTime > unblock_date){
            s[n].block = true
          }
          else {
            s[n].block = false
          }
        } else {
          // Normal booking: block if slot is too soon
          if(slot_date <= unblock_date){
            s[n].block = true
          }
          else {
            s[n].block = false
          }
        }

        if(slot_date >= max_date) {
          s[n].remove = true
        } else {
          s[n].remove = false
        }

        // When the slot has crossed its minimum-notice (or late-booking) window and the
        // schedule opted to hide rather than call-to-book, drop it from the page entirely.
        if (s[n].block && Number(s[n].hide_past_min_notice) === 1) {
          s[n].remove = true
        }

      }

      const visibleSlots = s.filter(slot => !slot.remove);
      return _.orderBy(visibleSlots, 'start_time')
    },
    goToCheckIn(){
      let code = this.$route.params.company
      let path = '/checkin/' + code
      if(this.bss.display_waiver_link){
        path = '/waiver/' + this.hash
      }
      this.$router.push(path)
    },
    goHome(){
      if (window !== window.top) {
        window.open(this.bss.redirect_url, '_blank');
      } else {
        window.location.href = this.bss.redirect_url
      }
    },
    getDate(d){
      return date(d)
    },
    getTime(format, d){
      return time(format, d)
    },
    toProfile(){
      this.$router.push('/settings/profile')
    },
    login(){
      let redirect = '/book/' + this.$route.params.company
      localStorage.setItem('redirect', redirect)
      this.$router.push('/login')
    },
    async isAuthenticated(){
      let token = await this.getAuthToken()
      if(token == 'No current user'){
        this.is_authenticated = false
      } else {
        this.is_authenticated = true
        // Merge over data() defaults — a stored user predating newer fields
        // (zip/address) must not wipe them out or they lose reactivity
        const storedUser = JSON.parse(localStorage.getItem('user'))
        if (storedUser) {
          this.user = { ...this.user, ...storedUser }
        }
      }
    },
    getFormattedDate(format, d){
      return formattedDate(format, d)
    },
    getDayOfWeek(d){
      if(this.locale.show_day_of_week){
        return dayOfWeek(d)
      }
      return ''
    },
    async removeBooking(index, item){

      this.cart.splice(index, 1)
      // Value leaving the cart: the line itself plus, for a booking, the
      // add-ons that go with it below.
      let removedValue = parseFloat(item.subtotal) || 0
      //Cart event
      let booking_slot_id = item.hasOwnProperty('booking') ? item.booking.id : null
      let items_id = item.hasOwnProperty('item') ? item.item.id : null
      //Remove addons for associated booking
      if(booking_slot_id && !items_id){
        for (let n in this.cart) {
          if (this.cart[n].hasOwnProperty('item') && this.cart[n].booking.id === item.booking.id) {
            removedValue += parseFloat(this.cart[n].subtotal) || 0
          }
        }
        this.cart = this.cart.filter(cartItem =>
          !(cartItem.hasOwnProperty('item') && cartItem.booking.id === item.booking.id)
        );
      }
      removedValue = Number(this.roundToFixed(removedValue, 2))
      if(window.dataLayer) {
        window.dataLayer.push({
          event: 'remove_from_cart',
          currency: this.locale.currency,
          value: removedValue
        });
      }
      if(window.gtag) {
        if (window !== window.top) {
          let eventData = {
            eventType: 'remove_from_cart',
            eventValue: removedValue,
            currency: this.locale.currency
          }
          this.$nextTick(() => {
            this.postMessageTrackingEvent(eventData)
          });
        } else {
          gtag("event", "remove_from_cart", {
            currency: this.locale.currency,
            value: removedValue
          })
        }
      }
      await this.addToCart(5, 1)
      //Pay on arrival or deposit
      this.computeDeposit()
    },
    async recalculatePromos(source){
      if(source === 'deposit'){
        this.applied_gift_cards = []
      }
      // Clear all cart item discounts before recalculating
      for(let n in this.cart){
        this.cart[n].discount = 0
      }
      if(this.cart.length <= 0){
        this.promo_codes = []
      } else {
        let bookings = []
        if(this.promo_codes.length <= 0){
          this.computeDeposit()
        }
        let promoCodesToRecalculate = this.promo_codes.slice()
        this.promo_codes = []
        for(let m in promoCodesToRecalculate){
          bookings = []
          for(let n in this.cart){
            if(this.cart[n].hasOwnProperty('gift_card')){
              bookings.push({type: 'gift_card', subtotal: this.cart[n].subtotal})
            }else if(this.cart[n].hasOwnProperty('item')){
              bookings.push({type: 'item', subtotal: this.cart[n].subtotal})
            }else{
              bookings.push({id: this.cart[n].booking.id, booking_date: this.cart[n].booking.booking_date,
                start_time:  this.cart[n].booking.start_time,
                game_id: this.cart[n].game.game_id, subtotal: this.cart[n].subtotal,
                group_size: this.cart[n].quantity})
            }
          }

          let name = promoCodesToRecalculate[m].name

          let code = this.$route.params.company
          let url = API_LOCATION + 'bookings/company-groups/' + code + '/promos-v2?code=' + encodeURIComponent(name) +
            '&cart_id=' + encodeURIComponent(this.cart_id)

          try {
            let response = await this.axios.get(url)
            if(JSON.stringify(response.data.promo_code) === '{}'){
              swal({
                title: this.$t('book.swals.error'),
                text: this.$t('book.swals.invalidPromoCode'),
                type: 'error',
                confirmButtonColor: '#1d8cf8',
                confirmButtonText: 'OK'
              })
              this.computeDeposit()
              return
            } else {
              if(parseFloat(response.data.promo_code.value_amount) < 0){
                swal({
                  title: this.$t('book.swals.error'),
                  text: this.$t('book.swals.promoCodeCannotBeApplied'),
                  type: 'error',
                  confirmButtonColor: '#1d8cf8',
                  confirmButtonText: 'OK'
                })
                return
              }
              this.promo_code = ''
              let dupe = false
              for(let n in this.promo_codes){
                if(this.promo_codes[n].name === response.data.promo_code.name){
                  dupe = true
                }
                if(this.promo_codes[n].is_combineable === 0 || response.data.promo_code.is_combineable === 0){
                  swal(this.$t('book.swals.error'), this.$t('book.swals.nonCombineablePromo'), 'error')
                  return
                }
              }
              if(!dupe){
                let value_amount = parseFloat(response.data.promo_code.value_amount)
                if(this.getTotalAmount() < value_amount){
                  value_amount = this.getTotalAmount()
                }

                // Apply discounted_items to cart items
                const discountedItems = response.data.promo_code.discounted_items || []
                this.applyDiscountedItemsToCart(discountedItems)

                this.promo_codes.push(
                  {
                    id: response.data.promo_code.id,
                    name: response.data.promo_code.name,
                    value_amount: value_amount,
                    display_amount: response.data.promo_code.display_amount != null
                      ? Math.min(parseFloat(response.data.promo_code.display_amount), this.getCartSubtotal())
                      : value_amount,
                    raw_value_amount: response.data.promo_code.raw_value_amount,
                    is_combineable: response.data.promo_code.is_combineable,
                    redemption_type: response.data.promo_code.redemption_type,
                    value_type: response.data.promo_code.value_type,
                    discounted_items: discountedItems
                  }
                )
              }
            }
            this.recalculateTaxesAndFees()
            this.computeDeposit()
            this.addToCart(5)
          } catch(err) {
            console.log(err)
            if(err.response && err.response.status == 401){
              this.$router.push('/forbidden')
            }
          }
        }
        // A code the cart no longer qualifies for is dropped in the catch above.
        // Resync totals and the server cart so the discount, taxes, fees and
        // deposit all reflect the drop.
        if(promoCodesToRecalculate.length !== this.promo_codes.length){
          this.recalculateTaxesAndFees()
          this.computeDeposit()
          this.addToCart(5)
        }
      }
    },
    getNumberFormat(value) {
      if (this.locale.currency === 'SEK' || this.locale.currency === 'DKK') {
        // Swedish formatting: space as thousands separator, comma as decimal
        return parseFloat(value).toLocaleString(this.locale.currency === 'DKK' ? 'da-DK' : 'sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      // Existing logic for other currencies
      if (this.locale.number_format === 1) {
        value = value.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
      }
      return value;
    },
    getCartSubtotal(){
      let subtotal = 0
      for(let n in this.cart){
        subtotal += parseFloat(this.cart[n].subtotal)
      }
      return Number(Math.round(Number(subtotal + 'e2')) + 'e-2')
    },
    getFee(f){
      let bookings_in_cart = 0
      let subtotalAmount = 0
      f.computed_amount = 0
      for(let n in this.cart){
        subtotalAmount += parseFloat(this.cart[n].subtotal)
        bookings_in_cart++
      }
      if(f.value_type === 0 && bookings_in_cart > 0){
        // if(!f.covered_by_promo_codes && this.getDiscounts() >= f.amount){
        //   f.computed_amount = 0
        //   return 0
        // }
        f.computed_amount = f.amount
        return f.amount
      }

      if(f.value_type === 1){
        let feeItemLinks = []
        if(!f.apply_to_all_items){
          const linked_games = JSON.parse(f.linked_games)
          const linked_items = JSON.parse(f.linked_items)
          const linked_gift_card_types = JSON.parse(f.linked_gift_card_types)
          feeItemLinks = linked_games.concat(linked_items).concat(linked_gift_card_types)
        }

        let total_fee = 0
        let quantity = 0
        for(let n in this.cart){
          let found = null
          quantity = this.cart[n].quantity
          if(this.cart[n].hasOwnProperty('item')){
            found = _.find(feeItemLinks, {id: this.cart[n].item.id})
          } else if(this.cart[n].hasOwnProperty('gift_card')){
            quantity = this.cart[n].gift_card.quantity
            found = _.find(feeItemLinks, {id: this.cart[n].gift_card.gift_card_type_id})
          } else {
            found = _.find(feeItemLinks, {id: this.cart[n].game.game_id})
          }

          if((!f.apply_to_all_items && found) || f.apply_to_all_items){
            total_fee += f.amount * quantity
          }
        }

        // if(f.covered_by_promo_codes && this.getDiscounts() >= total_fee){
        //   f.computed_amount = 0
        //   return 0
        // }
        f.computed_amount = total_fee
        return total_fee
      }

      if(f.value_type === 2){
        if(f.covered_by_promo_codes){
          subtotalAmount = subtotalAmount - this.getDiscounts()
          subtotalAmount = Math.max(0, subtotalAmount)
        }

        f.computed_amount = this.getPercentage(f.amount, subtotalAmount)
        return f.computed_amount
      }

      if(f.value_type === 3){
        let feeItemLinks = []
        if(!f.apply_to_all_items){
          const linked_games = JSON.parse(f.linked_games)
          const linked_items = JSON.parse(f.linked_items)
          const linked_gift_card_types = JSON.parse(f.linked_gift_card_types)
          feeItemLinks = linked_games.concat(linked_items).concat(linked_gift_card_types)
        }

        let total_fee = 0
        for(let n in this.cart){

          let found = null
          if(this.cart[n].hasOwnProperty('item')){
            found = _.find(feeItemLinks, {id: this.cart[n].item.id})
          } else if(this.cart[n].hasOwnProperty('gift_card')){
            found = _.find(feeItemLinks, {id: this.cart[n].gift_card.gift_card_type_id})
          } else {
            found = _.find(feeItemLinks, {id: this.cart[n].game.game_id})
          }

          if((!f.apply_to_all_items && found) || f.apply_to_all_items){
            total_fee += f.amount
          }
        }
        // if(!f.covered_by_promo_codes && this.getDiscounts() >= total_fee){
        //   f.computed_amount = 0
        //   return 0
        // }
        f.computed_amount = total_fee
        return total_fee
      }

      if(f.value_type === 4){
        let feeItemLinks = []
        if(!f.apply_to_all_items){
          const linked_games = JSON.parse(f.linked_games)
          const linked_items = JSON.parse(f.linked_items)
          const linked_gift_card_types = JSON.parse(f.linked_gift_card_types)
          feeItemLinks = linked_games.concat(linked_items).concat(linked_gift_card_types)
        }

        let total_fee = 0
        for(let n in this.cart){
          let found = null

          if(this.cart[n].hasOwnProperty('item')){
            found = _.find(feeItemLinks, {id: this.cart[n].item.id, item_type: 'item'})
          } else if(this.cart[n].hasOwnProperty('gift_card')){
            found = _.find(feeItemLinks, {id: this.cart[n].gift_card.gift_card_type_id, item_type: 'gift_card'})
          } else {
            found = _.find(feeItemLinks, {id: this.cart[n].game.game_id, item_type: 'game'})
          }
          if((!f.apply_to_all_items && found) || f.apply_to_all_items){
            subtotalAmount = this.cart[n].subtotal
            if(f.covered_by_promo_codes){
              let itemDiscount = this.cart[n].discount || 0
              subtotalAmount = this.cart[n].subtotal - itemDiscount
              subtotalAmount = Math.max(0, subtotalAmount)
            }
            total_fee += this.getPercentage(f.amount, subtotalAmount)
          }
        }

        f.computed_amount = total_fee
        return f.computed_amount
      }
      return 0
    },
    getProportionalDiscount(itemSubtotal) {
      const totalDiscount = this.getDiscounts()
      if (totalDiscount === 0) return 0

      // Calculate total cart subtotal (excluding gift cards)
      let cartSubtotal = 0
      for(let n in this.cart){
        if(!this.cart[n].hasOwnProperty('gift_card')){
          cartSubtotal += parseFloat(this.cart[n].subtotal)
        }
      }

      if (cartSubtotal === 0) return 0

      // Calculate this item's proportion of the discount
      const proportion = itemSubtotal / cartSubtotal
      const itemDiscount = totalDiscount * proportion

      // Can't discount more than the item's value
      return Math.min(itemDiscount, itemSubtotal)
    },
    hasBookingsInCart(){
      let bookings_count = 0
      for(let n in this.cart){
        if(!this.cart[n].hasOwnProperty('gift_card')){
          bookings_count++
        }
      }
      return bookings_count > 0 ? true : false
    },
    getTaxForGame(t, subtotal, group_size, booking){
      let subtotalAmount = subtotal
      let tax_value = 0

      if(t.pricing_type === 0){
        if(t.value_type === 0){
          t.computed_amount = t.amount
          return t.amount
        }

        if(t.value_type === 1){
          let taxItemLinks = []
          if(!t.apply_to_all_items){
            const linked_games = JSON.parse(t.linked_games)
            const linked_items = JSON.parse(t.linked_items)
            taxItemLinks = linked_games.concat(linked_items)
          }

          let total_tax = 0
          let found =  _.find(taxItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
          if((!t.apply_to_all_items && found) || t.apply_to_all_items){
            total_tax += t.amount * group_size
          }
          t.computed_amount = total_tax
          return total_tax
        }

        if(t.value_type === 2){

          if(t.is_compound){
            let compound_tax = this.getCompoundTaxAmount(t)
            subtotalAmount = subtotalAmount + compound_tax
          }

          if(t.pricing_type === 1){
            const baseAmount = parseFloat(this.roundToFixed(subtotalAmount / (1 + (this.getInclusiveRateFor() * 0.01)), 2))
            t.computed_amount = parseFloat(this.roundToFixed(baseAmount * (t.amount * 0.01), 2))
          } else {
            t.computed_amount = this.getPercentage(t.amount, subtotalAmount)
          }

          return t.computed_amount
        }

        if(t.value_type === 3){
          let taxItemLinks = []
          if(!t.apply_to_all_items){
            const linked_games = JSON.parse(t.linked_games)
            const linked_items = JSON.parse(t.linked_items)
            taxItemLinks = linked_games.concat(linked_items)
          }

          let total_tax = 0
          let found =  _.find(taxItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
          if((!t.apply_to_all_items && found) || t.apply_to_all_items){
            total_tax += t.amount
          }
          t.computed_amount = total_tax
          return total_tax
        }

        if(t.value_type === 4){
          let taxItemLinks = []
          if(!t.apply_to_all_items){
            const linked_games = JSON.parse(t.linked_games)
            const linked_items = JSON.parse(t.linked_items)
            taxItemLinks = linked_games.concat(linked_items)
          }

          let total_tax = 0
          let found =  _.find(taxItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
          if((!t.apply_to_all_items && found) || t.apply_to_all_items){
            if(t.is_compound){
              let compound_tax = this.getCompoundTaxAmount(t)
              subtotalAmount = subtotalAmount + compound_tax
            }
            total_tax += this.getPercentage(t.amount, subtotalAmount)
          }

          t.computed_amount = total_tax
          return t.computed_amount
        }
      }
      return tax_value
    },
    getFeeForGame(fee, subtotal, group_size){
      let fee_value = 0
      let subtotalAmount = subtotal
      if(fee.value_type === 0){
        fee_value = fee.amount
      }

      if(fee.value_type === 1){
        let feeItemLinks = []
        if(!fee.apply_to_all_items){
          const linked_games = JSON.parse(fee.linked_games)
          feeItemLinks = linked_games
        }

        let found = _.find(feeItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
        if((!fee.apply_to_all_items && found) || fee.apply_to_all_items){
          fee_value = fee.amount * group_size
        }
      }

      if(fee.value_type === 2){
        fee_value = this.getPercentage(fee.amount, subtotalAmount)
      }

      if(fee.value_type === 3){
        let feeItemLinks = []
        if(!fee.apply_to_all_items){
          const linked_games = JSON.parse(fee.linked_games)
          feeItemLinks = linked_games
        }

        let found = _.find(feeItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
        if((!fee.apply_to_all_items && found) || fee.apply_to_all_items){
          fee_value = fee.amount
        }
      }

      if(fee.value_type === 4){
        let feeItemLinks = []
        if(!fee.apply_to_all_items){
          const linked_games = JSON.parse(fee.linked_games)
          feeItemLinks = linked_games
        }

        let found = _.find(feeItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
        if((!fee.apply_to_all_items && found) || fee.apply_to_all_items){
          fee_value = this.getPercentage(fee.amount, subtotalAmount)
        }
      }
      return fee_value
    },
    getSubtotalWithTaxFee(subtotal, group_size){
      let taxes = 0
      let fees = 0
      let subtotalWithTaxFee = 0
      for(let n in this.taxes){
        if(this.taxes[n].pricing_type === 0){
          let subtotalAmount = subtotal
          if(this.taxes[n].value_type === 0){
            taxes += this.taxes[n].amount
          }

          if(this.taxes[n].value_type === 1){
            let taxItemLinks = []
            if(!this.taxes[n].apply_to_all_items){
              const linked_games = JSON.parse(this.taxes[n].linked_games)
              taxItemLinks = linked_games
            }

            let found = _.find(taxItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
            if((!this.taxes[n].apply_to_all_items && found) || this.taxes[n].apply_to_all_items){
              taxes += this.taxes[n].amount * group_size
            }
          }

          if(this.taxes[n].value_type === 2) {
            if (this.taxes[n].is_compound) {
              // Compound base: the taxes already computed for THIS amount, not
              // the cart-wide computed_amount values (stale or empty here).
              subtotalAmount = subtotalAmount + taxes
            }

            taxes += this.getPercentage(this.taxes[n].amount, subtotalAmount)
          }

          if(this.taxes[n].value_type === 3){
            let taxItemLinks = []
            if(!this.taxes[n].apply_to_all_items){
              const linked_games = JSON.parse(this.taxes[n].linked_games)
              taxItemLinks = linked_games
            }

            let found = _.find(taxItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
            if((!this.taxes[n].apply_to_all_items && found) || this.taxes[n].apply_to_all_items){
              taxes += this.taxes[n].amount
            }
          }

          if(this.taxes[n].value_type === 4){
            let taxItemLinks = []
            if(!this.taxes[n].apply_to_all_items){
              const linked_games = JSON.parse(this.taxes[n].linked_games)
              taxItemLinks = linked_games
            }

            let found = _.find(taxItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})

            if((!this.taxes[n].apply_to_all_items && found) || this.taxes[n].apply_to_all_items){
              if(this.taxes[n].is_compound){
                subtotalAmount = subtotalAmount + taxes
              }
              taxes += this.getPercentage(this.taxes[n].amount, subtotalAmount)
            }
          }
        }
      }

      for(let n in this.fees){
        let subtotalAmount = subtotal
        if(this.fees[n].value_type === 0){
          fees += this.fees[n].amount
        }

        if(this.fees[n].value_type === 1){
          let feeItemLinks = []
          if(!this.fees[n].apply_to_all_items){
            const linked_games = JSON.parse(this.fees[n].linked_games)
            feeItemLinks = linked_games
          }

          let found = _.find(feeItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
          if((!this.fees[n].apply_to_all_items && found) || this.fees[n].apply_to_all_items){
            fees += this.fees[n].amount * group_size
          }
        }

        if(this.fees[n].value_type === 2){
          fees += this.getPercentage(this.fees[n].amount, subtotalAmount)
        }

        if(this.fees[n].value_type === 3){
          let feeItemLinks = []
          if(!this.fees[n].apply_to_all_items){
            const linked_games = JSON.parse(this.fees[n].linked_games)
            feeItemLinks = linked_games
          }

          let found = _.find(feeItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
          if((!this.fees[n].apply_to_all_items && found) || this.fees[n].apply_to_all_items){
            fees += this.fees[n].amount
          }
        }

        if(this.fees[n].value_type === 4){
          let feeItemLinks = []
          if(!this.fees[n].apply_to_all_items){
            const linked_games = JSON.parse(this.fees[n].linked_games)
            feeItemLinks = linked_games
          }

          let found = _.find(feeItemLinks, {id: this.selectedGame ? this.selectedGame.game_id : null})
          if((!this.fees[n].apply_to_all_items && found) || this.fees[n].apply_to_all_items){
            fees += this.getPercentage(this.fees[n].amount, subtotalAmount)
          }
        }
      }
      subtotalWithTaxFee = subtotal + taxes + fees
      return subtotalWithTaxFee
    },
    isTaxApplicableToCart(tax) {
      if (tax.apply_to_all_items) {
        return true;
      }

      const linked_games = JSON.parse(tax.linked_games || '[]');
      const linked_items = JSON.parse(tax.linked_items || '[]');
      const taxItemLinks = linked_games.concat(linked_items);

      if (taxItemLinks.length === 0) {
        return false;
      }

      for (let n in this.cart) {
        if (this.cart[n].hasOwnProperty('item')) {
          const found = _.find(taxItemLinks, {id: this.cart[n].item.id, item_type: 'item'});
          if (found) return true;
        } else if (this.cart[n].hasOwnProperty('game')) {
          const found = _.find(taxItemLinks, {id: this.cart[n].game.game_id, item_type: 'game'});
          if (found) return true;
        }
      }

      return false;
    },
    getTax(t){
      let taxable_subtotal = 0
      let bookings_in_cart = 0
      t.computed_amount = 0
      for(let n in this.cart){
        if(!this.cart[n].hasOwnProperty('gift_card')){
          taxable_subtotal += parseFloat(this.cart[n].subtotal)
          bookings_in_cart++
        }
      }
      let subtotalAmount = taxable_subtotal
      if(t.value_type === 0 && bookings_in_cart > 0){
        t.computed_amount = t.amount
        return t.amount
      }

      if(t.value_type === 1){
        let taxItemLinks = []
        if(!t.apply_to_all_items){
          const linked_games = JSON.parse(t.linked_games)
          const linked_items = JSON.parse(t.linked_items)
          taxItemLinks = linked_games.concat(linked_items)
        }

        let total_tax = 0
        for(let n in this.cart){
          let found = null
          if(this.cart[n].hasOwnProperty('item')){
            found = _.find(taxItemLinks, {id: this.cart[n].item.id})
          } else {
            found = _.find(taxItemLinks, {id: this.cart[n].game.game_id})
          }

          if((!t.apply_to_all_items && found) || t.apply_to_all_items){
            total_tax += t.amount * this.cart[n].quantity
          }
        }
        t.computed_amount = total_tax
        return total_tax
      }

      if(t.value_type === 2){
        if(t.pricing_type === 1){
          // Inclusive tax: extract base first, then apply discount to base, then calculate tax
          let baseAmount = subtotalAmount / (1 + (this.getInclusiveRateFor() * 0.01))
          baseAmount = parseFloat(this.roundToFixed(baseAmount, 2))
          // Store original tax before discount for total calculation
          t.original_tax = parseFloat(this.roundToFixed(baseAmount * (t.amount * 0.01), 2))
          if(t.apply_after_discount){
            baseAmount = baseAmount - this.getTaxableDiscount()
            baseAmount = parseFloat(this.roundToFixed(baseAmount, 2))
            baseAmount = Math.max(0, baseAmount)
          }
          if(t.is_compound){
            let compound_tax = this.getCompoundTaxAmount(t)
            baseAmount = baseAmount + compound_tax
          }
          t.computed_amount = baseAmount * (t.amount * 0.01)
          t.computed_amount = parseFloat(this.roundToFixed(t.computed_amount, 2))
        } else {
          // Exclusive tax
          if(t.apply_after_discount){
            subtotalAmount = taxable_subtotal - this.getTaxableDiscount()
            subtotalAmount = Math.max(0, subtotalAmount)
          }
          if(t.is_compound){
            let compound_tax = this.getCompoundTaxAmount(t)
            subtotalAmount = subtotalAmount + compound_tax
          }
          t.computed_amount = this.getPercentage(t.amount, subtotalAmount)
        }
        return t.computed_amount
      }

      if(t.value_type === 3){
        let taxItemLinks = []
        if(!t.apply_to_all_items){
          const linked_games = JSON.parse(t.linked_games)
          const linked_items = JSON.parse(t.linked_items)
          taxItemLinks = linked_games.concat(linked_items)
        }

        let total_tax = 0
        for(let n in this.cart){

          let found = null
          if(this.cart[n].hasOwnProperty('item')){
            found = _.find(taxItemLinks, {id: this.cart[n].item.id})
          } else {
            found = _.find(taxItemLinks, {id: this.cart[n].game.game_id})
          }

          if((!t.apply_to_all_items && found) || t.apply_to_all_items){
            total_tax += t.amount
          }
        }
        t.computed_amount = total_tax
        return total_tax
      }

      if(t.value_type === 4){
        let taxItemLinks = []
        if(!t.apply_to_all_items){
          const linked_games = JSON.parse(t.linked_games)
          const linked_items = JSON.parse(t.linked_items)
          taxItemLinks = linked_games.concat(linked_items)
        }

        let total_tax = 0
        let total_original_tax = 0
        for(let n in this.cart){
          let found = null
          if(this.cart[n].hasOwnProperty('item')){
            found = _.find(taxItemLinks, {id: this.cart[n].item.id, item_type: 'item'})
          } else {
            found = _.find(taxItemLinks, {id: this.cart[n].game.game_id, item_type: 'game'})
          }
          if((!t.apply_to_all_items && found) || t.apply_to_all_items){

            subtotalAmount = this.cart[n].subtotal

            if(t.pricing_type === 1){
              // Inclusive tax: extract base first, then apply discount to base, then calculate tax
              let baseAmount = subtotalAmount / (1 + (this.getInclusiveRateFor(this.cart[n]) * 0.01))
              baseAmount = parseFloat(this.roundToFixed(baseAmount, 2))
              // Store original tax before discount for total calculation
              total_original_tax += parseFloat(this.roundToFixed(baseAmount * (t.amount * 0.01), 2))
              if(t.apply_after_discount){
                let itemDiscount = this.cart[n].discount || 0
                baseAmount = baseAmount - itemDiscount
                baseAmount = parseFloat(this.roundToFixed(baseAmount, 2))
                baseAmount = Math.max(0, baseAmount)
              }
              if(t.is_compound){
                let compound_tax = this.getCompoundTaxAmount(t)
                baseAmount = baseAmount + compound_tax
              }
              let itemTax = baseAmount * (t.amount * 0.01)
              total_tax += parseFloat(this.roundToFixed(itemTax, 2))
            } else {
              // Exclusive tax
              if(t.apply_after_discount){
                let itemDiscount = this.cart[n].discount || 0
                subtotalAmount = this.cart[n].subtotal - itemDiscount
                subtotalAmount = Math.max(0, subtotalAmount)
              }
              if(t.is_compound){
                let compound_tax = this.getCompoundTaxAmount(t)
                subtotalAmount = subtotalAmount + compound_tax
              }
              total_tax += this.getPercentage(t.amount, subtotalAmount)
            }
          }
        }

        t.original_tax = total_original_tax
        t.computed_amount = total_tax
        return t.computed_amount
      }
      return 0
    },
    getCompoundTaxAmount(t){
      let tax_amount = 0
      for (let n of this.taxes) {
        if (n.id === t.id) {
          break; // Only include earlier taxes
        }
        if (n.computed_amount) {
          tax_amount += n.computed_amount
        }
      }
      return tax_amount
    },
    getPercentage(amount, subtotal){
      if(subtotal && subtotal.toString().includes(',')){
        subtotal = subtotal.replace(',', '.')
      }
      if(amount && amount.toString().includes(',')){
        amount = amount.replace(',', '.')
      }
      const result = parseFloat(subtotal) * (parseFloat(amount) * 0.01)
      return parseFloat(this.roundToFixed(result, 2))
    },
    getCompoundSubtotal(){
      let subtotal = 0

      for(let n in this.cart){
        if(!this.cart[n].hasOwnProperty('gift_card')){
          subtotal += parseFloat(this.cart[n].subtotal)
        }
      }
      for(let t in this.taxes){
        if(this.taxes[t].pricing_type === 0){
          //value (total)
          if(this.taxes[t].value_type === 0){
            subtotal = subtotal + this.taxes[t].amount
          }
          //value (per person)
          if(this.taxes[t].value_type === 1){
            subtotal = subtotal + (this.taxes[t].amount * this.number_of_players)
          }
          //percentage
          if(this.taxes[t].value_type === 2){
            //not compound
            if(!this.taxes[t].is_compound){
              subtotal = subtotal + this.getPercentage(this.taxes[t].amount, subtotal)
            }
          }
        }
      }
      return subtotal
    },
    getTotalAmount(){
      let total = 0

      let subtotal = 0
      let bookings_in_cart = 0
      for(let n in this.cart){
        subtotal += parseFloat(this.cart[n].subtotal)
        if(!this.cart[n].hasOwnProperty('gift_card')){
          bookings_in_cart++
        }
      }

      let total_tax_amount = 0
      for(let n in this.taxes){
        if(this.taxes[n].pricing_type === 0) {
          if(this.taxes[n].computed_amount && this.taxes[n].computed_amount >= 0 && bookings_in_cart > 0 ){
            total_tax_amount += parseFloat(this.taxes[n].computed_amount)
          }
        }
      }

      let total_fee_amount = 0
      for(let n in this.fees){
        if(this.fees[n].computed_amount && this.fees[n].computed_amount >= 0){
          total_fee_amount += parseFloat(this.fees[n].computed_amount)
        }

      }

      let total_discounts = 0
      for(let n in this.promo_codes){
        total_discounts += parseFloat(this.promo_codes[n].value_amount)
      }

      const tipNum = parseFloat(this.applied_tip) || 0
      this.applied_tip = Number(Math.round(Number(tipNum + 'e2')) + 'e-2')

      // Reconcile inclusive tax savings: use shelfDiscount - exTaxDiscount instead of
      // the tax loop's originalTax - newTax to avoid penny rounding drift
      let exTaxDiscount = this.getTaxableDiscount()
      let shelfDiscount = this.getShelfPriceDiscounts()
      let inclusive_tax_savings = parseFloat(this.roundToFixed(shelfDiscount - exTaxDiscount, 2))
      if(inclusive_tax_savings < 0) inclusive_tax_savings = 0
      // Use ex-tax discount for the formula (matches backend), plus non-taxable
      // (gift card) discount which is excluded from getTaxableDiscount but still
      // needs to come off the total
      total_discounts = exTaxDiscount + this.getNonTaxableDiscount()

      total = subtotal + total_tax_amount + total_fee_amount - total_discounts - inclusive_tax_savings + this.applied_tip

      // Mirror backend update-transaction-values lambda (index.mjs:1560) which always
      // e-pattern normalizes the final total. Sub-half-cent drift (e.g. 5*42.99 - 214.95
      // = 2.84e-14) breaks the e-pattern because (2.84e-14).toString() is scientific
      // notation and concatenating 'e2' yields invalid '2.84e-14e2' → NaN. Backend
      // never hits this because its source values are DECIMAL columns (exact), but the
      // frontend's cart subtotals come from JS multiplication and carry drift.
      if (Math.abs(total) < 0.005) {
        total = 0
      } else {
        total = Number(Math.round(Number(total + 'e2')) + 'e-2')
      }

      this.payment.amount = total
      this.payment_intent_amount = total
      return total
    },
    recalculateTaxesAndFees() {
      for(let n in this.taxes) {
        this.getTax(this.taxes[n])
      }
      for(let n in this.fees) {
        this.getFee(this.fees[n])
      }
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    // Leaving the event card to re-pick a slot: the slot being edited leaves
    // the basket (with its add-ons) so the next pick replaces it instead of
    // sitting beside it. "Add another booking" keeps the basket and still
    // calls tabZero directly.
    async changeDateTime(source){
      const idx = this.cart.findIndex(c => c.booking && !c.hasOwnProperty('item')
        && !c.hasOwnProperty('gift_card') && this.selectedBooking
        && c.booking.id === this.selectedBooking.id)
      if(idx >= 0){
        await this.removeBooking(idx, this.cart[idx])
      }
      this.tabZero(0, source)
    },
    tabZero(index, source){
      this.gift_card_select = false
      this.show_addons = false
      this.addons = []
      this.scrollToTop()
      if(source === 1){
        this.show_calendar = false
      }
      this.$refs['wiz'].tabIndex(index);
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
    },
    giftCardSelect(){
      // Nothing joins a cart holding a booking request (server enforces too).
      if(this.cartHasRequest){
        swal(this.$t('book.swals.error'), this.$t('book.requestAloneMessage'), 'error')
        return
      }
      this.addToCart(4)
      this.scrollToTop()
      this.gift_card_select = true
      this.gift_card = {
        personal_message: '',
        design_url: '',
        custom_amount: '',
        recipient_first_name: '',
        recipient_last_name: '',
        recipient_email: '',
        total: 0,
        quantity: 1,
        send_instantly: true,
        delivery_date: new Date()
      }
      this.pricing_categories = []
      this.number_of_players = 0
      this.selectedGame = { difficulty_level: 0 }
      this.buttonGroupStyle = [{ 'font-family': this.bss.font_family_card,
        'border-color': this.bss.button_color,
        'background-color': this.bss.button_color,
        'background-image': 'linear-gradient(to bottom left,' + this.bss.button_color + ', ' + this.bss.button_color + ', ' + this.bss.button_color + ') !important',
        'color':  this.bss.card_color}, { 'font-family': this.bss.font_family_card,
        'border-color': this.bss.button_color, 'color': this.bss.button_color }]
      this.buttonGroupPriceStyle = [{ 'font-family': this.bss.font_family_card,
        'border-color': this.bss.button_color,
        'background-color': this.bss.button_color,
        'background-image': 'linear-gradient(to bottom left,' + this.bss.button_color + ', ' + this.bss.button_color + ', ' + this.bss.button_color + ') !important',
        'color':  this.bss.card_color}, { 'font-family': this.bss.font_family_card,
        'border-color': this.bss.button_color, 'color': this.bss.button_color }]
      this.getGiftCardSettings()
      this.$refs['wiz'].tabIndex(1);
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
    },
    getGiftCardSettings(){
      this.loading = true
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/gift-card-settings'
      axios.get(url)
        .then(response => {
          this.loading = false
          this.gift_card_types = response.data.gift_card_settings
          for(let n in this.gift_card_types){
            this.gift_card_types[n].game_display_mode = this.gift_card_types[n].game_display_mode || 0
            if(typeof this.gift_card_types[n].linked_game_ids === 'string'){
              this.gift_card_types[n].linked_game_ids = JSON.parse(this.gift_card_types[n].linked_game_ids)
            }
            if(!Array.isArray(this.gift_card_types[n].linked_game_ids)){
              this.gift_card_types[n].linked_game_ids = []
            }
          }
          this.selectedGiftCardType = this.gift_card_types[0]
          this.gift_card_designs = JSON.parse(this.gift_card_types[0].designs)
          this.has_addons = response.data.has_addons
          this.all_gift_card_games = response.data.games || []
          this.gift_card_games = this.all_gift_card_games
          this.selectGiftCardType(this.selectedGiftCardType)
          this.gift_card.design_url = this.gift_card_designs[0]
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    tabOne(index, game, slot){
      // Upsell state belongs to one "Book now" click; never carry it into another pick
      this.upsell_prefill_quantity = null
      this.upsell_promo_pending = null
      // User pressed back button (no game/slot) - check what to go back to
      if(!game && !slot){
        // Check the last item in cart to determine which flow user is in
        const lastCartItem = this.cart.length > 0 ? this.cart[this.cart.length - 1] : null
        const lastItemIsGiftCard = lastCartItem && lastCartItem.hasOwnProperty('gift_card')

        if(lastItemIsGiftCard){
          this.giftCardSelect()
          return
        }

        if(this.gift_card_select){
          // User is on gift card form but hasn't added to cart yet - go back to game selection (Step 0)
          this.$refs['wiz'].tabIndex(0);
          this.gift_card_select = false
          return
        }
      }

      // A slot click without a real game means the selection state was reset
      // (cart expiration). Return to event selection instead of building a
      // cart entry the backend can never accept.
      if(slot && (!game || !game.game_id)){
        this.tabZero(0, 1)
        return
      }

      // Booking requests are single purpose: a requestable slot cannot join a
      // cart holding anything else, and nothing joins a cart holding a
      // request. The server enforces the same rule; this is the UX layer.
      if(game && slot){
        const slotIsRequest = this.isRequestToBookSlot(game, slot)
        const otherCartItems = this.cart.filter(c => !(c && c.booking && c.booking.id === slot.id))
        if((slotIsRequest && otherCartItems.length > 0) || (!slotIsRequest && this.cartHasRequest)){
          swal(this.$t('book.swals.error'), this.$t('book.requestAloneMessage'), 'error')
          return
        }
        slot.is_request_booking = slotIsRequest
      }

      this.gift_card_select = false
      this.show_addons = false
      this.addons = []
      this.selected_duration = null
      this.durations = []
      this.errors.number_of_players = ''
      this.scrollToTop()
      if(game && slot){
        this.selectedGame = game
        this.selectedBooking = slot
        this.number_of_players = this.selectedGame.min_players_count
        this.getPricing()
      }

      this.$refs['wiz'].tabIndex(index);
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
      this.addToCart(2)
    },
    isCardHolderValid(){
      let errors = 0
      const isStripeCardFlow = this.selectedPaymentOption.name !== 'Card' ||
        (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id !== 3) ||
        (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 3 && this.stripe_payment_method === 'card')


      if ((this.payment.cardholder_last_name == '' || this.sanitizeNameInput(this.payment.cardholder_last_name) === '' )
        && !this.noCaptureCheckout && isStripeCardFlow) {
        this.errors.cardholder_last_name = this.$t('checkin.errors.lastName')
        errors++
      } else {
        this.errors.cardholder_last_name = ""
      }
      if ((this.payment.cardholder_first_name == '' || this.sanitizeNameInput(this.payment.cardholder_first_name) === '')
        && !this.noCaptureCheckout && isStripeCardFlow) {
        this.errors.cardholder_first_name = this.$t('checkin.errors.firstName')
        errors++
      } else {
        this.errors.cardholder_first_name = ""
      }
      if(errors > 0){
        return false
      }
      return true
    },
    async applyGiftCard(){
      this.invalidateWalletPending()
      if(!this.isCardHolderValid()){
        return
      }
      if(this.getTotalAmount() <= 0){
        swal({
          title: this.$t('book.swals.error'),
          text: this.$t('book.swals.cannotApplyGiftCard'),
          type: 'error'
        })
        return
      }
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/gift-cards?cart_id=' + this.cart_id
      let data = {
        gift_card_code: this.gift_card_code,
        email: this.user.email
      }

      axios.post(url, data)
        .then(response => {
          this.gift_card_code = ''
          let existing_gift_card = _.find(this.applied_gift_cards, {id: response.data.gift_card.id })
          if(!existing_gift_card && this.due_now > 0){
            let cart_total = this.due_now
            // Store the original remaining balance from API response (before this purchase)
            let original_balance = response.data.gift_card.remaining

            if(response.data.gift_card.remaining > cart_total){
              response.data.gift_card.remaining = cart_total
            }

            // Calculate remaining balance after this purchase
            response.data.gift_card.balance_from_api = original_balance - response.data.gift_card.remaining

            this.applied_gift_cards.push(response.data.gift_card)
          }

          this.due_now = this.getDueNow()
          this.computeDeposit()
          if(this.due_now <= 0){
            this.due_now = 0
          }
          this.setDisableSubmit()
          this.loading = false
          swal({
            text: this.$t('book.swals.giftCardApplied'),
            type: 'success'
          })

        })
        .catch(err => {
          swal({
            title: this.$t('book.swals.error'),
            text: this.$t('book.swals.invalidGiftCard'),
            type: 'error'
          })
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    async updateStripePaymentIntent(amount){
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/payment/stripe-payment-intent'

      const bookingSlotIds = this.cart
        .filter(c => c.booking && c.booking.id)
        .map(c => c.booking.id)

      let data = {
        currency: this.locale.currency,
        total: amount,
        paymentIntent: this.payment_intent_id,
        setup_future_usage: this.save_card_for_future ? 'off_session' : null,
        cart_id: this.cart_id,
        email: this.user.email,
        booking_slot_ids: bookingSlotIds
      }

      axios.post(url, data)
        .then(response => {
          if(response.data.clientSecret){
            this.payment_intent_id = response.data.clientSecret.split('_')[0] + '_' + response.data.clientSecret.split('_')[1]
            this.reInitializeStripe(response.data.clientSecret);
          }
        })
        .catch(err => {
          this.loading = false

          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })

    },
    validateGiftCard(){
      let errors = 0

      if(!this.gift_card.send_to_self && (this.gift_card.recipient_email == '' || !this.isValidEmail(this.gift_card.recipient_email))){
        this.errors.gift_card.email = this.$t('book.errors.email')
        errors++
      } else {
        this.errors.gift_card.email = ''
      }
      if((this.gift_card.recipient_first_name == '' || this.sanitizeNameInput(this.gift_card.recipient_first_name) === '')
        && !this.gift_card.send_to_self){
        this.errors.gift_card.first_name = this.$t('checkin.errors.firstName')
        errors++
      } else {
        this.errors.gift_card.first_name = ''
      }
      if(!this.gift_card.send_to_self &&
        (this.gift_card.recipient_last_name == ''|| this.sanitizeNameInput(this.gift_card.recipient_last_name) === '')){
        this.errors.gift_card.last_name = this.$t('checkin.errors.lastName')
        errors++
      } else {
        this.errors.gift_card.last_name = ''
      }
      if(this.selectedGiftCardType.require_terms && !this.gift_card.terms){
        this.errors.gift_card.terms = this.$t('book.errors.terms')
        errors++
      } else {
        this.errors.gift_card.terms = ''
      }

      if(this.selectedGiftCardType.value_type === 0 && (this.gift_card.custom_amount <= 0 || this.gift_card.custom_amount === undefined)){
        this.errors.gift_card.custom_amount = this.$t('book.errors.value')
        errors++
      } else {
        this.errors.gift_card.custom_amount = ''
      }

      return errors > 0 ? false : true
    },
    async setGiftCard(step){
      if(!this.show_addons && !this.validateGiftCard()){
        return
      }
      if(!step && this.has_addons && !this.show_addons){
        await this.getAddons(0)
        this.show_addons = true
      } else {
        this.show_addons = false
      }

      this.scrollToTop()
      if(!step){
        const giftCardData = {
          game: this.selectedGame,
          gift_card: {
            name: this.selectedGiftCardType.name,
            personal_message: this.gift_card.personal_message,
            design_url: this.gift_card.design_url,
            custom_amount: this.gift_card.custom_amount,
            recipient_first_name: this.gift_card.recipient_first_name,
            recipient_last_name: this.gift_card.recipient_last_name,
            recipient_email: this.gift_card.recipient_email,
            price: this.gift_card.unit_price,
            quantity: this.gift_card.quantity,
            game_id: this.selectedGame.game_id,
            number_of_participants: this.number_of_players,
            send_to_self: this.gift_card.send_to_self,
            send_instantly: this.gift_card.send_instantly,
            delivery_date: this.gift_card.send_instantly ? null : this.gift_card.delivery_date,
            total: this.gift_card.unit_value,
            gift_card_type_id: this.selectedGiftCardType.id
          },
          quantity: this.number_of_players,
          subtotal: this.gift_card.total,
          booking: '',
        }

        this.cart.push(giftCardData)
        await this.addToCart(3)
      } else {
        for(let n in this.addons){
          if(this.addons[n].quantity > 0){
            // this.addToCart(3, this.addons[n])
            this.cart.push({
              game: this.selectedGame,
              booking: this.selectedBooking,
              item: this.addons[n],
              quantity: this.addons[n].quantity,
              subtotal: this.addons[n].subtotal
            })
          }
        }
      }

      await this.recalculatePromos()
      const addedValue = this.addedToCartValue(step, this.gift_card.total)
      // An add-on substep with nothing chosen adds nothing to the cart.
      // Free add-ons still count, so test quantity, not value.
      if (step !== 'addon' || this.addons.some(a => a.quantity > 0)) {
        this.trackPixelEvent('AddToCart', addedValue)
        if(window.dataLayer) {
          window.dataLayer.push({
            event: 'add_to_cart',
            currency: this.locale.currency,
            value: addedValue
          });
        }
        if(window.gtag) {
          if (window !== window.top) {
            let eventData = {
              eventType: 'add_to_cart',
              eventValue: addedValue,
              currency: this.locale.currency
            }
            this.$nextTick(() => {
              this.postMessageTrackingEvent(eventData)
            });
          } else {
            gtag("event", "add_to_cart", {
              currency: this.locale.currency,
              value: addedValue
            })
          }
        }
      }

      if((!step && !this.has_addons) || step === 'addon'){
        this.$refs['wiz'].tabIndex(2)
      }

      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
    },
    returnFromPaymentStep(){
      this.$refs['wiz'].tabIndex(2)
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
    },
    async tabTwo(index, step){
      if(!this.show_addons && !this.validQuantity()){
        return
      }

      // Requests carry no add-ons (server rejects items on request checkouts),
      // so the add-on step is skipped entirely for a request flow.
      if(index === 2 && !step && this.has_addons && !this.show_addons
        && !(this.selectedBooking && this.selectedBooking.is_request_booking)){
        await this.getAddons(this.selectedGame.game_id)
        this.show_addons = true
      }
      this.prevent_submit = false
      this.scrollToTop()
      if(!step){
        let found = 0
        for(let n in this.cart){
          if(this.cart[n].hasOwnProperty('item') || this.cart[n].hasOwnProperty('gift_card')){
            continue
          }
          if(this.selectedBooking.id == this.cart[n].booking.id){
            this.cart[n].quantity = this.number_of_players
            this.cart[n].subtotal = this.subtotal
            this.cart[n].book_entire_slot = this.book_entire_slot,
            this.cart[n].tickets = this.pricing_categories
            this.cart[n].price_settings = this.price_settings
            this.cart[n].selected_duration_id = this.selected_duration && Number(this.selected_duration.is_default) !== 1 ? this.selected_duration.id : null
            this.cart[n].selected_duration = this.selected_duration
            const upsertWindow = this.durationWindowFor(this.selectedBooking, this.selected_duration)
            this.cart[n].end_time = upsertWindow ? upsertWindow.end_time : this.selectedBooking.end_time
            this.cart[n].end_date = upsertWindow ? upsertWindow.end_date : this.selectedBooking.end_date
            found++
          }
        }
        if(found <= 0){
          const pushWindow = this.durationWindowFor(this.selectedBooking, this.selected_duration)
          this.cart.push({
            game: this.selectedGame,
            price_settings: this.price_settings,
            booking: this.selectedBooking,
            quantity: this.number_of_players,
            book_entire_slot: this.book_entire_slot,
            subtotal: this.subtotal,
            tickets: this.pricing_categories,
            // Multiple durations: the chosen duration travels with the line; the slot object stays untouched
            selected_duration_id: this.selected_duration && Number(this.selected_duration.is_default) !== 1 ? this.selected_duration.id : null,
            selected_duration: this.selected_duration,
            end_time: pushWindow ? pushWindow.end_time : this.selectedBooking.end_time,
            end_date: pushWindow ? pushWindow.end_date : this.selectedBooking.end_date
          })
        }
      } else {
        for(let n in this.addons){
          if(this.addons[n].quantity > 0){
            // this.addToCart(3, this.addons[n])
            this.cart.push({
              game: this.selectedGame,
              booking: this.selectedBooking,
              item: this.addons[n],
              quantity: this.addons[n].quantity,
              subtotal: this.addons[n].subtotal
            })
          }
        }
      }

      await this.addToCart(3)
      await this.recalculatePromos()
      // Upsell: apply the template's linked promo code once the suggested booking is in the cart
      if(!step && this.upsell_promo_pending){
        const pending = this.upsell_promo_pending
        this.upsell_promo_pending = null
        const alreadyApplied = this.promo_codes.some(p => p.name === pending)
        if(!alreadyApplied){
          const typed = this.promo_code
          // recalculatePromos fires addToCart(5) without awaiting it; the validator caps a new
          // code against the server cart's promo links, so the server list must match first
          await this.addToCart(5)
          this.promo_code = pending
          await this.applyPromo(true)
          this.promo_code = typed
        }
      }
      const addedValue = this.addedToCartValue(step, this.subtotal)
      // An add-on substep with nothing chosen adds nothing to the cart.
      // Free add-ons still count, so test quantity, not value.
      if (step !== 'addon' || this.addons.some(a => a.quantity > 0)) {
        this.trackPixelEvent('AddToCart', addedValue)
        if(window.dataLayer) {
          window.dataLayer.push({
            event: 'add_to_cart',
            currency: this.locale.currency,
            value: addedValue
          });
        }
        if(window.gtag) {
          if (window !== window.top) {
            let eventData = {
              eventType: 'add_to_cart',
              eventValue: addedValue,
              currency: this.locale.currency
            }
            this.$nextTick(() => {
              this.postMessageTrackingEvent(eventData)
            });
          } else {
            gtag("event", "add_to_cart", {
              currency: this.locale.currency,
              value: addedValue
            })
          }
        }
      }

      // Request flows skip the add-on substep entirely (see the guard above),
      // so they advance as if the game had no add-ons.
      const requestFlowSkipsAddons = this.selectedBooking && this.selectedBooking.is_request_booking
      if((index === 2 && !step && (!this.has_addons || requestFlowSkipsAddons)) || step === 'addon'){
        this.$refs['wiz'].tabIndex(index)
        if(step === 'addon'){
          this.show_addons = false
        }
      }

      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
    },
    createCart(referer){
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/cart?r=' + encodeURIComponent(referer || '')

      // Check for UTM parameters in URL (current visit)
      const urlUtmSource = this.$route.query.utm_source
      const urlUtmMedium = this.$route.query.utm_medium
      const urlUtmCampaign = this.$route.query.utm_campaign

      // Get stored UTM data (from previous visits)
      const storedUTM = this.getUTMFromStorage()

      // Use URL parameters if present, otherwise fall back to stored data
      this.utm_source = urlUtmSource || (storedUTM && storedUTM.utm_source) || null
      this.utm_medium = urlUtmMedium || (storedUTM && storedUTM.utm_medium) || null
      this.utm_campaign = urlUtmCampaign || (storedUTM && storedUTM.utm_campaign) || null
      this.referer = referer || (storedUTM && storedUTM.referer) || null

      // If we have new UTM parameters in URL, save them to storage
      if(urlUtmSource || urlUtmMedium || urlUtmCampaign){
        this.saveUTMToStorage({
          utm_source: this.utm_source,
          utm_medium: this.utm_medium,
          utm_campaign: this.utm_campaign,
          referer: this.referer
        })
      }

      // Clean URL parameters from browser history
      const query = { ...this.$route.query };
      delete query.utm_source;
      delete query.utm_medium;
      delete query.utm_campaign;
      this.$router.replace({ query }).catch(() => {});

      if(this.utm_source){
        url += '&utm_source=' + encodeURIComponent(this.utm_source)
      }
      if(this.utm_medium){
        url += '&utm_medium=' + encodeURIComponent(this.utm_medium)
      }
      if(this.utm_campaign){
        url +=  '&utm_campaign=' + encodeURIComponent(this.utm_campaign)
      }
      if(this.bss && this.bss.id){
        url += '&bss_id=' + this.bss.id
      }

      axios.get(url)
        .then(response => {
          this.cart_id = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    addToCart(step, removed, telemetry){
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/cart'
      let cart = []

      for(let n in this.cart){
        if(this.cart[n].hasOwnProperty('item')){
          cart.push({type: 'item', value: this.cart[n].subtotal, quantity: this.cart[n].quantity, item_id: this.cart[n].item.id})
        } else if(this.cart[n].hasOwnProperty('gift_card')){
          cart.push({type: 'gift_card', value: this.cart[n].subtotal, quantity: this.cart[n].gift_card.quantity, gift_card_type_id: this.cart[n].gift_card.gift_card_type_id})
        } else {
          let quantity = 0
          for(let m in this.cart[n].tickets){
            quantity += this.cart[n].tickets[m].number_of_players
          }
          cart.push({type: 'booking', value: this.cart[n].subtotal, quantity: quantity, booking_slot_id: this.cart[n].booking.id, selected_duration_id: this.cart[n].selected_duration_id || null})
        }
      }
      let data = {
        cart: cart,
        promo_codes: this.promo_codes,
        cart_id: this.cart_id,
        cart_value: this.getCartSubtotal(),
        current_step: step,
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        // Diagnostic only. Passed through for server-side logging (the cart lambda logs the
        // request); it is never read or stored. Used to capture the Stripe confirm outcome.
        payment_telemetry: telemetry || null,
      }
      this.cart_sync_pending++
      return axios.post(url, data)
        .then(async response => {
          this.cart_sync_pending--
          if(removed){
            await this.recalculatePromos()
          }

          this.loading = false

        })
        .catch(err => {
          this.cart_sync_pending--
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    isEmptyCart(){
      if(this.cart.length <= 0){
        return true
      }
      return false
    },
    computeDeposit(){
      this.recalculateTaxesAndFees()
      //check if deposit is required
      this.allow_deposit = false
      this.deposit = 0
      this.require_deposit = false
      for(let n in this.cart){
        if(!this.cart[n].hasOwnProperty('gift_card')
          && !this.cart[n].hasOwnProperty('item') &&
          this.cart[n].price_settings.allow_deposit && this.cart[n].price_settings.require_deposit){
          this.require_deposit = true
          this.allow_deposit = true
          this.pay_deposit = true
        }
      }
      for(let n in this.cart) {
        if (this.cart[n].hasOwnProperty('gift_card')) {
          this.allow_pay_on_arrival = false
        } else if(!this.cart[n].hasOwnProperty('item')) {
          if(this.cart[n].price_settings.allow_deposit === 1){
            this.allow_deposit = true
            if(this.cart[n].price_settings.deposit_type === 0){
              this.deposit += parseFloat(this.cart[n].price_settings.deposit_amount)
            } else {
              this.deposit += parseFloat(this.cart[n].price_settings.deposit_amount) * this.cart[n].quantity
            }
          }
        }
        if(this.deposit > this.getTotalAmount()){
          this.deposit = this.getTotalAmount()
        }
      }
      for(let n in this.cart) {
        if(!this.cart[n].hasOwnProperty('gift_card') && !this.cart[n].hasOwnProperty('item') &&
          this.cart[n].price_settings.allow_deposit === 0 && this.allow_deposit){
          this.deposit += parseFloat(this.cart[n].subtotal)
        }
      }

      const currentTotal = this.getTotalAmount()
      if(this.deposit > currentTotal){
        this.deposit = currentTotal
      }

      if(!this.allow_deposit){
        this.pay_deposit = false
      }

      // If card storage is required for whichever payment branch the customer is
      // landing in, pre-check save_card_for_future.
      const needsCardSave = (this.allow_deposit && this.payment_settings.require_card_for_deposit)
        || this.payment_settings.require_card_for_full_payment
      if(needsCardSave
        && this.payment_settings.store_credit_card
        && (this.payment_settings.payment_gateway_id === 2 || this.payment_settings.payment_gateway_id === 3)){
        this.$nextTick(() => { this.save_card_for_future = true })
      }

      //set deposit rows if deposit has already been selected
      this.selectPayDeposit()
    },
    tabThree(index, source){
      this.disable_submit = true

      if(this.selectedPaymentOption.name === 'Card' &&
        (this.payment_settings.payment_gateway_id === 2 || this.payment_settings.payment_gateway_id === 1
          || this.payment_settings.payment_gateway_id === 4)){
        this.disable_submit = false
      }
      if(this.selectedPaymentOption.name !== 'Card'
        && this.selectedPaymentOption.name !== 'Gift card'){
        this.disable_submit = false
      }
      if(this.due_now <= 0){
        this.disable_submit = false
      }
      // on_approval requests capture nothing: nothing to tokenize, submit is live.
      if(this.requestNoCapture){
        this.disable_submit = false
      }
      if(this.isEmptyCart()){
        swal({
          title: this.$t('book.swals.emptyCart'),
          text: this.$t('book.swals.addItemsToCart'),
          type: 'warning'
        })
        return
      }
      this.scrollToTop()

      let errors = 0
      if((this.user.first_name == '' || this.sanitizeNameInput(this.user.first_name) === '')){
        this.errors.first_name = this.$t('checkin.errors.firstName')
        errors++
      } else {
        this.errors.first_name = ''
      }
      if((this.user.last_name == '' || this.sanitizeNameInput(this.user.last_name) === '')){
        this.errors.last_name =  this.$t('checkin.errors.lastName')
        errors++
      } else {
        this.errors.last_name = ''
      }
      if(this.user.email == '' || !this.isValidEmail(this.user.email)){
        this.errors.email = this.$t('book.errors.email')
        errors++
      } else {
        this.errors.email = ''
      }
      if(this.phoneFieldMode === 'required' && this.user.phone == ''){
        this.errors.phone = this.$t('book.errors.phone')
        errors++
      } else if(this.user.phone != '' && this.user.phoneValidationStatus === 'invalid') {
        this.errors.phone = this.$t('book.errors.phoneInvalid')
        errors++
      } else {
        this.errors.phone = ''
      }

      // Built-in address fields (per template config, OTC-2035)
      this.errors.address_line_1 = ''
      this.errors.city = ''
      this.errors.state = ''
      this.errors.customer_zip = ''
      if(this.addressFieldMode === 'required'){
        if((this.user.address_line_1 || '').trim() === ''){
          this.errors.address_line_1 = this.$t('book.errors.requiredField')
          errors++
        }
        if((this.user.city || '').trim() === ''){
          this.errors.city = this.$t('book.errors.requiredField')
          errors++
        }
        if((this.user.state || '').trim() === ''){
          this.errors.state = this.$t('book.errors.requiredField')
          errors++
        }
        if((this.user.zip || '').trim() === ''){
          this.errors.customer_zip = this.$t('book.errors.requiredField')
          errors++
        }
      }
      if(this.zipFieldMode === 'required' && (this.user.zip || '').trim() === ''){
        this.errors.customer_zip = this.$t('book.errors.requiredField')
        errors++
      }

      for(let n in this.custom_fields){
        const cf = this.custom_fields[n]
        const isRequired = cf.required || (cf.type === 1 && cf.interaction_required)
        if(isRequired && this.isFieldVisibile(cf) && !cf.customer_response){
          cf.error = this.$t('book.errors.requiredField')
          errors++
        } else {
          cf.error = ''
        }
      }

      if(errors > 0){
        return
      }

      if(source === 1){
        this.completeBooking()
      } else {
        //Payment gateway
        if(this.payment_settings.payment_gateway_id === 3){
          this.initializeStripe()
        }
        if(this.payment_settings.payment_gateway_id === 2){
          this.initializeSquare()
        }
        this.computeDeposit()
      }

      this.addToCart(6)
      const checkoutValue = this.getTotalAmount()
      this.trackPixelEvent('InitiateCheckout', checkoutValue)
      if(window.dataLayer) {
        window.dataLayer.push({
          event: 'begin_checkout',
          currency: this.locale.currency,
          value: checkoutValue
        });
      }
      if(window.gtag) {
        if (window !== window.top) {
          let eventData = {
            eventType: 'begin_checkout',
            eventValue: checkoutValue,
            currency: this.locale.currency
          }
          this.$nextTick(() => {
            this.postMessageTrackingEvent(eventData)
          });
        } else {
          gtag("event", "begin_checkout", {
            currency: this.locale.currency,
            value: checkoutValue
          })
        }
      }
      this.$refs['wiz'].tabIndex(index)
      if (window !== window.top) {
        this.$nextTick(() => {
          this.updateParentAboutPageChange()
        });
      }
    },
    async tabFive() {
      if (this.isEmptyCart()) {
        swal({
          title: this.$t('book.swals.emptyCart'),
          text: this.$t('book.swals.addItemsToCart'),
          type: 'warning'
        })
        return
      }
      // Last line of defence for the Pay button gate: a balance left after a
      // gift card must be paid under the Card option, the only path that runs
      // the card charge after the booking is created. Runs before the scroll
      // so the customer stays where they tapped when the dialog closes.
      if (giftCardBalanceBlocksSubmit({
        selectedOptionName: this.selectedPaymentOption.name,
        dueNow: this.due_now,
        noCaptureCheckout: this.noCaptureCheckout
      })) {
        this.disable_submit = true
        swal({
          title: this.$t('book.swals.giftCardBalanceDueTitle'),
          text: this.$t('book.swals.giftCardBalanceDue'),
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd5d93',
          confirmButtonText: 'OK'
        })
        return
      }
      // Wallet taps defer to a second confirm tap; keep the viewport where the
      // customer tapped so the relabeled button stays under their thumb.
      const willDeferWalletConfirm = this.payment_settings.payment_gateway_id === 3 &&
        this.selectedPaymentOption.name === 'Card' && !this.noCaptureCheckout && this.due_now > 0 &&
        (this.stripe_payment_method === 'apple_pay' || this.stripe_payment_method === 'google_pay')
      if (!willDeferWalletConfirm) {
        this.scrollToTop()
      }

      if ((this.getTotalAmount() > 0 && this.due_now > 0) || this.applied_gift_cards.length > 0) {
        let errors = 0

        if(!this.isCardHolderValid()){
          errors++
        }

        if (errors > 0) {
          return
        }
      }

      if (this.selectedPaymentOption.name === 'Yappy' && this.payment_settings.payment_gateway_id === 5
        && !this.noCaptureCheckout){
        this.payWithYappy()
        return
      }

      if (this.payment_settings.payment_gateway_id === 1 && this.selectedPaymentOption.name === 'Card'
        && !this.noCaptureCheckout && this.due_now > 0) {
        this.disable_submit = true
        this.tokenizing = true
        try {
          this.authorize_opaque_data = await this.$refs.authorizePaymentForm.tokenize()
          this.authorize_zip = this.$refs.authorizePaymentForm.zip
        } catch (err) {
          this.disable_submit = false
          this.tokenizing = false
          let msg = this.$t('book.swals.transactionFailed') || 'Transaction failed, please verify your payment information.'
          if (err.message === 'ACCEPT_JS_NOT_LOADED') {
            msg = this.$t('book.swals.paymentNotReady') || 'Payment is loading, please try again.'
          } else if (err.message === 'VALIDATION_FAILED') {
            msg = this.$t('book.swals.checkFields') || 'Please check your card details and try again.'
          }
          swal(this.$t('book.swals.error') || 'Error', msg, 'error')
          return
        }
      }
      this.completeBooking()
    },
    disableTabsTest(){
      this.$refs['wiz'].disableTabs();
    },
    async tokenize(paymentMethod) {
      const tokenResult = await paymentMethod.tokenize();
      if (tokenResult.status === 'OK') {
        const zip = tokenResult.details.billing.postalCode ? tokenResult.details.billing.postalCode : ''
        return {token: tokenResult.token, zip}
      } else {
        let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
        if (tokenResult.errors) {
          errorMessage += ` and errors: ${JSON.stringify(
            tokenResult.errors
          )}`;
        }
        this.disable_submit = false
        throw new Error(errorMessage);
      }
    },
    // Square tokenize / verifyBuyer failed at submit. Reset the submit state,
    // tell the customer, and leave a telemetry marker in the cart log; a bare
    // return here used to show nothing but a spinner blink.
    squareSubmitFailed(stage, error) {
      this.loading = false
      this.bookingSubmitted = false
      this.disable_submit = false
      this.tokenizing = false
      const message = String((error && error.message) || error)
      this.addToCart(6, false, { event: 'square_' + stage + '_failed', error: message })
      swal(this.$t('book.swals.transactionFailed'), this.$t('book.swals.checkFields'), 'error')
    },
    async initializeCard(payments) {
      const { card: cardColor, text: textColor, accent: accentColor } = this.sdkPalette()
      const customStyle = {
        '.input-container.is-focus': {
          borderColor: accentColor,
        },
        '.input-container.is-error': {
          borderColor: '#ff1600',
        },
        '.message-icon': {
          color: textColor,
        },
        '.message-text.is-error': {
          color: '#ff1600',
        },
        '.message-icon.is-error': {
          color: '#ff1600',
        },
        'input.is-error': {
          color: '#ff1600',
        },
        '@media screen and (max-width: 600px)': {
          'input': {
            'fontSize': '12px',
          }
        },
        '.input-container': {
          borderColor: this.inputBorderSolid,
          borderRadius: '6px',
        },
        '.message-text': {
          color: textColor,
        },
        input: {
          backgroundColor: cardColor,
          color: textColor,
          fontFamily: 'helvetica neue, sans-serif',
        },
        'input::placeholder': {
          color: textColor,
        },
      }
      const card = await payments.card({
        style: customStyle
      });
      await card.attach('#card-container');
      return card;
    },
    async verifyBuyer(payments, token, zip) {
      const total = this.getTotalAmount()
      let amount = this.pay_deposit ? this.due_now : total
      if(this.applied_gift_cards.length > 0){
        amount = this.due_now
      }
      const verificationDetails = {
        amount: (Math.round((amount + Number.EPSILON) * 100) / 100).toString(),
        /* collected from the buyer */
        billingContact: {
          familyName: this.payment.cardholder_last_name,
          givenName: this.payment.cardholder_first_name,
          postalCode: zip
        },
        currencyCode: this.locale.currency,
        intent: 'CHARGE',
      };

      const verificationResults = await payments.verifyBuyer(
        token,
        verificationDetails
      );
      return verificationResults.token;
    },
    async initializeSquare() {
      if (!window.Square) {
        // Diagnostic marker, logged by the cart lambda: the Square SDK script
        // never loaded, so the card form cannot mount and the customer sees a
        // blank payment section with no error.
        this.addToCart(6, false, { event: 'square_sdk_missing' })
        throw new Error('Square.js failed to load properly');
      }

      // Only initialize once, then reuse
      if (!this.card) {
        this.square = window.Square.payments(this.squareAppId, this.squareLocationId);
        this.square.setLocale(this.$i18n.locale);
        this.loading = true;

        try {
          this.card = await this.initializeCard(this.square);
          this.loading = false;
          this.addToCart(6, false, { event: 'square_card_ready' })
        } catch (e) {
          console.error('Initializing Card failed', e);
          this.loading = false;
          // Card form failed to attach — customer is left on the payment step
          // with no form and no visible error. A square_card_ready never
          // following this marker for the same cart means a dead payment step.
          this.addToCart(6, false, { event: 'square_init_failed', error: String((e && e.message) || e) })
          return;
        }
      }
    },
    // Opaque colors for payment SDKs (Stripe appearance, Square card style),
    // which reject alpha. Each template color is flattened over the surface it
    // sits on: page over the dark body, card over the page, text and accent
    // over the card. A color the parser cannot read falls back to the theme
    // default so the card form still mounts.
    sdkPalette() {
      return sdkPalette(this.bss)
    },
    async reInitializeStripe(clientSecret){
      this.stripeElementReady = false
      if (this.paymentElement) {
        this.paymentElement.unmount();
      }
      // Same stale-button guard as initializeStripe: no tappable express
      // checkout button while the elements group is being replaced.
      if (this.expressCheckoutElement) {
        this.expressCheckoutElement.unmount()
        this.expressCheckoutElement = null
      }
      this.expressCheckoutAvailable = false
      const appearance = {
        theme: 'stripe',
        variables: {
          colorPrimary: this.sdkPalette().accent,
          colorBackground: this.sdkPalette().card,
          colorText: this.sdkPalette().text,
        },
        rules: {
          '.Input': { borderColor: this.inputBorderSolid },
          '.Input:focus': { borderColor: this.inputBorderSolid },
        },
      };
      this.elements = this.stripe.elements({ appearance, clientSecret });
      const paymentElementOptions = {
        layout: "tabs",
      };
      if (this.expressCheckoutEnabled) {
        // Wallets render as native Express Checkout buttons above the form
        // instead of tabs, so the sheet opens on the wallet button's own tap.
        paymentElementOptions.wallets = { applePay: 'never', googlePay: 'never' }
      }

      this.paymentElement = this.elements.create("payment", paymentElementOptions);
      this.paymentElement.mount("#payment-element");
      this.mountExpressCheckout()

      this.paymentElement.on('ready', () => {
        this.stripeElementReady = true;
        this.addToCart(6, false, { event: 'stripe_element_ready' })
      });

      this.paymentElement.on('change', (event) => {
        if (this.wallet_pending_response && event.value && event.value.type !== this.wallet_pending_method) {
          this.invalidateWalletPending()
          return
        }
        if (this.noCaptureCheckout) {
          return;
        }
        if (event.complete) {
          // Enable the payment button, but only under the Card option: the
          // form is hidden under every other option and can complete on its
          // own, which must not undo the Gift card balance gate.
          if (cardFormCompleteEnablesSubmit(this.selectedPaymentOption && this.selectedPaymentOption.name)) {
            this.disable_submit = false;
          }
        } else {
          // Disable the payment button only after element is ready
          if(this.selectedPaymentOption.name === 'Card' && this.stripeElementReady){
            this.disable_submit = true;
          }
        }

        if (event.value) {
          this.stripe_payment_method = event.value.type
        }
      });
    },
    async initializeStripe(){
      this.stripeElementReady = false
      if (this.paymentElement) {
        this.paymentElement.unmount()
      }
      // Unmount the express checkout button synchronously too: a stale wallet
      // button left tappable during the PI round-trip would open the sheet
      // against the previous elements group and amount.
      if (this.expressCheckoutElement) {
        this.expressCheckoutElement.unmount()
        this.expressCheckoutElement = null
      }
      this.expressCheckoutAvailable = false
      // A Stripe Connect venue tokenizes inside its connected account (platform key + account).
      this.stripe = window.Stripe(this.payment_settings.api_name, {
        currency: this.locale.currency.toLowerCase(),
        locale: this.$i18n.locale,
        ...(this.payment_settings.stripe_account_id ? { stripeAccount: this.payment_settings.stripe_account_id } : {})
      });
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/payment/stripe-payment-intent'

      const bookingSlotIds = this.cart
        .filter(c => c.booking && c.booking.id)
        .map(c => c.booking.id)

      let data = {
        currency: this.locale.currency,
        total: this.getTotalAmount(),
        cart_id: this.cart_id,
        email: this.user.email,
        booking_slot_ids: bookingSlotIds
      }

      // If we already have a payment intent, update it instead of creating new one
      if (this.payment_intent_id) {
        data.paymentIntent = this.payment_intent_id
      }

      this.loading = true
      axios.post(url, data)
        .then(response => {
          this.loading = false
          let clientSecret = response.data.clientSecret
          this.payment_intent_id = response.data.clientSecret.split('_')[0] + '_' + response.data.clientSecret.split('_')[1]
          const appearance = {
            theme: 'stripe',
            variables: {
              colorPrimary: this.sdkPalette().accent,
              colorBackground: this.sdkPalette().card,
              colorText: this.sdkPalette().text,
            },
            rules: {
              '.Input': { borderColor: this.inputBorderSolid },
              '.Input:focus': { borderColor: this.inputBorderSolid },
            },
          };
          this.elements = this.stripe.elements({ appearance, clientSecret });
          const paymentElementOptions = {
            layout: "tabs",
          };
          if (this.expressCheckoutEnabled) {
            // Wallets render as native Express Checkout buttons above the form
            // instead of tabs, so the sheet opens on the wallet button's own tap.
            paymentElementOptions.wallets = { applePay: 'never', googlePay: 'never' }
          }

          this.paymentElement = this.elements.create("payment", paymentElementOptions);
          this.paymentElement.mount("#payment-element");
          this.mountExpressCheckout()

          this.paymentElement.on('ready', () => {
            this.stripeElementReady = true;
            this.addToCart(6, false, { event: 'stripe_element_ready' })
          });

          this.paymentElement.on('change', (event) => {
            if (this.wallet_pending_response && event.value && event.value.type !== this.wallet_pending_method) {
              this.invalidateWalletPending()
              return
            }
            if (this.noCaptureCheckout) {
              return;
            }
            if (event.complete) {
              // Enable the payment button, but only under the Card option: the
              // form is hidden under every other option and can complete on its
              // own, which must not undo the Gift card balance gate.
              if (cardFormCompleteEnablesSubmit(this.selectedPaymentOption && this.selectedPaymentOption.name)) {
                this.disable_submit = false;
              }
            } else {
              // Disable the payment button only after element is ready
              if(this.selectedPaymentOption.name === 'Card' && this.stripeElementReady){
                this.disable_submit = true;
              }
            }

            if (event.value) {
              this.stripe_payment_method = event.value.type
            }
          });
        })
        .catch(err => {
          this.loading = false
          this.stripeElementReady = true
          // Diagnostic marker: intent creation or element setup failed, so the
          // payment form never mounts and the customer sees a dead payment
          // step. Status pins whether the backend rejected the intent or the
          // request never completed.
          this.addToCart(6, false, {
            event: 'stripe_init_failed',
            status: err.response ? err.response.status : null,
            error: String((err && err.message) || err)
          })
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    getDiscounts(){
      let total_discount = 0
      for(let n in this.promo_codes){
        total_discount = parseFloat(total_discount) + parseFloat(this.promo_codes[n].value_amount)
      }
      return total_discount
    },
    getShelfPriceDiscounts(){
      // Shelf-price discount on TAXABLE items only. Gift cards are excluded so
      // their discount portion isn't counted as inclusive_tax_savings — that
      // portion is handled separately via getNonTaxableDiscount().
      let total = 0
      for(let n in this.promo_codes){
        const items = this.promo_codes[n].discounted_items || []
        const isFlat = this.promo_codes[n].redemption_type === 1
        if(isFlat){
          // For flat promos, items[i].discount IS shelf-price (= the flat amount).
          // Sum only non-gift-card entries; fall back to value_amount when no items.
          if(items.length > 0){
            for(let i in items){
              if(items[i].type !== 'gift_cards'){
                total += parseFloat(items[i].discount) || 0
              }
            }
          } else {
            total += parseFloat(this.promo_codes[n].value_amount)
          }
        } else if(this.promo_codes[n].raw_value_amount != null){
          // Percentage: backend's discounted_items names the cart lines this promo
          // actually applies to (per linked_games / linked_items). Apply the
          // percentage to each line's SHELF subtotal individually and round per
          // line before summing, matching update-transaction-values:590,610.
          // Aggregating subtotals before a single round drifts up to N cents vs
          // the backend, surfacing as a bogus inclusive_tax_savings delta in
          // getTotalAmount that the backend rejects as a total mismatch.
          let scopedShelfDiscount = 0
          const rawPct = this.promo_codes[n].raw_value_amount
          if(items.length > 0){
            for(const discountedItem of items){
              if(discountedItem.type === 'gift_cards') continue
              if(discountedItem.is_rule){
                // Rule-origin entries (buy x get y) are not slices of the
                // percentage. The backend books rule dollars with shelf equal
                // to ex-tax (zero inclusive-tax savings), so use the entry's
                // own discount. Re-deriving subtotal times percentage here
                // injects a spurious savings term and desyncs the total from
                // the backend recompute.
                scopedShelfDiscount += parseFloat(discountedItem.discount) || 0
                continue
              }
              for(let c in this.cart){
                let matches = false
                if(discountedItem.type === 'items' && this.cart[c].hasOwnProperty('item')){
                  matches = this.cart[c].item.id === discountedItem.id
                } else if(discountedItem.type === 'games' && this.cart[c].hasOwnProperty('game')){
                  if(discountedItem.booking_slot_id && this.cart[c].booking){
                    matches = this.cart[c].booking.id === discountedItem.booking_slot_id
                  } else {
                    matches = this.cart[c].game.game_id === discountedItem.id
                  }
                }
                if(matches){
                  scopedShelfDiscount += Number(Math.round(parseFloat(this.cart[c].subtotal) * rawPct) + 'e-2')
                  break
                }
              }
            }
          } else {
            // No discounted_items present (legacy/edge): fall back to the full
            // taxable subtotal so promos without scope info still produce a discount.
            for(let c in this.cart){
              if(!this.cart[c].hasOwnProperty('gift_card')){
                scopedShelfDiscount += Number(Math.round(parseFloat(this.cart[c].subtotal) * rawPct) + 'e-2')
              }
            }
          }
          total += scopedShelfDiscount
        } else {
          total += parseFloat(this.promo_codes[n].value_amount)
        }
      }
      let cartSubtotal = 0
      for(let n in this.cart){
        cartSubtotal += parseFloat(this.cart[n].subtotal)
      }
      if(total > cartSubtotal) total = cartSubtotal
      return total
    },
    // Combined inclusive rate for one cart line (value_type 2 always, value_type 4 when it
    // applies to the line) or, with no line, for the whole transaction (value_type 2 plus
    // value_type 4 on all items). A shelf price includes every inclusive tax at once, so
    // each tax extracts its base with this rate and takes its own share. Mirrors
    // update-transaction-values buildInclusiveRateLookup. getInclusiveTaxRate below is
    // the discount-side rate and stays gated on apply_after_discount.
    getInclusiveRateFor(line = null){
      let rate = 0
      for(let t in this.taxes){
        const tax = this.taxes[t]
        if(tax.pricing_type !== 1) continue
        if(tax.value_type !== 2 && tax.value_type !== 4) continue
        if(tax.value_type === 4 && !tax.apply_to_all_items){
          if(!line) continue
          let found = null
          if(line.hasOwnProperty('item')){
            const linked_items = tax.linked_items ? JSON.parse(tax.linked_items) : []
            found = _.find(linked_items, {id: line.item.id})
          } else if(line.game){
            const linked_games = tax.linked_games ? JSON.parse(tax.linked_games) : []
            found = _.find(linked_games, {id: line.game.game_id})
          }
          if(!found) continue
        }
        rate += Number(tax.amount) || 0
      }
      return rate
    },
    getInclusiveTaxRate(){
      let combinedRate = 0
      for(let t in this.taxes){
        if(this.taxes[t].pricing_type !== 1) continue
        if(this.taxes[t].value_type !== 2 && this.taxes[t].value_type !== 4) continue
        if(!this.taxes[t].apply_after_discount) continue
        combinedRate += this.taxes[t].amount
      }
      return combinedRate
    },
    getTaxableDiscount(){
      let taxable = 0
      for(let n in this.promo_codes){
        const items = this.promo_codes[n].discounted_items || []
        const isFlat = this.promo_codes[n].redemption_type === 1
        if(items.length > 0){
          for(let i in items){
            if(items[i].type !== 'gift_cards'){
              let amount = parseFloat(items[i].discount) || 0
              // Flat promo discounted_items contain shelf-price values -- convert to ex-tax.
              // Rule-origin entries (is_rule) are already ex-tax, so extracting
              // again would double-strip the tax base and desync the total.
              if(isFlat && !items[i].is_rule){
                amount = this.getBasePriceForDiscount(amount)
              }
              taxable += amount
            }
          }
        } else {
          let amount = parseFloat(this.promo_codes[n].value_amount)
          // For flat promos, convert shelf-price to ex-tax for inclusive tax base calculation
          if(isFlat){
            amount = this.getBasePriceForDiscount(amount)
          }
          taxable += amount
        }
      }
      // Cap at cart subtotal: mirrors the cap already present in getShelfPriceDiscounts
      // at line 6144. Needed because booking-site-validate-promo-code stamps full
      // value_amount onto each matching booking's discounted_items entry (flat promos
      // applied to multi-booking carts), and also stamps raw_value_amount above the
      // capped value_amount for inclusive-tax cases. Without this cap, the summed
      // per-item discounts can exceed the cart subtotal, producing a negative
      // getTotalAmount that the backend rejects as "Invalid payment amount".
      let cartSubtotal = 0
      for(let n in this.cart){
        cartSubtotal += parseFloat(this.cart[n].subtotal)
      }
      if(taxable > cartSubtotal) taxable = cartSubtotal
      return taxable
    },
    getNonTaxableDiscount(){
      // Gift cards are excluded from getTaxableDiscount because their discount
      // doesn't reduce a taxable base. But it DOES reduce what the customer pays,
      // so we need to subtract it from the total separately.
      let total = 0
      for(let n in this.promo_codes){
        const items = this.promo_codes[n].discounted_items || []
        if(items.length === 0) continue
        for(let i in items){
          if(items[i].type === 'gift_cards'){
            total += parseFloat(items[i].discount) || 0
          }
        }
      }
      return total
    },
    getBasePriceForDiscount(price){
      let combinedRate = this.getInclusiveTaxRate()
      if(combinedRate === 0) return price
      return Number(Math.round(Number((price / (1 + (combinedRate * 0.01))) + 'e2')) + 'e-2')
    },
    failEcePaymentIfPending(){
      // Release the wallet sheet when a flow that started from the Express
      // Checkout confirm event ends without reaching confirmPayment. No-op
      // when no ECE confirm is pending (card flow, non-pilot sites).
      const event = this.eceConfirmEvent
      this.eceConfirmEvent = null
      if (event && typeof event.paymentFailed === 'function') {
        try {
          event.paymentFailed({ reason: 'fail' })
        } catch (signalErr) {
          console.log('ECE paymentFailed signal failed:', signalErr)
        }
      }
    },
    mountExpressCheckout(){
      if (!this.expressCheckoutEnabled) return
      if (this.expressCheckoutElement) {
        this.expressCheckoutElement.unmount()
        this.expressCheckoutElement = null
      }
      this.expressCheckoutElement = this.elements.create('expressCheckout', {
        buttonType: { applePay: 'book', googlePay: 'book' },
        // Wallets only. Link/Klarna/Amazon Pay/PayPal already have their
        // places inside the payment form, and their redirect flows are not
        // wired through this element's confirm handler.
        paymentMethods: {
          link: 'never',
          klarna: 'never',
          amazonPay: 'never',
          paypal: 'never'
        }
      })
      this.expressCheckoutElement.mount('#express-checkout-element')
      this.expressCheckoutAvailable = false
      this.expressCheckoutElement.on('ready', (event) => {
        const avail = event.availablePaymentMethods
        this.expressCheckoutAvailable = !!(avail && (avail.applePay || avail.googlePay))
      })
      this.expressCheckoutElement.on('confirm', (event) => {
        // The wallet sheet has already been shown and authorized by Stripe at
        // this point, so the user-activation constraint no longer applies and
        // the async booking setup inside completeBooking is safe before the
        // confirmPayment call it leads to.
        if (this.loading || this.bookingSubmitted) {
          // Cannot proceed; release the sheet instead of leaving it processing.
          if (event && typeof event.paymentFailed === 'function') {
            event.paymentFailed({ reason: 'fail' })
          }
          return
        }
        this.eceConfirmEvent = event
        this.completeBooking()
      })
    },
    invalidateWalletPending(){
      if (!this.wallet_pending_response) return
      this.wallet_pending_response = null
      this.wallet_pending_method = null
      // Mirror the confirm-failure reset (release the held slot, re-prime a
      // fresh PaymentIntent) so the customer can change anything and resubmit.
      // No 409 handling here on purpose: this only ever runs while
      // wallet-pending, i.e. before the confirm tap, so the PaymentIntent
      // cannot have succeeded and /payment/clear cannot return 409. Do not
      // copy the confirm block's 409 "actually paid" branch into this path.
      if (this.payment_intent_id) {
        let code = this.$route.params.company
        let url = API_LOCATION + 'bookings/company-groups/' + code + '/payment/clear'
        axios.post(url, { payment_id: this.payment_intent_id })
          .catch(function(clearErr){ console.log('payment/clear failed:', clearErr) })
      }
      this.bookingSubmitted = false
      this.loading = false
      this.prevent_submit = false
      this.disable_submit = false
      this.stripeElementReady = false
      this.payment_intent_id = null
      this.stripe_payment_method = 'card'
      this.initializeStripe()
    },
    onWizardTabChange(){
      // Wallet-pending state can only exist while the customer is ON the
      // payment step (success navigation clears it first), so any tab change
      // while it is set means they navigated away between the two taps.
      this.invalidateWalletPending()
    },
    confirmWalletPayment(){
      if (!this.wallet_pending_response) return
      const response = this.wallet_pending_response
      this.wallet_pending_response = null
      this.wallet_pending_method = null
      this.loading = true
      this.disable_submit = true
      // No await may ever be added before runStripeConfirm here: the wallet
      // sheet must open inside this tap's user-activation window.
      this.runStripeConfirm(response)
    },
    payButtonClick(){
      if (this.walletAwaitingConfirm) {
        this.confirmWalletPayment()
      } else {
        this.tabFive(5)
      }
    },
    // Success-dialog config for every submit path. Requests must never claim the
    // booking is confirmed; the copy also states whether the customer was charged
    // (charge_now) or will only be charged on approval. isBookingRequest is the
    // server's classification; cartHasRequest covers paths whose endpoint does
    // not return the flag (Paystack).
    bookingSuccessSwal(){
      if(this.isBookingRequest || this.cartHasRequest){
        const onApproval = this.bss.request_to_book_payment_mode === 'on_approval'
        return {
          title: this.$t('book.swals.requestSubmittedTitle'),
          text: this.$t(onApproval ? 'book.swals.requestSubmittedOnApproval' : 'book.swals.requestSubmittedChargeNow'),
          type: 'success',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }
      }
      return {
        title: this.$t('book.swals.congratulations'),
        text: this.$t('book.swals.confirmedBooking'),
        type: 'success',
        showCancelButton: false,
        confirmButtonText: 'OK'
      }
    },
    runStripeConfirm(response){
      const code = this.$route.params.company
      //stripe confirm payment goes here
      let elements = this.elements
      let self = this
      // Diagnostic marker, logged by the cart lambda with the request's
      // user agent. A stripe_confirm_started with no later
      // stripe_confirm_result for the same intent means the customer left
      // while confirmPayment was still unresolved (e.g. a 3DS challenge
      // that died on screen). Fire-and-forget: must not delay confirmPayment.
      this.addToCart(7, false, {
        event: 'stripe_confirm_started',
        payment_intent_id: this.payment_intent_id || null,
        selected_method: this.stripe_payment_method || null
      })
      this.stripe.confirmPayment({
        elements,
        redirect: 'if_required',
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: "https://offthecouch.io/",
        },
      }).then(async function(result) {
        // Stripe's confirmPayment with redirect:'if_required' resolves (no result.error)
        // even when the payment did not actually complete. An abandoned wallet step (Link,
        // Cash App Pay) or a dismissed 3DS leaves the PaymentIntent at requires_payment_method
        // and resolves here with no error. Treat it as paid only when the PaymentIntent
        // actually succeeded (or is processing for async methods the webhook will finalize),
        // not merely when there is no error. Anything else takes the existing failure path.
        const pi = result.paymentIntent
        const paymentSucceeded = !result.error && pi &&
          (pi.status === 'succeeded' || pi.status === 'processing')
        if (!paymentSucceeded) {
          // Pass the confirm outcome through the cart request for server-side logging only
          // (not stored), so resolved-without-success cases are diagnosable.
          self.addToCart(7, false, {
            event: 'stripe_confirm_result',
            payment_intent_id: self.payment_intent_id || null,
            selected_method: self.stripe_payment_method || null,
            pi_status: pi && pi.status ? pi.status : null,
            has_error: !!result.error,
            error_code: result.error && result.error.code ? result.error.code : null,
            error_type: result.error && result.error.type ? result.error.type : null,
            error_decline_code: result.error && result.error.decline_code ? result.error.decline_code : null,
            error_message: result.error && result.error.message ? result.error.message : null
          })
          // The charge outcome is only uncertain when Stripe couldn't give us a
          // definitive result. A card decline or validation error means the charge was
          // attempted and explicitly failed; an abandoned wallet leaves the PI at
          // requires_payment_method (never charged) — both can fail fast. Only an
          // api_connection_error / unknown error might hide a charge that actually
          // succeeded, so only those reconcile with the server (which returns 409 if so)
          // before we decide; everything else releases the slot in the background.
          const outcomeUncertain = !!(result.error &&
            result.error.type !== 'card_error' && result.error.type !== 'validation_error')
          let url2 = API_LOCATION + 'bookings/company-groups/' + code + '/payment/clear'
          if(outcomeUncertain && self.payment_intent_id){
            try {
              // Keep the spinner up while we verify: one continuous spinner, then the result.
              await axios.post(url2, { payment_id: self.payment_intent_id })
            } catch (clearErr) {
              if(clearErr.response && clearErr.response.status === 409){
                // charge actually went through — confirm, do NOT re-prime for retry
                self.loading = false
                self.prevent_submit = false
                self.disable_submit = false
                self.order_number = response.data.orderId
                self.hash = response.data.hash
                self.timestamp = response.data.timestamp
                self.clearUTMFromStorage()
                // Fires when the dialog is DISPLAYED; the addToCart(9) in the
                // .then only fires if the customer taps OK. A confirmation_shown
                // with no 9 = customer saw the congratulations screen but left.
                self.addToCart(9, false, { event: 'confirmation_shown', order_number: self.order_number })
                swal(self.bookingSuccessSwal()).then(()=> {
                  self.$refs['wiz'].disableTabs();
                  self.$refs['wiz'].tabIndex(4)
                  self.scrollToTop()
                })
                return
              }
              console.log('payment/clear failed:', clearErr)
            }
          } else if(self.payment_intent_id){
            // Definite failure: release the slot in the background — no need to make
            // the customer wait, the charge did not go through.
            axios.post(url2, { payment_id: self.payment_intent_id })
              .catch(function(clearErr){ console.log('payment/clear failed:', clearErr) })
          }
          // Genuine failure: show the modal FIRST so it covers the Stripe
          // element re-init, then reset state and re-prime for retry behind it.
          swal({
            title: self.$t('book.swals.transactionFailed'),
            text: self.$t('book.swals.declinedCard'),
            type: 'error',
            showCancelButton: false,
            confirmButtonColor: '#fd5d93',
            confirmButtonText: self.$t('book.swals.backToCart')
          })
          self.bookingSubmitted = false;
          self.applied_gift_cards = []
          self.loading = false
          self.prevent_submit = false
          self.disable_submit = false
          self.stripeElementReady = false
          self.payment_intent_id = null
          self.initializeStripe()
        } else {
          self.loading = false
          self.prevent_submit = false
          self.disable_submit = false
          self.trackPixelEvent('Purchase', self.due_now, response.data.orderId)
          if(window.dataLayer) {
            window.dataLayer.push({
              event: 'purchase',
              currency: self.locale.currency,
              value: self.locale.send_full_cart_amount_to_ga === 1 ? self.roundToFixed(self.payment.amount, 2) : self.due_now
            });
          }
          if(window.gtag) {
            if (window !== window.top) {
              let eventData = {
                eventType: 'purchase',
                eventValue: self.locale.send_full_cart_amount_to_ga === 1 ? self.roundToFixed(self.payment.amount, 2) :  self.due_now,
                currency: self.locale.currency
              }
              self.$nextTick(() => {
                self.postMessageTrackingEvent(eventData)
              });
            } else {
              gtag("event", "purchase", {
                currency: self.locale.currency,
                value: self.locale.send_full_cart_amount_to_ga === 1 ? self.roundToFixed(self.payment.amount, 2) : self.due_now
              })
            }
          }

          self.order_number = response.data.orderId
          self.hash = response.data.hash
          self.timestamp = response.data.timestamp
          self.clearUTMFromStorage()
          if(self.bss.auto_redirect){
            let time = parseInt(self.bss.redirect_delay) * 1000
            setTimeout(() => {
              // window.location.href = self.bss.redirect_url
              if (window !== window.top) {
                window.open(self.bss.redirect_url, '_blank');
              } else {
                window.location.href = self.bss.redirect_url
              }
            }, time)
          }
          // Displayed-marker; the 9 in .then only fires on the customer's OK.
          self.addToCart(9, false, { event: 'confirmation_shown', order_number: self.order_number })
          swal(self.bookingSuccessSwal()).then((response)=> {
            self.$refs['wiz'].disableTabs();
            self.$refs['wiz'].tabIndex(4)
            if (window !== window.top) {
              self.$nextTick(() => {
                self.updateParentAboutPageChange()
              });
            }
            self.scrollToTop()
            self.addToCart(9)
            self.trackPixelEvent('Success', self.due_now, self.order_number)
            if(window.dataLayer) {
              window.dataLayer.push({
                event: 'success',
                currency: self.locale.currency,
                value: self.locale.send_full_cart_amount_to_ga === 1 ? self.roundToFixed(self.payment.amount, 2) : self.due_now
              });
            }
            if(window.gtag) {
              if (window !== window.top) {
                let eventData = {
                  eventType: 'success',
                  eventValue: self.locale.send_full_cart_amount_to_ga === 1 ? self.roundToFixed(self.payment.amount, 2) :  self.due_now,
                  currency: self.locale.currency
                }
                self.$nextTick(() => {
                  self.postMessageTrackingEvent(eventData)
                });
              } else {
                gtag("event", "success", {
                  currency: self.locale.currency,
                  value: self.locale.send_full_cart_amount_to_ga === 1 ? self.roundToFixed(self.payment.amount, 2) :  self.due_now
                })
              }
            }
          })
        }
      }).catch(async function(err) {
        // Catches promise rejection from confirmPayment (network error, SDK failure,
        // unexpected throw). Reconcile with the server before declaring failure: the
        // charge may have gone through even though the SDK threw. /payment/clear returns
        // 409 if it did, in which case confirm the booking instead of letting the
        // customer retry into a double charge.
        console.log('confirmPayment rejected:', err)
        // Rejections previously logged only to the customer's console,
        // leaving no server-side trace (no device, no error). Mirror the
        // resolved-failure telemetry so rejected confirms are diagnosable.
        self.addToCart(7, false, {
          event: 'stripe_confirm_result',
          rejected: true,
          payment_intent_id: self.payment_intent_id || null,
          selected_method: self.stripe_payment_method || null,
          error_name: err && err.name ? err.name : null,
          error_message: err && err.message ? err.message : String(err)
        })
        if(self.payment_intent_id){
          let url2 = API_LOCATION + 'bookings/company-groups/' + code + '/payment/clear'
          try {
            await axios.post(url2, { payment_id: self.payment_intent_id })
          } catch (clearErr) {
            if(clearErr.response && clearErr.response.status === 409){
              self.loading = false
              self.prevent_submit = false
              self.disable_submit = false
              self.tokenizing = false
              self.order_number = response.data.orderId
              self.hash = response.data.hash
              self.timestamp = response.data.timestamp
              self.clearUTMFromStorage()
              self.addToCart(9, false, { event: 'confirmation_shown', order_number: self.order_number })
              swal(self.bookingSuccessSwal()).then(()=> {
                self.$refs['wiz'].disableTabs();
                self.$refs['wiz'].tabIndex(4)
                self.scrollToTop()
              })
              return
            }
            console.log('payment/clear failed:', clearErr)
          }
        }
        // Show the modal FIRST so it covers the Stripe element re-init,
        // then reset state and re-prime for retry behind it.
        swal({
          title: self.$t('book.swals.transactionFailed'),
          text: self.$t('book.swals.declinedCard'),
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#fd5d93',
          confirmButtonText: self.$t('book.swals.backToCart')
        })
        self.bookingSubmitted = false
        self.applied_gift_cards = []
        self.loading = false
        self.prevent_submit = false
        self.disable_submit = false
        self.tokenizing = false
        self.stripeElementReady = false
        self.payment_intent_id = null
        self.initializeStripe()
      });
    },
    async completeBooking(){
      this.loading = true
      this.bookingSubmitted = true;
      this.addToCart(7)
      this.disable_submit = true
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/payment?cart_id=' + this.cart_id
      // let url = API_LOCATION + 'bookings/company-groups/' + code + '/payment/a7f2d9e4?cart_id=' + this.cart_id
      // Format card data for non-Accept-Hosted flows (legacy)
      if (this.payment.cardNumber) {
        this.payment.cardNumber = this.payment.cardNumber.replace(/\s/g, '');
      }
      if (this.payment.expirationDate && this.payment.expirationDate.includes('/')) {
        let year = '20' + this.payment.expirationDate.split('/')[1]
        let month = this.payment.expirationDate.split('/')[0]
        this.payment.expirationDate = year + '-' + month
      }

      let subtotal = this.getCartSubtotal()
      if(subtotal.toString().includes(',')){
        subtotal = subtotal.replace(',', '.')
      }
      let cart = this.getBookingsFromCart()
      let custom_fields = []
      let resp = ''
      for(let n in this.custom_fields){
        if(!this.isFieldVisibile(this.custom_fields[n])) continue
        resp = this.custom_fields[n].customer_response
        if(this.custom_fields[n].type === 3 && this.custom_fields[n].customer_response){
          if(this.custom_fields[n].customer_response.has_follow_up_field){
            resp = this.custom_fields[n].customer_response.name + ': ' + this.custom_fields[n].customer_response.follow_up_response
          } else {
            resp = this.custom_fields[n].customer_response.name
          }
        }
        custom_fields.push({
          customer_response: resp,
          id: this.custom_fields[n].id,
          type: this.custom_fields[n].type
        })
      }
      let data = {
        ...this.smsConsentPayload(),
        cart: this.cart_id,
        tip: this.roundToFixed(this.applied_tip, 2),
        bookings: cart.bookings,
        gift_cards: cart.gift_cards,
        items: cart.items,
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        discount: this.getDiscounts(),
        promo_codes: this.promo_codes,
        total: this.roundToFixed(this.payment.amount, 2),
        subtotal: subtotal,
        currency: this.locale.currency,
        deposit: this.pay_deposit ? Math.min(this.deposit, this.getTotalAmount()) : null,
        paid_deposit: this.pay_deposit,
        custom_fields: custom_fields,
        bss_id: this.bss && this.bss.id ? this.bss.id : null,
        applied_gift_cards: this.applied_gift_cards,
        locale: this.$i18n.locale,
        utm_source: this.utm_source,
        utm_campaign: this.utm_campaign,
        utm_medium: this.utm_medium,
        referer: this.referer,
        save_card_for_future: this.save_card_for_future
      }
      if(this.payment_intent_id){
        data.paymentIntent = this.payment_intent_id
      }


      if(this.selectedPaymentOption.name !== 'Gift card' && this.selectedPaymentOption.name !== 'Card'){
        data.payment_method = this.selectedPaymentOption
        data.cardholder_first_name = this.payment.cardholder_first_name
        data.cardholder_last_name = this.payment.cardholder_last_name
      }

      data.pay_on_arrival = this.pay_on_arrival
      let payment = {
        cardholder_first_name: this.payment.cardholder_first_name,
        cardholder_last_name: this.payment.cardholder_last_name
      }
      data.payment = payment

      if((data.total > 0 && !this.pay_deposit) || (data.deposit > 0 && this.pay_deposit)){
        if(this.allow_pay_on_arrival && this.pay_on_arrival){
          // this.loading = true
          data.pay_on_arrival = true
        } else if(this.selectedPaymentOption.name === 'Card') {
          // No-capture checkouts (on_approval requests, pay on arrival) hide the
          // card form; there is nothing to tokenize. The other gateway branches
          // already skip here, and without this guard Square tokenizes the hidden
          // empty form, throws, and the submit died silently.
          if (this.payment_settings.payment_gateway_id === 2 && !this.noCaptureCheckout && this.due_now > 0) {
            //Square
            this.loading = true
            let token;
            try {
              token = await this.tokenize(this.card);
            } catch (error) {
              this.squareSubmitFailed('tokenize', error)
              return;
            }
            let token2
            try {
              token2 = await this.tokenize(this.card);
            } catch (error) {
              this.squareSubmitFailed('tokenize', error)
              return;
            }

            let verificationToken
            try {
              verificationToken = await this.verifyBuyer(this.square, token.token, token.zip);
            } catch (error) {
              this.squareSubmitFailed('verify_buyer', error)
              return;
            }

            data.payment.locationId = this.squareLocationId
            data.payment.sourceId = token.token
            data.payment.sourceId2 = token2.token
            data.payment.verificationToken = verificationToken
            data.payment.zip = token.zip
          } else if (this.payment_settings.payment_gateway_id === 1){
            data.payment.opaqueData = this.authorize_opaque_data
            data.payment.zip = this.authorize_zip
          }
          else if (this.payment_settings.payment_gateway_id === 4){
            this.paystack_reference = ''+Math.floor((Math.random() * 1000000000) + 1)
            data.paystack_reference = this.paystack_reference
          }
        }
      }

      if(this.prevent_submit == false){
        this.loading = true
        axios.post(url, data)
          .then(async response => {
            // Defensive guard: never advance to the confirmation tab without a real
            // order number from the backend. An unexpected 2xx body (missing orderId,
            // a second double-submit response overwriting a prior one, etc.) used to
            // render tab 4 with an empty "Order reference: #" and a false "PAID" badge.
            if (!response.data || !response.data.orderId) {
              this.failEcePaymentIfPending()
              this.bookingSubmitted = false
              this.loading = false
              this.disable_submit = false
              this.prevent_submit = false
              this.tokenizing = false
              swal({
                title: this.$t('book.swals.transactionFailed'),
                text: this.$t('book.swals.declinedCard'),
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#fd5d93',
                confirmButtonText: this.$t('book.swals.backToCart')
              })
              return
            }
            // Gateway timeout: the payment is being verified server-side. Do not
            // show the confirmation tab and block resubmission; the customer gets
            // a confirmation email once the payment is verified, or the slot is
            // released if it did not go through.
            if (response.data.status === 'pending') {
              this.failEcePaymentIfPending()
              this.prevent_submit = true
              this.disable_submit = true
              this.loading = false
              this.tokenizing = false
              swal({
                title: this.$t('book.swals.paymentVerifying'),
                text: this.$t('book.swals.paymentVerifyingText'),
                type: 'info',
                showCancelButton: false,
                confirmButtonColor: '#fd5d93',
                confirmButtonText: this.$t('book.swals.backToBooking')
              })
              return
            }
            if(response.data.isBookingRequest){
              this.isBookingRequest = true
            }
            if(response.data.isCustomPaymentUnpaid){
              this.isCustomPaymentUnpaid = true
              this.due_now = 0
              this.due_later = this.getTotalAmount()
            } else if(this.pay_deposit){
              let paid = this.due_now
              for(let n in this.applied_gift_cards){
                paid += this.applied_gift_cards[n].remaining
              }
              this.due_now = paid
            } else if(this.noCaptureCheckout){
              this.due_now = 0
              this.due_later = this.getTotalAmount()
            }
            else {
              this.due_now = this.getDueNow()
              if (this.due_now < 0) { this.due_now = 0 }
              this.due_later = 0
            }
            if(this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 3 && !this.noCaptureCheckout && parseFloat(this.due_now) > 0){
              // The intent amount and the card-on-file flag are both set by the
              // booking request above (save_card_for_future is in its payload).
              // Nothing on the page may update the intent between here and
              // confirmPayment: the page's due figure is a display number and
              // in deposit mode includes the gift card amount.

              if (this.stripe_payment_method === 'apple_pay' || this.stripe_payment_method === 'google_pay') {
                // Wallet sheets must open inside a tap's user-activation window
                // (iOS 26 Safari enforces this), so confirm waits for a second
                // tap with no preceding async work.
                this.wallet_pending_response = response
                this.wallet_pending_method = this.stripe_payment_method
                this.loading = false
                this.disable_submit = false
                this.$nextTick(() => {
                  const btn = this.$refs.payButton
                  if (btn && btn.$el && btn.$el.scrollIntoView) {
                    btn.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  }
                })
                return
              }
              // confirmPayment takes over the wallet sheet from here; the
              // pending ECE event must not be failed once confirm runs.
              this.eceConfirmEvent = null
              this.runStripeConfirm(response)

            } else if (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 4){
              let payment = this.payWithPaystack(cart.bookings, custom_fields, cart.gift_cards, subtotal)
              // this.loading = false
            } else {
              this.failEcePaymentIfPending()
              this.trackPixelEvent('Purchase', this.due_now, response.data.orderId)
              if(window.dataLayer) {
                window.dataLayer.push({
                  event: 'purchase',
                  currency: this.locale.currency,
                  value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
                });
              }
              if(window.gtag) {
                if (window !== window.top) {
                  let eventData = {
                    eventType: 'purchase',
                    eventValue: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now,
                    currency: this.locale.currency
                  }
                  this.$nextTick(() => {
                    this.postMessageTrackingEvent(eventData)
                  });
                } else {
                  gtag("event", "purchase", {
                    currency: this.locale.currency,
                    value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
                  })
                }
              }

              this.prevent_submit = true
              this.disable_submit = false
              this.order_number = response.data.orderId
              this.hash = response.data.hash
              this.timestamp = response.data.timestamp
              this.clearUTMFromStorage()

              if(this.bss.auto_redirect){
                let time = parseInt(this.bss.redirect_delay) * 1000
                setTimeout(() => {
                  //window.location.href = this.bss.redirect_url
                  if (window !== window.top) {
                    window.open(this.bss.redirect_url, '_blank');
                  } else {
                    window.location.href = this.bss.redirect_url
                  }
                }, time)
              }
              this.loading = false
              this.addToCart(9, false, { event: 'confirmation_shown', order_number: this.order_number })
              swal(this.bookingSuccessSwal()).then((response)=> {
                this.$refs['wiz'].disableTabs();
                this.$refs['wiz'].tabIndex(4)
                if (window !== window.top) {
                  this.$nextTick(() => {
                    this.updateParentAboutPageChange()
                  });
                }
                this.scrollToTop()
                this.addToCart(9)
                this.trackPixelEvent('Success', this.due_now, this.order_number)
                if(window.dataLayer) {
                  window.dataLayer.push({
                    event: 'success',
                    currency: this.locale.currency,
                    value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
                  });
                }
                if(window.gtag) {
                  if (window !== window.top) {
                    let eventData = {
                      eventType: 'success',
                      eventValue: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) :  this.due_now,
                      currency: this.locale.currency
                    }
                    this.$nextTick(() => {
                      this.postMessageTrackingEvent(eventData)
                    });
                  } else {
                    gtag("event", "success", {
                      currency: this.locale.currency,
                      value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
                    })
                  }
                }
              })
            }
          })
          .catch(err => {
            // BACKEND API FAILED - RELEASE THE LOCK
            this.failEcePaymentIfPending()
            this.bookingSubmitted = false;
            this.loading = false
            this.disable_submit = false
            this.prevent_submit = false
            this.tokenizing = false
            this.addToCart(8)
            if(err.response && err.response.data == 'This booking is no longer available'){
              swal({
                title: this.$t('book.swals.sorry'),
                text: this.$t('book.swals.bookingNotAvailable'),
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#fd5d93',
                confirmButtonText: this.$t('book.swals.startOver')
              }).then((response)=> {
              })

            } else if (err.response && err.response.status == 500){
              if(this.payment_settings.payment_gateway_id === 1){
                this.authorize_opaque_data = null
                this.authorize_zip = null
              }

              swal({
                title: this.$t('book.swals.invalidTransaction'),
                text: err.response.data,
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#fd5d93',
                confirmButtonText: this.$t('book.swals.backToBooking')
              }).then((response)=> {
                if(err.response.data === 'Your cart has expired'){
                  this.handleCartExpiration()
                }
              })
            } else if (err.response && err.response.status == 409){
              swal({
                title: this.$t('book.swals.error'),
                text: err.response.data,
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#fd5d93',
                confirmButtonText: this.$t('book.swals.backToBooking')
              }).then((response)=> {
              })
            }
            if(err.response && err.response.status == 401){
              this.$router.push('/forbidden')
            }
          })
      }

    },
    async getBookingSlots(){
      // Dedicated flag: the global `loading` hides whole page sections via
      // v-show="!loading", which would blank the page instead of overlaying
      // the calendar.
      this.calendar_loading = true
      let dt = getNow()
      let calendarApi = this.$refs.calendar.getApi();
      const view = calendarApi.view; // Get the current view
      let start = view.activeStart; // Start date of the visible range
      let end = view.activeEnd; // End date of the visible range
      calendarApi.setOption('firstDay', this.locale.first_day_of_week);
      if(this.locale.country === 'GB') {
        calendarApi.setOption('locale', gbLocale);
        calendarApi.setOption('slotLabelFormat', function (date) {
          let hour = date.date.hour
          let minute = '00'
          let dd = 'AM'
          if (date.date.minute == 0){
            return hour + ':' + minute
          }}
        );
      }
      // Groups configured for 24h time get a 24h axis and 24h event times,
      // regardless of country. Without this only GB got 24h and everyone else
      // saw FullCalendar's 12h defaults even with time_format set to HH:mm.
      if(this.locale.time_format === 'HH:mm') {
        calendarApi.setOption('slotLabelFormat', function (date) {
          if (date.date.minute == 0){
            return date.date.hour + ':00'
          }}
        );
        calendarApi.setOption('eventTimeFormat', { hour: '2-digit', minute: '2-digit', hour12: false });
      }

      start = start.getFullYear() + '-' + ('0' + (start.getMonth()+1)).slice(-2) + '-' + ('0' + start.getDate()).slice(-2)
      end = end.getFullYear() + '-' + ('0' + (end.getMonth()+1)).slice(-2) + '-' + ('0' + end.getDate()).slice(-2)
      let today = moment(getNow()).format('YYYY-MM-DD')

      let url = API_LOCATION + 'games/'
        + this.selectedGame.game_id
        + '/bookings?from=' + start
        + '&to=' + end
        + '&time=' + dt.getHours() + ':' + dt.getMinutes() + '&date=' + today
        + '&include_capacity=1'
      let start_date = new Date()
      let end_date = new Date()
      let newEvent = {}

      axios.get(url)
        .then(response => {
          syncServerNow(response.data.server_now)
          calendarApi.removeAllEvents();
          this.booking_slots = response.data.booking_slots

          if(response.data.booking_slots.length >0){
            calendarApi.setOption('slotMinTime', response.data.booking_slots[0].start_time);
            // Trim trailing empty hours: end the grid at the latest slot end.
            // Ends are compared as minutes so a slot running past midnight
            // (11 PM to 12 AM) counts beyond 24:00; as a bare end time its
            // 00:00 would rank lowest and the grid would stop above the slot.
            const lastEnd = response.data.booking_slots.reduce(
              (max, s) => Math.max(max, this.slotEndMinutes(s)), 0)
            if (lastEnd > 0) {
              calendarApi.setOption('slotMaxTime',
                ('0' + Math.floor(lastEnd / 60)).slice(-2) + ':' + ('0' + (lastEnd % 60)).slice(-2) + ':00');
            }
          }
          for (let n in response.data.booking_slots){
            start_date = new Date()
            start_date = new Date(start_date.getFullYear(), start_date.getMonth(), 1)
            start_date.setFullYear(response.data.booking_slots[n].booking_date.split('T')[0].split('-')[0])
            start_date.setMonth(parseInt(response.data.booking_slots[n].booking_date.split('T')[0].split('-')[1]) - 1)
            start_date.setDate(response.data.booking_slots[n].booking_date.split('T')[0].split('-')[2])
            start_date.setHours(response.data.booking_slots[n].start_time.split(':')[0]);
            start_date.setMinutes(response.data.booking_slots[n].start_time.split(':')[1]);
            end_date = new Date()
            end_date = new Date(end_date.getFullYear(), end_date.getMonth(), 1)
            end_date.setFullYear(response.data.booking_slots[n].booking_date.split('T')[0].split('-')[0])
            end_date.setMonth(parseInt(response.data.booking_slots[n].booking_date.split('T')[0].split('-')[1]) - 1)
            end_date.setDate(response.data.booking_slots[n].booking_date.split('T')[0].split('-')[2])
            end_date.setHours(response.data.booking_slots[n].end_time.split(':')[0]);
            end_date.setMinutes(response.data.booking_slots[n].end_time.split(':')[1]);
            // A slot running past midnight ends on end_date, not booking_date.
            // Built from booking_date its end lands before its start, and the
            // past-slot guard below would hide it for the whole day.
            if (this.slotEndsOnLaterDate(response.data.booking_slots[n])) {
              const endParts = response.data.booking_slots[n].end_date.split('T')[0].split('-')
              end_date = new Date(endParts[0], parseInt(endParts[1]) - 1, endParts[2],
                response.data.booking_slots[n].end_time.split(':')[0],
                response.data.booking_slots[n].end_time.split(':')[1])
            }

            // Don't expose past slots (e.g. historical sold-out bookings) to customers.
            // The week grid always renders the full Mon-Sun range, so already-elapsed days
            // would otherwise leak booking history. Available/call-to-book are already
            // time-gated; this closes the sold-out/booked/blocked leak. end_date (not
            // start_date) so an in-progress slot still within a late-booking window survives.
            if (end_date < getNow()) {
              continue;
            }

            //min max ranges
            let blocked_days = 0
            let blocked_minutes = 0
            let unblock_date = getNow()

            // When allow_late_booking is 1, calculate deadline from slot start time
            // Otherwise, calculate minimum advance booking time from current time
            if (response.data.booking_slots[n].allow_late_booking === 1) {
              // Late booking: calculate deadline as slot_start_time + min_booking_value
              unblock_date = new Date(start_date.getTime())

              if(response.data.booking_slots[n].min_booking_period === 0){
                blocked_minutes = response.data.booking_slots[n].min_booking_value
                unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
              }else if(response.data.booking_slots[n].min_booking_period === 1){
                blocked_minutes = parseInt(response.data.booking_slots[n].min_booking_value) * 60
                unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
              } else if(response.data.booking_slots[n].min_booking_period === 2){
                blocked_days = response.data.booking_slots[n].min_booking_value
                unblock_date.setDate(unblock_date.getDate() + blocked_days)
              } else if (response.data.booking_slots[n].min_booking_period === 3){
                blocked_days = 7 * parseInt(response.data.booking_slots[n].min_booking_value)
                unblock_date.setDate(unblock_date.getDate() + blocked_days)
              } else if (response.data.booking_slots[n].min_booking_period === 4){
                //months
                const slotDate = new Date(unblock_date.getTime());
                const futureDate = new Date(slotDate.getTime());

                futureDate.setMonth(futureDate.getMonth() + parseInt(response.data.booking_slots[n].min_booking_value));
                const timeDifference = futureDate.getTime() - slotDate.getTime();
                blocked_days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
                unblock_date.setDate(unblock_date.getDate() + blocked_days)
              }
            } else {
              // Normal booking: calculate minimum advance booking from current time
              if(response.data.booking_slots[n].min_booking_period === 0){
                blocked_minutes = response.data.booking_slots[n].min_booking_value
                unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
              }else if(response.data.booking_slots[n].min_booking_period === 1){
                blocked_minutes = parseInt(response.data.booking_slots[n].min_booking_value) * 60
                unblock_date.setMinutes(unblock_date.getMinutes() + blocked_minutes)
              } else if(response.data.booking_slots[n].min_booking_period === 2){
                blocked_days = response.data.booking_slots[n].min_booking_value
                unblock_date.setDate(unblock_date.getDate() + blocked_days)
              } else if (response.data.booking_slots[n].min_booking_period === 3){
                blocked_days = 7 * parseInt(response.data.booking_slots[n].min_booking_value)
                unblock_date.setDate(unblock_date.getDate() + blocked_days)
              } else if (response.data.booking_slots[n].min_booking_period === 4){
                //months
                const currentDate = getNow();
                const futureDate = new Date(currentDate.getTime());

                futureDate.setMonth(futureDate.getMonth() + parseInt(response.data.booking_slots[n].min_booking_value));
                const timeDifference = futureDate.getTime() - currentDate.getTime();
                blocked_days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
                unblock_date.setDate(unblock_date.getDate() + blocked_days)
              }
            }

            // Hide slots that have entered the minimum-notice (or late-booking) window
            // when the schedule opted to hide them rather than show call-to-book.
            let pastMinNotice = response.data.booking_slots[n].allow_late_booking === 1
              ? getNow() > unblock_date
              : start_date <= unblock_date
            if (pastMinNotice && Number(response.data.booking_slots[n].hide_past_min_notice) === 1) {
              continue
            }

            let max_date = new Date(response.data.booking_slots[n].max_booking_date)
            const playerHeadroom = this.selectedGame.max_players_count - response.data.booking_slots[n].group_size
            const resourceCap = response.data.booking_slots[n].resource_max_remaining_seats
            const available_slots = resourceCap != null ? Math.min(playerHeadroom, resourceCap) : playerHeadroom

            newEvent = {
              id: response.data.booking_slots[n].id,
              title: response.data.booking_slots[n].status,
              start: start_date,
              end: end_date,
              allDay: false
            }
            // Determine if slot is available based on allow_late_booking setting
            let isAvailable = false;
            let isCallToBook = false;

            if (response.data.booking_slots[n].allow_late_booking === 1) {
              // Late booking: available before slot starts OR within late booking window (after slot starts, before deadline)
              const currentTime = getNow();
              isAvailable = response.data.booking_slots[n].online_display_mode !== 'non_bookable' && (response.data.booking_slots[n].status === 'available' || (response.data.booking_slots[n].online_display_mode === 'bookable' && response.data.booking_slots[n].status !== 'booked'))
                && (currentTime < start_date || (start_date <= currentTime && currentTime <= unblock_date)) && start_date < max_date;
              // Show as call-to-book only if past the deadline (late booking restrictions only apply after slot starts)
              isCallToBook = (
                ((response.data.booking_slots[n].status === 'available'
                    || (response.data.booking_slots[n].online_display_mode === 'bookable' && response.data.booking_slots[n].status !== 'booked'))
                  && currentTime > unblock_date && start_date < max_date)
                || response.data.booking_slots[n].status === 'call_to_book');
            } else {
              // Normal booking: available if slot is after minimum advance time
              isAvailable = response.data.booking_slots[n].online_display_mode !== 'non_bookable' && (response.data.booking_slots[n].status === 'available' || (response.data.booking_slots[n].online_display_mode === 'bookable' && response.data.booking_slots[n].status !== 'booked'))
                && start_date > unblock_date && start_date < max_date;
              isCallToBook = start_date >= getNow() && (
                ((response.data.booking_slots[n].status === 'available'
                    || (response.data.booking_slots[n].online_display_mode === 'bookable' && response.data.booking_slots[n].status !== 'booked'))
                  && start_date <= unblock_date && start_date < max_date)
                || response.data.booking_slots[n].status === 'call_to_book');
            }

            // Resource saturation overrides bookability regardless of underlying status.
            if (response.data.booking_slots[n].is_resource_saturated) {
              isAvailable = false
              isCallToBook = false
            }

            // Request-to-book classification (mirror of isRequestToBookSlot,
            // expressed in this path's date math: "window open" =
            // before/inside the booking window, "window failed" = past the
            // minimum notice). A closed late-booking window is never
            // requestable.
            let isRtb = false
            {
              const rtbSlot = response.data.booking_slots[n]
              if (this.allowRequestToBook && !rtbSlot.is_resource_saturated
                && rtbSlot.online_display_mode !== 'non_bookable'
                && start_date < max_date && start_date > getNow()
                && !this.isPublicBooking(this.selectedGame, rtbSlot)) {
                const windowOpen = rtbSlot.allow_late_booking === 1 ? getNow() <= unblock_date : start_date > unblock_date
                if (rtbSlot.status === 'requestable') {
                  isRtb = windowOpen || (rtbSlot.allow_late_booking !== 1 && Number(rtbSlot.request_past_min_notice) === 1)
                } else if (rtbSlot.status === 'available' && !windowOpen && rtbSlot.allow_late_booking !== 1
                  && Number(rtbSlot.request_past_min_notice) === 1 && !rtbSlot.has_external_link) {
                  isRtb = true
                }
              }
              if (isRtb) {
                isAvailable = false
                isCallToBook = false
              } else if (rtbSlot.status === 'requestable' && this.allowRequestToBook
                && !this.isPublicBooking(this.selectedGame, rtbSlot)
                && start_date >= getNow() && rtbSlot.allow_late_booking !== 1
                && start_date <= unblock_date && Number(rtbSlot.request_past_min_notice) !== 1
                && !rtbSlot.has_external_link) {
                // Requestable past its notice with no request flag: follows
                // the default three-way behavior — call to book.
                isCallToBook = true
              }
            }

            if(isRtb){
              newEvent.title = this.bss.request_to_book_text || this.$t('book.requestToBook')
              newEvent.slotKind = 'rtb'
              newEvent.bookingSlot = response.data.booking_slots[n]
              newEvent.backgroundColor = this.bss.rtb_slot_background_color || '#FFD600'
              newEvent.textColor = this.bss.rtb_slot_text_color || '#1E1E2F'
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            else if(isAvailable && !this.isPublicBooking(this.selectedGame, response.data.booking_slots[n])){
              newEvent.title = this.$t('book.available')
              newEvent.slotKind = 'available'
              newEvent.bookingSlot = response.data.booking_slots[n]
              newEvent.backgroundColor = this.bss.available_slot_background_color
              newEvent.textColor = this.bss.available_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            if(isAvailable && this.isPublicBooking(this.selectedGame, response.data.booking_slots[n])){
              newEvent.title = this.$t('book.available')
              newEvent.slotKind = 'available'
              newEvent.capacityAvailable = available_slots
              newEvent.capacityTotal = this.selectedGame.max_players_count
              newEvent.bookingSlot = response.data.booking_slots[n]
              newEvent.backgroundColor = this.bss.available_slot_background_color
              newEvent.textColor = this.bss.available_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            else if(isCallToBook){
              newEvent.slotKind = 'ctb'
              if(response.data.booking_slots[n].slot_text){
                newEvent.title = response.data.booking_slots[n].slot_text
              } else {
                newEvent.title = this.bss.call_to_book_text || this.$t('book.callToBook')
              }

              if(response.data.booking_slots[n].has_external_link){
                newEvent.url = response.data.booking_slots[n].external_link
              }
              newEvent.backgroundColor = this.bss.ctb_slot_background_color
              newEvent.textColor = this.bss.ctb_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            else if (response.data.booking_slots[n].is_resource_saturated && start_date < max_date) {
              newEvent.title = this.bss.booked_text
              newEvent.slotKind = 'soldout'
              newEvent.backgroundColor = this.bss.sold_out_slot_background_color
              newEvent.textColor = this.bss.sold_out_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            else if ((response.data.booking_slots[n].status === 'booked' || response.data.booking_slots[n].status === 'requested') && start_date < max_date &&
              (response.data.booking_slots[n].is_reservation_upgraded || !this.isPublicBooking(this.selectedGame, response.data.booking_slots[n]) ||
                (this.isPublicBooking(this.selectedGame, response.data.booking_slots[n])
                  && !this.hasRemainingSlots(this.selectedGame, response.data.booking_slots[n])))){
              newEvent.title = this.bss.booked_text
              newEvent.slotKind = 'soldout'
              newEvent.backgroundColor = this.bss.sold_out_slot_background_color
              newEvent.textColor = this.bss.sold_out_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            // Check if booked public slots with remaining capacity should be "call to book" based on time restrictions
            else if ((response.data.booking_slots[n].status === 'booked') && start_date < max_date &&
              response.data.booking_slots[n].online_display_mode !== 'non_bookable' &&
              !response.data.booking_slots[n].is_reservation_upgraded &&
              !response.data.booking_slots[n].is_resource_saturated &&
              this.isPublicBooking(this.selectedGame, response.data.booking_slots[n])
              && this.hasRemainingSlots(this.selectedGame, response.data.booking_slots[n])) {

              // Determine if this slot should be "call to book" based on timing rules
              let shouldBeCallToBook = false;
              if (response.data.booking_slots[n].allow_late_booking === 1) {
                // Late booking restrictions only apply AFTER the slot has started
                const currentTime = getNow();
                if (currentTime >= start_date) {
                  // Slot has started - check if we're past the deadline
                  shouldBeCallToBook = currentTime > unblock_date;
                } else {
                  // Slot hasn't started yet - should be available (not call to book)
                  shouldBeCallToBook = false;
                }
              } else {
                // Normal booking: call-to-book if within the advance booking window
                shouldBeCallToBook = start_date <= unblock_date;
              }

              if (shouldBeCallToBook) {
                // Render as call-to-book
                newEvent.slotKind = 'ctb'
                if(response.data.booking_slots[n].slot_text){
                  newEvent.title = response.data.booking_slots[n].slot_text
                } else if (!response.data.booking_slots[n].has_external_link && !response.data.booking_slots[n].slot_text){
                  newEvent.title = this.bss.call_to_book_text
                } else {
                  newEvent.title = this.$t('book.callToBook')
                }

                if(response.data.booking_slots[n].has_external_link){
                  newEvent.url = response.data.booking_slots[n].external_link
                }
                newEvent.backgroundColor = this.bss.ctb_slot_background_color
                newEvent.textColor = this.bss.ctb_slot_text_color
                newEvent.editable = false
                newEvent.startEditable = false
                calendarApi.addEvent(newEvent);
              } else {
                // Render as available (existing behavior)
                newEvent.title = this.$t('book.available')
                newEvent.slotKind = 'available'
                newEvent.capacityAvailable = available_slots
                newEvent.capacityTotal = this.selectedGame.max_players_count
                newEvent.bookingSlot = response.data.booking_slots[n]
                newEvent.backgroundColor = this.bss.available_slot_background_color
                newEvent.textColor = this.bss.available_slot_text_color
                newEvent.editable = false
                newEvent.startEditable = false
                calendarApi.addEvent(newEvent);
              }
            }
            else if ((response.data.booking_slots[n].status === 'blocked' || (response.data.booking_slots[n].status === 'requestable' && (!this.allowRequestToBook || this.isPublicBooking(this.selectedGame, response.data.booking_slots[n])))) && start_date < max_date){
              newEvent.title = this.bss.blocked_text
              newEvent.slotKind = 'soldout'
              newEvent.backgroundColor = this.bss.sold_out_slot_background_color
              newEvent.textColor = this.bss.sold_out_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }
            // Custom status shown online as Sold out: site sold out text and colors, not clickable.
            else if (response.data.booking_slots[n].online_display_mode === 'non_bookable' && start_date < max_date){
              newEvent.title = this.bss.booked_text
              newEvent.slotKind = 'soldout'
              newEvent.backgroundColor = this.bss.sold_out_slot_background_color
              newEvent.textColor = this.bss.sold_out_slot_text_color
              newEvent.editable = false
              newEvent.startEditable = false
              calendarApi.addEvent(newEvent);
            }

          }
          if (window !== window.top) {
            this.$nextTick(() => {
              this.updateParentAboutPageChange()
            });
          }
          this.calendar_loading = false
        })
        .catch(err => {
          this.loading = false
          this.calendar_loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })

    },
    // True when the slot ends on a later date than it starts and its end time
    // is not after its start time (e.g. 11 PM to 12 AM).
    slotEndsOnLaterDate(slot){
      if(!slot.end_date || !slot.end_time) return false
      return slot.end_date.split('T')[0] > slot.booking_date.split('T')[0] && slot.end_time <= slot.start_time
    },
    // Slot end as minutes from the start of its booking date, for sizing the
    // week grid. An overnight slot counts past 24:00; one spanning several
    // days only extends the grid to the end of its first day.
    slotEndMinutes(slot){
      if(!slot.end_time) return 0
      const minutes = parseInt(slot.end_time.split(':')[0]) * 60 + parseInt(slot.end_time.split(':')[1])
      if(!this.slotEndsOnLaterDate(slot)) return minutes
      const startDay = new Date(slot.booking_date.split('T')[0] + 'T00:00:00')
      const endDay = new Date(slot.end_date.split('T')[0] + 'T00:00:00')
      const days = Math.round((endDay - startDay) / 86400000)
      return days === 1 ? 1440 + minutes : 1440
    },
    getMaxPlayersByCategory(arr) {
      const maxPlayersByCategory = {};

      // Iterate through the array to find the maximum players for each category
      arr.forEach((item) => {
        const { category_id, max_players } = item;

        if (!(category_id in maxPlayersByCategory) || max_players > maxPlayersByCategory[category_id]) {
          maxPlayersByCategory[category_id] = max_players;
        }
      });

      // Update each item in the array with the maximum players for its category
      const updatedArray = arr.map((item) => ({
        ...item,
        maximum_players_for_category: maxPlayersByCategory[item.category_id]
      }));

      return updatedArray;
    },
    // Multiple durations. A pricing row carries game_duration_id: null for the default duration,
    // else the duration's id. Mirror of filterPricingByDuration in the console's pricing.js.
    filterPricingByDuration(rows, selectedDurationId){
      const list = Array.isArray(rows) ? rows : []
      if(selectedDurationId === null || selectedDurationId === undefined){
        return list.filter(r => r.game_duration_id === null || r.game_duration_id === undefined)
      }
      return list.filter(r => Number(r.game_duration_id) === Number(selectedDurationId))
    },
    // Rebuilds this.pricing and the category counters for the chosen duration
    applyDurationPricing(){
      const selectedId = this.selected_duration && Number(this.selected_duration.is_default) !== 1 ? this.selected_duration.id : null
      this.pricing = this.getMaxPlayersByCategory(this.filterPricingByDuration(this.pricing_all, selectedId))
      this.number_of_players = 0
      this.pricing_categories = []
      for(let n in this.pricing){
        if(!(_.find(this.pricing_categories, { category_id: this.pricing[n].category_id }))){
          this.pricing_categories.push({
            category_id: this.pricing[n].category_id,
            category: this.pricing[n].category.toLowerCase(),
            number_of_players: this.pricing[n].default_participants,
            price: this.pricing[n].price,
            maximum_participants: this.pricing[n].maximum_participants,
            minimum_participants: this.pricing[n].minimum_participants,
            maximum_players_for_category: this.pricing[n].maximum_players_for_category
          })
          this.number_of_players++
        }
      }
    },
    selectDuration(d){
      this.selected_duration = d
      this.book_entire_slot = false
      this.applyDurationPricing()
      this.getSubtotal()
    },
    durationButtonStyle(d){
      const active = this.selected_duration && Number(this.selected_duration.id) === Number(d.id)
      if(active){
        return { 'font-family': this.bss.font_family_card, 'border-color': this.bss.button_color, 'background-color': this.bss.button_color,
          'background-image': 'linear-gradient(to bottom left,' + this.bss.button_color + ', ' + this.bss.button_color + ', ' + this.bss.button_color + ') !important',
          'color': this.bss.card_color }
      }
      return { 'font-family': this.bss.font_family_card, 'border-color': this.bss.button_color, 'color': this.bss.button_color }
    },
    // End of the chosen window for a slot object (HH:mm:ss) and its date, or null when no duration applies
    durationWindowFor(slot, duration){
      if(!slot || !duration || !slot.start_time) return null
      const start = moment(`${String(slot.booking_date).substring(0, 10)} ${slot.start_time}`, 'YYYY-MM-DD HH:mm:ss')
      if(!start.isValid()) return null
      const end = start.clone().add(Number(duration.duration_minutes), 'minutes')
      return { end_time: end.format('HH:mm:ss'), end_date: end.format('YYYY-MM-DD') }
    },
    selectedEndTime(){
      const w = this.durationWindowFor(this.selectedBooking, this.selected_duration)
      return w ? w.end_time : null
    },
    cartLineEndTime(c){
      return c && c.selected_duration && c.end_time ? c.end_time : null
    },
    async getPricing(){
      this.loading = true
      let url = API_LOCATION + 'games/' + this.selectedGame.game_id + '/pricing?booking_slot_id=' + this.selectedBooking.id
      axios.get(url)
        .then(response => {
          this.loading = false
          this.pricing_all = response.data.pricing
          this.price_settings = response.data.settings
          this.has_addons = this.price_settings.has_addons
          this.book_entire_slot = false
          // Multiple durations: the default duration is preselected; its categories drive the counters
          // Ascending by minutes, the same order as the console
          this.durations = (Array.isArray(response.data.durations) ? [...response.data.durations] : []).sort((a, b) => (Number(a.duration_minutes) - Number(b.duration_minutes)) || (Number(a.id) - Number(b.id)))
          if(this.price_settings.enable_multiple_durations && this.durations.length > 0){
            this.selected_duration = this.durations.find(d => Number(d.is_default) === 1) || this.durations[0]
          } else {
            this.selected_duration = null
          }
          this.applyDurationPricing()
          // Upsell "Book now": start from the party size of the booking already in
          // the cart, within this category's limits and the slot's remaining capacity
          if(this.upsell_prefill_quantity && this.pricing_categories.length === 1){
            const cat = this.pricing_categories[0]
            const minP = Number(cat.minimum_participants) || 0
            let maxP = Number(cat.maximum_participants) || this.upsell_prefill_quantity
            maxP = Math.min(maxP, Number(cat.maximum_players_for_category) || maxP)
            cat.number_of_players = Math.min(Math.max(this.upsell_prefill_quantity, minP), maxP)
          }
          this.upsell_prefill_quantity = null
          this.getSubtotal()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    async getAddons(gameId){
      this.loading = true
      let code = this.$route.params.company
      let url = API_LOCATION + 'games/' + gameId + '/addons?id=' + code
      axios.get(url)
        .then(response => {
          this.loading = false
          this.addons = response.data.addons
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
      // this.$refs['step3'].loadModel(this.wizardModel)
    },
    async wizardComplete() {
    },
    getAuthToken() {
      return new Promise(function (resolve) {
        Auth.currentSession()
          .then(data => {
            resolve(data.idToken.jwtToken)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    async getSchedules(init){
      let eventParam = this.$route.params.event
      if(this.show_calendar){
        setTimeout(()=>{
          let calendarApi = this.$refs.calendar.getApi();
          calendarApi.gotoDate(this.currentDay);
        }, 100);

      }
      let dt = getNow()
      dt = dt.getFullYear() + '-' + ('0' + (dt.getMonth()+1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)

      if(dt !== this.currentDay){
        this.currentTime = '00:00'
      } else {
        let date = getNow()
        this.currentTime = date.getHours() + ':' + date.getMinutes()
      }

      let code = this.$route.params.company
      // In week-calendar view the calendar's own loading overlay is the
      // indicator; raising the global flag too stacks the full-screen mask
      // on top of it (double spinner on week navigation).
      if (!this.show_calendar) {
        this.loading = true
      }
      let url = API_LOCATION + 'bookings/company-groups/' + code + '?date=' + this.currentDay + '&time=' + this.currentTime

      if(eventParam && eventParam !== 'gift-card') {
        if (/^\d+$/.test(eventParam)) {
          url += '&game=' + eventParam
        } else {
          url += '&slug=' + eventParam
        }
      }

      axios.get(url)
        .then(response => {
          this.loading = false
          syncServerNow(response.data.server_now)
          this.games = _.orderBy(response.data.schedules, 'position')
          // A page with no active events is still valid when it sells gift cards
          // (is_gift_card stays false for numeric direct game links, which keep
          // their 404 on an empty result).
          if(this.games.length <= 0 && eventParam && eventParam !== 'gift-card' && !this.is_gift_card){
            this.notFound = true
          }
          if(this.games.length <= 0 ){
            this.empty = true
          }
          if (window !== window.top && !init) {
            this.$nextTick(() => {
              this.updateParentAboutPageChange()
            });
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })

    },
    silentRefreshSchedules(){
      this._silentRefreshId = (this._silentRefreshId || 0) + 1
      let requestId = this._silentRefreshId

      let eventParam = this.$route.params.event
      let dt = getNow()
      dt = dt.getFullYear() + '-' + ('0' + (dt.getMonth()+1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)

      if(dt !== this.currentDay){
        this.currentTime = '00:00'
      } else {
        let date = getNow()
        this.currentTime = date.getHours() + ':' + date.getMinutes()
      }

      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '?date=' + this.currentDay + '&time=' + this.currentTime

      if(eventParam && eventParam !== 'gift-card') {
        if (/^\d+$/.test(eventParam)) {
          url += '&game=' + eventParam
        } else {
          url += '&slug=' + eventParam
        }
      }

      axios.get(url)
        .then(response => {
          if (requestId !== this._silentRefreshId) return
          syncServerNow(response.data.server_now)
          this.games = _.orderBy(response.data.schedules, 'position')
        })
        .catch(err => {
          console.warn('Silent refresh failed:', err && err.message)
        })
    },
    roundToFixed(num, decimals) {
      if (num == null || isNaN(num)) {
        return (0).toFixed(decimals);
      }
      // JS toString switches to scientific notation for very small numbers (~< 1e-7).
      // Concatenating 'e' + decimals onto a string like '2.84e-14' produces invalid
      // scientific notation ('2.84e-14e2'), which Number() turns into NaN.
      // Sub-half-unit values are below display precision anyway, so snap to 0.
      const halfUnit = Math.pow(10, -(decimals + 1)) * 5
      if (Math.abs(num) < halfUnit) {
        return (0).toFixed(decimals);
      }
      let rounded = Math.round(Number(num + 'e' + decimals));
      return Number(rounded + 'e-' + decimals).toFixed(decimals);
    },
    getAmount(integer){
      if(integer == null){
        return
      }
      return this.roundToFixed(integer, 2)
    },
    validQuantity(){
      let num = 0
      let errors = 0

      for(let m in this.pricing_categories){
        num += this.pricing_categories[m].number_of_players
      }

      // Check limit_purchase_category constraint
      if(this.price_settings.limit_purchase_category && !this.book_entire_slot){
        let categoriesWithPlayers = 0
        for(let m in this.pricing_categories){
          if(this.pricing_categories[m].number_of_players > 0){
            categoriesWithPlayers++
          }
        }

        if(categoriesWithPlayers > 1){
          this.errors.number_of_players = this.$t('book.errors.onlyOneCategoryAllowed')
          errors++
        } else if(categoriesWithPlayers === 0 && num === 0){
          this.errors.number_of_players = this.$t('book.errors.selectAtLeastOnePlayer')
          errors++
        }
      }

      // Only check other validations if no limit_purchase_category error
      if(errors === 0){
        // Check total group size limits
        if(num > this.selectedGame.max_players_count && !this.book_entire_slot){
          this.errors.number_of_players = this.$t('book.errors.numberOfPlayerExceedsCapacity')
          errors++
        } else if (this.isPublicBooking(this.selectedGame, this.selectedBooking) &&
          (num > (this.selectedGame.max_players_count - this.selectedBooking.group_size)) && !this.book_entire_slot){
          this.errors.number_of_players = this.$t('book.errors.totalNumberOfPlayersGreaterThan') + (this.selectedGame.max_players_count - this.selectedBooking.group_size)
          errors++
        } else if (this.selectedBooking.resource_max_remaining_seats != null &&
          num > this.selectedBooking.resource_max_remaining_seats && !this.book_entire_slot){
          this.errors.number_of_players = this.$t('book.errors.totalNumberOfPlayersGreaterThan') + this.selectedBooking.resource_max_remaining_seats
          errors++
        } else if(num < this.selectedGame.min_players_count && !this.book_entire_slot){
          this.errors.number_of_players = this.$t('book.errors.numberOfPlayerLessThanMinimum')
          errors++
        }
      }

      // Only clear error if no errors were found
      if(errors === 0){
        this.errors.number_of_players = ''
      }

      return errors > 0 ? false : true
    },
    updateTotalPlayerCount(){
      // Helper method to calculate total player count without recalculating subtotal
      this.number_of_players = 0
      for(let m in this.pricing_categories) {
        this.number_of_players += this.pricing_categories[m].number_of_players
      }
    },
    getSubtotal(){
      this.subtotal = 0
      this.number_of_players = 0
      if(this.price_settings.cumulative_category_pricing){
        if(this.price_settings.pricing_type_id === 1){
          for(let m in this.pricing_categories) {
            this.number_of_players += this.pricing_categories[m].number_of_players
          }
          for(let m in this.pricing_categories){
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.number_of_players >= this.pricing[n].min_players
                && this.number_of_players <= this.pricing[n].max_players) {
                this.subtotal += this.pricing[n].price * this.pricing_categories[m].number_of_players
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.number_of_players > this.pricing[last_index].max_players){
              this.subtotal += this.pricing[last_index].price * this.pricing_categories[m].number_of_players
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.number_of_players !== 0 &&
              this.number_of_players < smallest_price_category.min_players){
              this.subtotal += smallest_price_category.price * this.pricing_categories[m].number_of_players
            }
          }
        }
        else if(this.price_settings.pricing_type_id === 2){
          for(let m in this.pricing_categories) {
            this.number_of_players += this.pricing_categories[m].number_of_players
          }
          for(let m in this.pricing_categories){
            // Empty categories are never sold; total headcount only picks the tier (OTC-2911)
            if(!(this.pricing_categories[m].number_of_players > 0)) continue
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.number_of_players >= this.pricing[n].min_players
                && this.number_of_players <= this.pricing[n].max_players) {
                this.subtotal += this.pricing[n].price
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.number_of_players > this.pricing[last_index].max_players){
              this.subtotal += this.pricing[last_index].price
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.number_of_players !== 0 &&
              this.number_of_players < smallest_price_category.min_players){
              this.subtotal += smallest_price_category.price
            }
          }
        }
      } else {
        if(this.price_settings.pricing_type_id === 1){
          for(let m in this.pricing_categories){

            this.number_of_players += this.pricing_categories[m].number_of_players
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.pricing_categories[m].number_of_players >= this.pricing[n].min_players
                && this.pricing_categories[m].number_of_players <= this.pricing[n].max_players) {
                this.subtotal += this.pricing[n].price * this.pricing_categories[m].number_of_players
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players > this.pricing[last_index].max_players){
              this.subtotal += this.pricing[last_index].price * this.pricing_categories[m].number_of_players
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players !== 0 &&
              this.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              this.subtotal += smallest_price_category.price * this.pricing_categories[m].number_of_players
            }
          }
        }
        else if(this.price_settings.pricing_type_id === 2){
          for(let m in this.pricing_categories){
            this.number_of_players += this.pricing_categories[m].number_of_players
            for(let n in this.pricing){
              if(this.pricing[n].category_id === this.pricing_categories[m].category_id
                && this.pricing_categories[m].number_of_players >= this.pricing[n].min_players
                && this.pricing_categories[m].number_of_players <= this.pricing[n].max_players) {
                this.subtotal += this.pricing[n].price
                break
              }
            }
            let last_index = _.findLastKey(this.pricing, {category_id: this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players > this.pricing[last_index].max_players){
              this.subtotal += this.pricing[last_index].price
            }

            let smallest_price_category = _.find(this.pricing, {category_id : this.pricing_categories[m].category_id})
            if(this.pricing_categories[m].number_of_players !== 0 &&
              this.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              this.subtotal += smallest_price_category.price
            }
          }
        }
      }
    },
    getBss(){
      const today = moment().format('YYYY-MM-DD')
      const code = this.$route.params.company
      const eventParam = this.$route.params.event
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/booking?date=' + today
      if (eventParam && eventParam !== 'gift-card') {
        if (/^\d+$/.test(eventParam)) {
          url += '&game=' + eventParam
        } else {
          url += '&slug=' + eventParam
        }
      }

      return axios.get(url)
        .then(response => {
          this.notFound = false
          this.gift_card_settings_init = response.data.gift_card_settings
          this.bss = response.data.config[0]
          document.documentElement.style.setProperty('--input-border-color', inputBorderColor(this.bss))
          this.createCart(document.referrer)
          this.$nextTick(() => {
            if (this.$refs.wiz) {
              this.$refs.wiz.$forceUpdate()
            }
          })
          this.locale = response.data.locale
          applyPageLocale(this.locale && this.locale.default_locale, this.bss && Number(this.bss.show_language_switcher) === 1)
          this.taxes = response.data.taxes
          this.fees = response.data.fees
          this.allow_pay_on_arrival = this.bss.allow_pay_on_arrival

          // Set the date based on default_date_type setting
          if (this.bss.default_date_type === 1 && this.bss.default_days_ahead > 0) {
            // Days ahead
            this.setCurrentDate(this.bss.default_days_ahead)
            this.getSchedules()
          } else if (this.bss.default_date_type === 2 && this.bss.default_specific_date) {
            // Specific date
            this.setCurrentDateFromSpecific(this.bss.default_specific_date)
            this.getSchedules()
          } else if (this.bss.default_date_type === 3 && this.bss.earliest_available_date) {
            // Earliest available date
            this.setCurrentDateFromSpecific(this.bss.earliest_available_date)
            this.getSchedules()
          }

          // Auto-refresh at midnight (venue time) for display mode (TV screens)
          if (this.bss.hide_date_selection) {
            const now = getNow()
            const midnight = new Date(now)
            midnight.setHours(24, 0, 0, 0)
            const msUntilMidnight = midnight.getTime() - now.getTime()
            this._displayModeTimeout = setTimeout(() => {
              window.location.reload()
            }, msUntilMidnight)
          }

          // Initialize WebSocket for real-time availability updates
          if (this.bss.enable_real_time_updates) {
            this._bookingWs = new BookingWebSocket({
              companyGroupId: this.bss.company_group_id,
              date: this.currentDay,
              onBookingChanged: () => this.silentRefreshSchedules()
            })
            this._bookingWs.connect()
          }

          this.payment_settings = response.data.payment_settings
          if(this.payment_settings.allow_custom_tipping_options && this.payment_settings.custom_tipping_value_type === 1){
            this.tip_placeholder = this.$t('book.tipAmount') + ' (' + this.getCurrencySymbol(this.locale.currency) + ')'
          }

          this.tipping_options = response.data.tipping_options
          if(this.payment_settings.allow_custom_tipping_options && this.payment_settings.allow_preset_tipping_options){
            this.tipping_options.push({id: 0, name: this.$t('book.customAmount'), value_type: 0, amount: 0})
          }
          const isDirectGameLink = this.$route.params.event && /^\d+$/.test(this.$route.params.event)
          if((this.payment_settings.gift_cards_enabled && !isDirectGameLink && this.$route.params.event !== 'gift-card') ||
            this.$route.params.event === 'gift-card' && this.payment_settings.gift_card_unique_link_enabled){
            this.is_gift_card = true
          } else if (this.$route.params.event === 'gift-card' && !this.payment_settings.gift_card_unique_link_enabled){
            this.notFound = true
          }
          this.payment_methods = response.data.payment_methods
          for(let n in this.payment_methods){
            if(this.payment_methods[n].name === 'Card'){
              this.payment_methods[n].display_name = this.$t('book.card')
            }
            else if(this.payment_methods[n].name === 'Gift card'){
              this.payment_methods[n].display_name = this.$tc('book.giftCard', 1)
            }
            else {
              this.payment_methods[n].display_name = this.payment_methods[n].name
            }
          }

          this.selectedPaymentOption = this.payment_methods[0]
          this.custom_fields = response.data.custom_fields
          this.custom_fields = _.orderBy(this.custom_fields, 'position')
          for(let n in this.custom_fields){
            if(this.custom_fields[n].external_links){
              this.custom_fields[n].external_links = JSON.parse(this.custom_fields[n].external_links)
            }

            if(this.custom_fields[n].policies){
              this.custom_fields[n].policies = JSON.parse(this.custom_fields[n].policies)
            }
            if(this.custom_fields[n].type === 3){
              this.custom_fields[n].dropdown_options = _.orderBy(JSON.parse(this.custom_fields[n].dropdown_options), 'id')
            }
          }
          if(this.locale.show_day_of_week){
            this.day_of_week = 'ddd, '
          }
          if(this.locale.google_tag_active && this.locale.google_tag_container_id){
            this.initializeGtm(this.locale.google_tag_container_id)
          }
          if(this.locale.pixel_active && this.locale.pixel_id){
            if (window === window.top) {
              this.addMetaPixel(this.locale.pixel_id)
            } else {
              this.startPixelHandshake()
            }
          }
          if(this.locale.ga4_active && this.locale.ga4_id){
            this.insertGoogleAnalyticsScript(this.locale.ga4_id)
          }

          if(this.payment_settings.payment_gateway_id === 4){
            this.loadPaystack()
          }
          //Stripe
          if(this.payment_settings.payment_gateway_id === 3){
            this.loadStripe()
          }
          if(this.payment_settings.payment_gateway_id === 2){
            this.squareAppId = this.payment_settings.api_name
            this.squareLocationId = this.payment_settings.api_location
            this.loadSquare(this.payment_settings.is_live)
          }
          //Locale
          this.country = _.find(this.countries, { code: this.locale.country })
          //Prefill address country from the venue's locale
          if(!this.user.country && this.country){
            this.user.country = this.country.code
          }
          //Fix year for el date picker
          this.locale.date_format = this.locale.date_format.replaceAll('Y', 'y')
          this.locale.date_format = this.locale.date_format.replaceAll('D', 'd')
        })
        .catch(err => {
          this.notFound = true
          console.log(err)
        })
    },
    async loadSquare(is_live){
      const script = document.createElement('script');
      if(is_live){
        script.src = 'https://web.squarecdn.com/v1/square.js'
      } else {
        script.src = 'https://sandbox.web.squarecdn.com/v1/square.js'
      }
      script.async = true;
      document.body.appendChild(script);
    },
    async payWithPaystack(bookings, custom_fields, gift_cards, subtotal) {
      let amount = this.due_now
      for(let n in this.applied_gift_cards){
        amount -= this.applied_gift_cards[n].remaining
      }
      // Inline v2 API. The merchant reference MUST be this.paystack_reference:
      // the pending payments row make-booking created is keyed on it, and both
      // handle-paystack-payment and paystack-webhook finalize by that key.
      // Metadata lets the webhook attribute the charge to this cart for
      // telemetry; the popup ignores it.
      const popup = new PaystackPop()
      const releaseHold = () => {
        this.disable_submit = false
        this.handlePaystackPayment(this.paystack_reference, 'payment_failed')
      }
      popup.newTransaction({
        key: this.payment_settings.api_name,
        email: this.user.email,
        amount: Math.round(Number(parseFloat(amount) + 'e2')),
        reference: this.paystack_reference,
        metadata: {
          otc: 1,
          otc_flow: 'booking_site',
          cart_hash: this.cart_id
        },
        onSuccess: (transaction) => {
          this.handlePaystackPayment(transaction.reference || this.paystack_reference, 'payment_succeeded')
        },
        onCancel: () => {
          releaseHold()
        },
        onError: (err) => {
          // Fires on a declined attempt while the popup stays open for the
          // customer to retry another card. Do NOT release the hold here: a
          // retry on the same reference can still succeed. A real close goes
          // through onCancel; a never-completed checkout is released by the
          // cleanup sweep.
          console.log(err)
        }
      })
      let offset = 0

      if(this.bss.clear_stale_carts){
        //5.Get time offset
        if(this.bss.cart_timeout_period === 0){
          offset = this.bss.cart_timeout_value * 60 * 1000
        } else if(this.bss.cart_timeout_period === 1){
          offset = this.bss.cart_timeout_value * 60 * 60 * 1000
        } else if(this.bss.cart_timeout_period === 2){
          offset = this.bss.cart_timeout_value * 24 * 60 * 60 * 1000
        }
        setTimeout(function() {
          window.location.reload();
        }, offset);
      }

    },
    async handlePaystackPayment(reference, status){
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/payment/paystack'
      let data = {
        status: status,
        paystack_reference: reference,
        cart_hash: this.cart_id
      }
      this.loading = true
      this.postPaystackStatusWithRetry(url, data, status)
        .then(response => {
          // Defensive guard: Paystack's onClose handler also calls this with
          // status='payment_failed'. If the backend ever returns 2xx without a valid
          // orderId for that case, don't advance to the confirmation tab with an
          // empty "Order reference: #" and a false "PAID" badge.
          if (!response.data || !response.data.orderId) {
            this.bookingSubmitted = false
            this.loading = false
            this.disable_submit = false
            this.prevent_submit = false
            swal({
              title: this.$t('book.swals.transactionFailed'),
              text: this.$t('book.swals.declinedCard'),
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#fd5d93',
              confirmButtonText: this.$t('book.swals.backToCart')
            })
            return
          }
          this.trackPixelEvent('Purchase', this.due_now, response.data.orderId)
          if(window.dataLayer) {
            window.dataLayer.push({
              event: 'purchase',
              currency: this.locale.currency,
              value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
            });
          }
          if(window.gtag) {
            if (window !== window.top) {
              let eventData = {
                eventType: 'purchase',
                eventValue: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) :  this.due_now,
                currency: this.locale.currency
              }
              this.$nextTick(() => {
                this.postMessageTrackingEvent(eventData)
              });
            } else {
              gtag("event", "purchase", {
                currency: this.locale.currency,
                value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) :  this.due_now
              })
            }
          }
          this.loading = false
          this.prevent_submit = true
          this.disable_submit = false
          this.order_number = response.data.orderId
          this.hash = response.data.hash
          this.timestamp = response.data.timestamp
          this.clearUTMFromStorage()
          this.addToCart(9)
          this.trackPixelEvent('Success', this.due_now, this.order_number)
          if(window.dataLayer) {
            window.dataLayer.push({
              event: 'success',
              currency: this.locale.currency,
              value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
            });
          }
          if(window.gtag) {
            if (window !== window.top) {
              let eventData = {
                eventType: 'success',
                eventValue: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now,
                currency: this.locale.currency
              }
              this.$nextTick(() => {
                this.postMessageTrackingEvent(eventData)
              });
            } else {
              gtag("event", "success", {
                currency: this.locale.currency,
                value: this.locale.send_full_cart_amount_to_ga === 1 ? this.roundToFixed(this.payment.amount, 2) : this.due_now
              })
            }
          }
          if(this.bss.auto_redirect){
            let time = parseInt(this.bss.redirect_delay) * 1000
            setTimeout(() => {
              // window.location.href = this.bss.redirect_url
              if (window !== window.top) {
                window.open(this.bss.redirect_url, '_blank');
              } else {
                window.location.href = this.bss.redirect_url
              }
            }, time)
          }
          this.addToCart(9, false, { event: 'confirmation_shown', order_number: this.order_number })
          swal(this.bookingSuccessSwal()).then((response)=> {
            this.$refs['wiz'].disableTabs();
            this.$refs['wiz'].tabIndex(4)
            if (window !== window.top) {
              this.$nextTick(() => {
                this.updateParentAboutPageChange()
              });
            }
            this.scrollToTop()
          })
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (status === 'payment_succeeded') {
            // Paystack captured the charge but OTC could not be told even after
            // retries. Keep submit locked so it cannot be paid twice; the
            // webhook finalizes the booking and sends the confirmation email.
            this.bookingSubmitted = false
            this.disable_submit = true
            this.prevent_submit = true
            swal({
              title: this.$t('book.swals.paymentVerifying'),
              text: this.$t('book.swals.paymentVerifyingText'),
              type: 'warning',
              showCancelButton: false
            })
          } else {
            // The charge did not complete (cancelled, declined, or the hold was
            // released). Tell the customer instead of silently losing the slot.
            this.bookingSubmitted = false
            this.disable_submit = false
            this.prevent_submit = false
            swal({
              title: this.$t('book.swals.transactionFailed'),
              text: this.$t('book.swals.declinedCard'),
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#fd5d93',
              confirmButtonText: this.$t('book.swals.backToCart')
            })
          }
        })
    },
    // A captured charge's callback is retried before anything is shown; a
    // cancel (payment_failed) is sent once. 401 is never retried.
    async postPaystackStatusWithRetry(url, data, status){
      const delays = status === 'payment_succeeded' ? [0, 2000, 4000, 6000] : [0]
      let lastErr = null
      for (let attempt = 0; attempt < delays.length; attempt++) {
        if (delays[attempt]) await new Promise(resolve => setTimeout(resolve, delays[attempt]))
        try {
          return await axios.post(url, data)
        } catch (err) {
          lastErr = err
          if (err.response && err.response.status == 401) break
        }
      }
      throw lastErr
    },
    async loadPaystack(){
      const script = document.createElement('script');
      script.src = 'https://js.paystack.co/v2/inline.js'
      script.async = true;
      document.body.appendChild(script);
    },
    async loadStripe(){
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      document.body.appendChild(script);
    },
    setCurrentDate(daysAhead = 0){
      let current = getNow()
      current.setDate(current.getDate() + daysAhead)
      this.currentDay = current.getFullYear() + '-' + ('0' + (current.getMonth()+1)).slice(-2) + '-' + ('0' + current.getDate()).slice(-2)
      this.currentTime = current.getHours() + ':' + current.getMinutes()
    },
    setCurrentDateFromSpecific(specificDate){
      // specificDate expected in 'yyyy-MM-dd' format
      const dateParts = specificDate.split('T')[0].split('-')
      this.currentDay = dateParts[0] + '-' + dateParts[1] + '-' + dateParts[2]
      let now = getNow()
      this.currentTime = now.getHours() + ':' + now.getMinutes()
    },
    updateParentAboutHeightChange() {
      this.$nextTick(() => {
        setTimeout(() => {
          const root = this.$refs.root;
          if (root) {
            let newHeight = root.scrollHeight;
            if (this.isEmbedded) {
              // Anchored dialogs live on document.body, outside #root. If one runs past
              // the end of the page the iframe must grow to show all of it.
              const dialog = document.querySelector('.modal.embedded-modal.show .modal-dialog');
              if (dialog) {
                const style = window.getComputedStyle(dialog);
                const modalBottom = dialog.offsetTop + dialog.offsetHeight
                  + (parseFloat(style.marginBottom) || 0);
                newHeight = Math.max(newHeight, Math.ceil(modalBottom));
              }
            }
            window.parent.postMessage({ action: "updateHeight", height: newHeight }, "*");
          }
        }, 50);
      });
    },
    updateParentAboutPageChange() {
      // Debounce scroll postMessage to prevent multiple rapid calls
      // especially problematic in iOS Safari iframes
      if (this.scrollDebounceTimer) {
        clearTimeout(this.scrollDebounceTimer);
      }

      this.scrollDebounceTimer = setTimeout(() => {
        window.parent.postMessage({action: 'scrollToTop'}, '*');
      }, 100);
    },
    // Embedded pages ask the parent whether its snippet relays pixel events.
    // Parents on the older analytics-only snippet never answer, so after a
    // short wait the pixel loads inside the frame as it always did and events
    // fire here. A late answer switches later events to the relay.
    startPixelHandshake(){
      this.pixelHandshakeListener = (e) => {
        if (e.source === window.parent && e.data && e.data.pixelHandshake === 'ready') {
          this.parentHandlesPixel = true
          this.stopPixelHandshake()
        }
      }
      window.addEventListener('message', this.pixelHandshakeListener)
      this.pixelHandshakeTimer = setTimeout(() => {
        if (!this.parentHandlesPixel && !window.fbq) {
          this.addMetaPixel(this.locale.pixel_id)
        }
      }, 1500)
      // Ask more than once: a parent that loads its pixel through a tag
      // manager may not have fbq yet when the first hello arrives. The
      // parent's reply is idempotent and the listener stops on the first.
      const sayHello = () => window.parent.postMessage({ pixelHandshake: 'hello' }, '*')
      sayHello()
      this.pixelHandshakeRetries = [setTimeout(sayHello, 500), setTimeout(sayHello, 1000)]
    },
    stopPixelHandshake(){
      if (this.pixelHandshakeListener) {
        window.removeEventListener('message', this.pixelHandshakeListener)
        this.pixelHandshakeListener = null
      }
      clearTimeout(this.pixelHandshakeTimer)
      for (const t of this.pixelHandshakeRetries || []) {
        clearTimeout(t)
      }
      this.pixelHandshakeRetries = []
    },
    // Value of what this add-to-cart step put in the cart: the add-ons just
    // chosen on the add-on substep, otherwise the booking or gift card itself.
    addedToCartValue(step, baseValue){
      if (step !== 'addon') {
        return baseValue
      }
      let addonsValue = 0
      for (let n in this.addons) {
        if (this.addons[n].quantity > 0) {
          addonsValue += parseFloat(this.addons[n].subtotal) || 0
        }
      }
      return Number(this.roundToFixed(addonsValue, 2))
    },
    // Meta pixel events. Embedded pages whose parent answered the handshake
    // relay to the parent so the venue's own pixel fires first party; the
    // parent snippet in group settings maps pixelEvent to fbq. Everything
    // else fires fbq here. Never both: Meta does not deduplicate two browser
    // events.
    trackPixelEvent(eventName, value, orderId){
      if (!this.locale || !this.locale.pixel_active || !this.locale.pixel_id) {
        return
      }
      // Purchase and Success report the cart total instead of the amount due
      // when the group's pixel setting asks for it, mirroring the GA setting.
      if ((eventName === 'Purchase' || eventName === 'Success') && Number(this.locale.send_full_cart_amount_to_pixel) === 1) {
        value = this.payment.amount
      }
      const numericValue = Number(this.roundToFixed(value, 2))
      if (window !== window.top && this.parentHandlesPixel) {
        const eventData = {
          pixelEvent: eventName,
          eventValue: numericValue,
          currency: this.locale.currency
        }
        if (orderId !== undefined && orderId !== null && orderId !== '') {
          eventData.orderId = String(orderId)
        }
        this.$nextTick(() => {
          this.postMessageTrackingEvent(eventData)
        })
        return
      }
      if (!window.fbq) {
        if (window === window.top) {
          return
        }
        // Event before the handshake settled: load the pixel in the frame now.
        this.stopPixelHandshake()
        this.addMetaPixel(this.locale.pixel_id)
      }
      fbq('track', eventName, { value: numericValue, currency: this.locale.currency })
    },
    postMessageTrackingEvent(event_data){
      window.parent.postMessage(event_data, '*');
    },
    handleBeforeUnload(event) {
      this.deleteCart();
    },
    handlePageHide(event) {
      // pagehide fallback for mobile browsers (especially iOS Safari) where beforeunload doesn't fire
      // Only delete cart if page is being unloaded (not cached for back/forward navigation)
      if (!event.persisted) {
        this.deleteCart();
      }
    },
    deleteCart() {
      // Release a booking held between wallet tap 1 and tap 2 if the customer
      // leaves the page. Must run before the bookingSubmitted guard below,
      // which is true while wallet-pending.
      if (this.wallet_pending_response && this.payment_intent_id) {
        let releaseCode = this.$route.params.company
        fetch(API_LOCATION + 'bookings/company-groups/' + releaseCode + '/payment/clear', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ payment_id: this.payment_intent_id }),
          keepalive: true
        });
      }

      // Don't delete cart if booking was successfully submitted
      if (this.bookingSubmitted) {
        return;
      }

      // Don't delete if cart_id is empty
      if (!this.cart_id) {
        return;
      }

      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/cart?hash=' + this.cart_id

      // Use fetch with keepalive
      fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        keepalive: true  // This is crucial for sending data on unload
      });
    },
    async handleCartExpiration() {
      // Preserve customer info before clearing
      const savedUser = { ...this.user }
      const expiredCartHash = this.cart_id

      // Clear cart and booking selections — slot may no longer be available
      this.cart = []
      this.promo_codes = []
      this.selectedBooking = {}
      this.selectedGame = {}
      this.show_calendar = false
      this.gift_card_select = false
      this.selectedPlayers = null
      this.selectedAddons = []
      this.pricing_categories = []
      this.price_settings = ''
      this.subtotal = 0
      this.number_of_players = 0
      this.book_entire_slot = false
      this.deposit = 0
      this.discount = 0
      this.cart_value_for_discount = 0

      // Create a new cart
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/cart?r=' + encodeURIComponent(document.referrer || '')
      if (this.utm_source) url += '&utm_source=' + encodeURIComponent(this.utm_source)
      if (this.utm_medium) url += '&utm_medium=' + encodeURIComponent(this.utm_medium)
      if (this.utm_campaign) url += '&utm_campaign=' + encodeURIComponent(this.utm_campaign)
      if (this.bss && this.bss.id) url += '&bss_id=' + this.bss.id

      try {
        const response = await axios.get(url)
        this.cart_id = response.data
      } catch (err) {
        console.log(err)
      }

      // Restore customer info
      this.user = savedUser

      // Diagnostic marker on the NEW cart: an expired-cart reset booted the
      // customer to the start. Distinguishes forced resets from customers
      // navigating back on their own (which never carries this event).
      this.addToCart(2, false, { event: 'cart_expired_reset', expired_cart: expiredCartHash })

      // Navigate back to game selection
      this.$refs['wiz'].tabIndex(0)
    },
    observeSizeChanges() {
      const root = this.$refs.root;
      if (!root) return;

      this.observer = new ResizeObserver(() => {
        this.updateParentAboutHeightChange(); // Send height update on resize
      });

      this.observer.observe(root);
    }
  },
  beforeDestroy(){
    this.stopPixelHandshake()
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    if(this.isMobile){
      window.removeEventListener('pagehide', this.handlePageHide);
    }
    window.removeEventListener("resize", this.updateParentAboutHeightChange);
    if (this.observer) this.observer.disconnect();
    if (this.scrollDebounceTimer) clearTimeout(this.scrollDebounceTimer);
    if (this._displayModeTimeout) clearTimeout(this._displayModeTimeout);
    if (this._bookingWs) this._bookingWs.destroy();
    if (this._countdownTimer) clearInterval(this._countdownTimer);
  },
  updated() {
    this.$nextTick(() => {
      setTimeout(this.updateParentAboutHeightChange, 100); // Delay to allow DOM updates
    });
  },
  mounted() {
    this._onWindowResize = () => { this.windowWidth = window.innerWidth }
    window.addEventListener('resize', this._onWindowResize)
    if (window !== window.top) {
      this.updateParentAboutHeightChange()
      window.addEventListener("resize", this.updateParentAboutHeightChange);
      this.observeSizeChanges()
    } else {
      this.$refs.root.style.minHeight = "100vh";
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    // Mobile browsers (especially iOS Safari) don't reliably fire beforeunload
    // Use pagehide as fallback for mobile devices
    if(this.isMobile){
      window.addEventListener('pagehide', this.handlePageHide);
      this.calendarOptions.initialView = 'timeGridDay'
    }
    this.setCurrentDate()
    this.getBss()

    // Tick the booking notice countdown once a second (OTC-1767)
    this._countdownTimer = setInterval(() => { this.nowTick = getNow().getTime() }, 1000)

    if(this.$route.params.event === 'gift-card'){
      this.gift_card_link = true
    }
    this.getSchedules(1)
  }
}
</script>

<style scoped>

/* Event details drawn over the card image. The block keeps its usual place while it fits above
   the time slots (three lines); with more lines (several ratings) it grows upward over the image
   and carries the title with it, so it never runs into the time slots. */
.details-over-image {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -70px;
  min-height: 80px;
}

.details-over-image__title {
  position: absolute;
  left: 0;
  right: -15px;
  bottom: 100%;
  margin: 0 0 10px;
}

.booking-notice-banner{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
  margin: 16px auto;
  padding: 10px 16px;
  border: 1px solid;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.35;
}
.booking-notice-banner i{
  font-size: 1.1rem;
  flex-shrink: 0;
}
.fade-enter-active, .fade-leave-active{ transition: opacity .3s ease; }
.fade-enter, .fade-leave-to{ opacity: 0; }

.booking-week-cal{
  position: relative;
}
/* Sits over the week grid while slots load; background color comes from the
   site's bss setting inline. z-index clears FullCalendar's sticky header (3).
   The grid is much taller than the viewport, so flex-centering would park the
   spinner below the fold; sticky keeps it in the visible part of the screen
   for as long as the overlay is in view. */
.cal-loading-overlay{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 0.85;
}
/* Offset from the calendar's own top edge, not the viewport: an ancestor
   transform (transition wrapper) turns fixed/sticky positioning into
   "top of overlay", which parked the spinner on the day-header row. ~30vh
   below the grid's top lands mid-screen for the visible part of the grid. */
.cal-loading-overlay .custom-spinner{
  margin-top: 30vh;
}

.button-wide{
  width: 95%;
}
.no-upper-margin{
  margin-top: -15px;
}

.game-img{
  display: inline-flex;
  align-items: flex-end;
  justify-content: right;
  border-radius: 50%;
  height: 50px;
  width: 50px;
}

.empty-bookings{
  text-align: center;
  padding: -10px 5px -10px;
  border: 1px solid #e44cc4;
  border-radius: .1875rem;
  /*margin: 0px 0 -10px;*/
  min-height: 90px;
}
.empty-bookings i{
  font-size: 1em;
  margin: 0px 0 -10px;
}

.empty-bookings p{
  padding: 7px;
  /*margin-top: 30px;*/
  font-size: 0.8em;
}
.el-date-editor.el-input .el-input__inner {
  cursor: crosshair !important;
}

html, body {
  height: 100%; /* Ensure full-page height */
  margin: 0;
  padding: 0;
}

.root-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Stretch to full height */
}

/* If inside an iframe, reset min-height to prevent forced stretching */
@media (display-mode: browser) {
  .root-container {
    min-height: auto; /* Reset min-height when iframed */
  }
}

.payment-methods-buttons {
  width: 100%;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.payment-btn {
  padding: 10px 20px;
  border: 1.5px solid;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 120px;
}

.payment-btn:hover:not(.active) {
  opacity: 0.8;
  transform: translateY(-2px);
}

.payment-btn.active {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.deposit-info-text {
  font-size: 13px;
  opacity: 0.9;
  margin-bottom: 10px;
}

.deposit-required-line {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
}

.deposit-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.deposit-card {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 8px;
  border: 1.5px solid;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.deposit-card:hover:not(.active) {
  opacity: 0.8;
}

.deposit-card.active {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.deposit-card-title {
  font-weight: 600;
  font-size: 14px;
}

.deposit-card-amount {
  margin-left: auto;
  font-weight: 700;
  font-size: 16px;
}

.deposit-card-sub {
  width: 100%;
  font-size: 12px;
  opacity: 0.85;
}

.payment-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive - stack buttons on smaller screens */
@media (max-width: 576px) {
  .button-group {
    flex-direction: column;
  }

  .payment-btn {
    width: 100%;
  }
}

.slot-custom-badge {
  position: absolute;
  top: -8px;
  right: 4px;
  z-index: 200;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 10px;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  text-transform: none;
  letter-spacing: 0;
}

.slot-custom-text {
  display: block;
  width: 100%;
  font-size: 70%;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  line-height: 1.25;
  margin-top: 2px;
  word-break: normal;
  overflow-wrap: break-word;
}

.slot-content-stack {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
  align-items: center;
}

.slot-content-stack > * {
  display: block;
  width: 100%;
  text-align: center;
}

.slot-custom-text-inline {
  text-transform: none;
  letter-spacing: 0;
}

.game-info-trigger {
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 110;
  background: none;
  border: none;
  padding: 6px;
  min-width: 32px;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6));
}

.game-info-trigger--text {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  filter: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  max-width: calc(100% - 16px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card.event-card-elevated {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* Cards in a row were always equalized by flex stretch (row → inline-flex
   column wrapper → card); the old JS filler rows only padded the CONTENT to
   a page-global max slot count, which leaked cascade-day heights onto other
   days (OTC-2591). Instead, the body lays out as a flex column so the
   "see more times" row can pin to the card bottom via margin-top: auto. */
.card.event-card-elevated ::v-deep .card-body {
  display: flex;
  flex-direction: column;
}

.card.event-card-elevated .see-more-times-row {
  margin-top: auto;
  padding-top: 0.5rem;
}

.game-info-flip {
  perspective: 1600px;
  /* paint above the card-body content that overlaps the image bottom via
     negative margins, so the trigger's full hit area stays clickable */
  z-index: 5;
}

.game-info-flip.is-flipped {
  z-index: 110;
}

.game-info-flip__inner {
  position: relative;
  width: 100%;
  height: 250px;
  transform-style: preserve-3d;
  transition: transform 0.6s cubic-bezier(0.45, 0.05, 0.2, 1);
  will-change: transform;
}

.game-info-flip.is-flipped .game-info-flip__inner {
  transform: rotateY(180deg);
}

.game-info-flip__front,
.game-info-flip__back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 250px;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  /* Firefox doesn't reliably honor backface-visibility (scrollable/composited
     faces), so also swap visibility at the rotation midpoint */
  transition: visibility 0s linear 0.3s;
}

.game-info-flip__front {
  visibility: visible;
}

.game-info-flip.is-flipped .game-info-flip__front {
  visibility: hidden;
}

.game-info-flip__back {
  transform: rotateY(180deg);
  visibility: hidden;
}

.game-info-flip.is-flipped .game-info-flip__back {
  visibility: visible;
}

/* hidden faces must not eat taps meant for the visible face */
.game-info-flip:not(.is-flipped) .game-info-flip__back {
  pointer-events: none;
}

.game-info-flip.is-flipped .game-info-flip__front {
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .game-info-flip__inner {
    transition: none;
  }
  .game-info-flip__front,
  .game-info-flip__back {
    transition: none;
  }
}

.game-info-panel {
  border-radius: 5px;
  padding: 14px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  text-align: left;
}

.game-info-panel__close {
  position: absolute;
  top: 2px;
  right: 6px;
  z-index: 1;
  background: none;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  padding: 4px 8px;
  cursor: pointer;
  opacity: 0.85;
}

.game-info-panel__content {
  font-size: 0.85rem;
  line-height: 1.5;
  padding-right: 18px;
  word-break: normal;
  overflow-wrap: break-word;
}

.game-info-panel__content ::v-deep img {
  max-width: 100%;
  height: auto;
}

.game-info-panel__content ::v-deep p:last-child {
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .slot-custom-badge {
    font-size: 9px;
    padding: 2px 6px;
    top: -6px;
  }
}
</style>

<style>
/* Embedded booking page only: the popup is placed at the visible part of the page instead
   of fixed and centered in the (page-sized) iframe. The overlay dims the whole page and is
   a plain block, not a scroll container, so touch scrolling passes through to the host
   page like the rest of the embed, and a tap on the dim area closes the popup. */
.modal-open .modal.embedded-modal,
.modal.embedded-modal,
.modal.embedded-modal.show {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  bottom: auto;
  height: auto;
  min-height: 100%;
  overflow: visible;
}
.modal.embedded-modal .modal-dialog {
  min-height: 0;
  margin: 0 auto 1rem;
}
.modal.embedded-modal .modal-dialog::before {
  display: none;
}
/* The theme slides a shown dialog down by 30% of its own height (10% on phones). For the
   long policy and option popups that pushes the top of the text off screen, and embedded
   popups must sit exactly where they are placed (transforms are also invisible to the
   offset-based height report sent to the host page). */
.modal.content-modal.show .modal-dialog,
.modal.content-modal.show .modal-dialog.modal-notice {
  transform: none;
}
</style>
